var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeashell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "seashell",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 431,
    height: 435.725,
    viewBox: "0 0 431 435.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 431,
    height: 435.725,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M226.59,435.725c-33.784,0-69.7-8.32-94.221-22.427-17.123-9.854-28.959-22.515-41.49-35.921-4.966-5.311-10.1-10.8-15.731-16.3-7.041-6.868-14.651-12.6-22.011-18.134-12.507-9.412-24.321-18.3-33.216-32.089C7.292,291.278,2.744,260.123.42,238.393h0C-2.39,212.095,9.5,183.819,19.059,161.1q1.169-2.78,2.28-5.443c3.182-7.644,5.68-15.3,8.1-22.694,4.96-15.2,9.645-29.563,19.726-43.84C61.68,71.388,78.368,61.143,94.506,51.236c6.858-4.209,13.948-8.564,20.507-13.393l4.046-2.988c20.525-15.192,41.746-30.9,73.4-34.285,25.966-2.773,49.152,5.1,69.615,12.038l.806.274c18.51,6.279,30.6,17.89,43.4,30.182a266.131,266.131,0,0,0,21.35,19.022c8.361,6.491,18.016,12.124,28.238,18.087,16.342,9.533,33.24,19.391,45.157,33.368,19.663,23.059,25.706,47.3,29.089,78.934,2.923,27.362-1.306,50.551-14.139,77.539-4.588,9.644-7.792,20.063-10.89,30.142-4.7,15.3-9.572,31.134-19.364,44.348-15.789,21.309-35.35,35.738-54.267,49.687q-3.481,2.567-6.967,5.153c-22.324,16.628-45.074,31.843-77.828,35.343a189.084,189.084,0,0,1-20.07,1.037",
    transform: "translate(-2.633 0)",
    fill: "#fc8363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M124.393,134.755s28.171,12.222,55.6,3.707,47-23.979,43.723-34.541-28.171-12.224-55.6-3.709-43.721,34.543-43.721,34.543m46.886-24.162c25.6-7.948,47.579-10.455,49.087-5.6s-18.025,15.238-43.626,23.186a138.109,138.109,0,0,1-49.087,5.6,138.1,138.1,0,0,1,43.626-23.186",
    transform: "translate(91.322 71.581)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M124.393,134.755s28.171,12.222,55.6,3.707,47-23.979,43.723-34.541-28.171-12.224-55.6-3.709-43.721,34.543-43.721,34.543m46.886-24.162c25.6-7.948,47.579-10.455,49.087-5.6s-18.025,15.238-43.626,23.186a138.109,138.109,0,0,1-49.087,5.6,138.1,138.1,0,0,1,43.626-23.186",
    transform: "translate(91.322 71.581)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M150.615,102.717c.3-.06.07-.428.091-.514-.455.249-.046.614-.091.514",
    transform: "translate(111.032 77.194)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M148.268,104l.025-.193-.541.655Z",
    transform: "translate(108.964 78.403)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M145.575,105.413c.672.513,1.527-.7,2.391-.757l.186.105.146-.672a11.569,11.569,0,0,1-2.723,1.324",
    transform: "translate(107.32 78.618)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M143.935,104.645c.251.2-.4.432.57-.146a.647.647,0,0,1-.125-.025,3.565,3.565,0,0,1-.446.17",
    transform: "translate(106.082 78.91)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M144.235,104.525c.448-.211-.388-.091,0,0",
    transform: "translate(106.228 78.859)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M143.216,105.313l.5-.481c-.191-.1-.741.093-.59-.1-.562.384-.367.481.09.583",
    transform: "translate(105.211 79.103)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M142.827,105.578l.265-.228c-.081-.04-.174-.03-.265.228",
    transform: "translate(105.245 79.557)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M143.544,105.069l-.565.481c.133.068.235.279.269-.2.032.216.077-.025.3-.281",
    transform: "translate(105.36 79.359)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M143.538,105.158c.4,0,.865-.088.365.391,1.1-.569.739-.965-.365-.391",
    transform: "translate(105.782 79.214)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M145.613,105.436l.523.021.3-.37c-.149.184-.937.144-.823.349",
    transform: "translate(107.34 79.372)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M140.844,105.825c.03.154.374.277.5.434l.36-.36c-.265.009-.73.118-.858-.074",
    transform: "translate(103.747 79.93)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M141.359,106.072l-.537.537c.593-.24.646-.4.537-.537",
    transform: "translate(103.73 80.116)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M143.039,106.33l.855-.964c-.355.356-.714.693-1.057,1.064Z",
    transform: "translate(105.252 79.583)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M139.521,106.711l.209-.5-.413.8Z",
    transform: "translate(102.594 80.222)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M139.083,107.232c.137-.395-.6-.256-.391-.558a2.968,2.968,0,0,0-.913,1.062,1.834,1.834,0,0,1,1.3-.5",
    transform: "translate(101.432 80.571)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M137.546,107.872a4,4,0,0,0,.409-.593,2,2,0,0,0-.409.593",
    transform: "translate(101.256 81.028)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M140.478,106.709a.79.79,0,0,0-.7-.14l.441.26c.077-.035.165-.077.255-.119",
    transform: "translate(102.946 80.473)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M140.287,106.715l-.014-.009-.555.251.569-.242",
    transform: "translate(102.896 80.595)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M140.243,106.621l-.065.03c.046.026.065.032.065-.03",
    transform: "translate(103.244 80.531)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M142.114,106.158c-.281.393-.958.99-.042.971.147-.391-.377-.379.042-.971",
    transform: "translate(104.324 80.181)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M140.526,107.072l.727-.232c-.061-.1-.258-.188-.119-.383Z",
    transform: "translate(103.507 80.408)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M140.371,107.1l.272-.288-.267.093Z",
    transform: "translate(103.39 80.672)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M138.677,107.506a2.634,2.634,0,0,1-.857.716,8.631,8.631,0,0,0,1.216-.491c-.007-.147.049-.446-.36-.225",
    transform: "translate(101.463 81.14)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M139.184,107.121l-.054.054c.056.012.095.007.054-.054",
    transform: "translate(102.452 80.909)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M135.826,108.977l.093.037-.023-.072Z",
    transform: "translate(99.957 82.284)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M138.615,107.817a.766.766,0,0,0,.562-.453,4.752,4.752,0,0,1-.664.414c0,.067.018.1.1.039",
    transform: "translate(101.986 81.092)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M137.04,108.058a4.181,4.181,0,0,0,.609-.06c-.209-.042-.609-.067-.609.06",
    transform: "translate(100.874 81.546)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M139.07,107.143a.241.241,0,0,1,.035-.039c-.137-.035-.105,0-.035.039",
    transform: "translate(102.362 80.885)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M139.16,107.12a1.767,1.767,0,0,0-.269.427,2.6,2.6,0,0,0,.421-.37.532.532,0,0,1-.153-.056",
    transform: "translate(102.272 80.908)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M136.4,111.939c-.149-.372.4-1.113,1.243-1.1.479-.611-.562-1.534-1.471-1.854.065.161.142.3-.39.878.335.058,1.683-.377,1.315.249-.751.667-.767.277-1.287.332.6.23-.725,1.246-.174,1.771l.614-.648c.07.091-.109.4.149.374",
    transform: "translate(99.707 82.315)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M137.161,108.692l.248-.19a2.912,2.912,0,0,1-1.2.033c-.353.423-.372.606-.337.739.444-.24.9-.463,1.355-.685Z",
    transform: "translate(99.982 81.952)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M137.96,108.315c-.009.5-.569,1.008.051,1.206.776-.451.383-.616.769-1.037-1.23.783.256-.411-.786-.13a4.433,4.433,0,0,1,.641-.474,6.328,6.328,0,0,1-.758.183l.042.007.005,0,0,.007c.081.018.116.037.039.042a.139.139,0,0,1-.023.023.5.5,0,0,1,.018.176c-.414.121-.111-.068-.018-.176a.44.44,0,0,0-.016-.065l-.007,0-1.176.9a5.655,5.655,0,0,0,1.218-.656",
    transform: "translate(100.649 81.482)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M141.754,107.407a.119.119,0,0,1-.084-.072c-.063.088-.079.135.084.072",
    transform: "translate(104.336 81.07)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M141.8,107.662c.07-.1.076-.291.4-.395.325-.005.088.19.163.311.135-.19.521-.583-.153-.5l-.07.095c-.592.111-1.506-.063-1.438-.158a3,3,0,0,0,1.094.649",
    transform: "translate(103.64 80.827)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M139.814,107.8l-.983.73.72.058-.13-.186c.653-.228.395-.409.393-.6",
    transform: "translate(102.227 81.421)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M135.859,109.1l-.084-.479-.293.913Z",
    transform: "translate(99.697 82.042)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M135.1,109.531l-.147-.374-.244.416Z",
    transform: "translate(99.111 82.446)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M163.5,109.2l.283-.232a1.364,1.364,0,0,0-.283.232",
    transform: "translate(120.858 82.305)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M162.156,109.611l.012.205c.07-.142.086-.233-.012-.205",
    transform: "translate(119.844 82.786)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M136.748,118.414c.544.341,1.171.858,1.074.42l-.191-.421a1.4,1.4,0,0,1-.883,0",
    transform: "translate(100.653 89.437)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M151.519,114.606l-.179-.093c-.083.176-.16.337-.232.486l.411-.393",
    transform: "translate(111.499 86.492)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M151.277,113.521l.713.088a2.5,2.5,0,0,0-.713-.088",
    transform: "translate(111.627 85.742)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M170.582,105.95l.156-.576c-.556.283-.211.358-.156.576",
    transform: "translate(126.09 79.589)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M126.2,115.939a14.394,14.394,0,0,0-1.785,1.109c1.144-.611,2.327-1.076,1.785-1.109",
    transform: "translate(91.34 87.569)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M163.947,111.919c.174-.153.228-.27.186-.358-.181.151-.269.276-.186.358",
    transform: "translate(121.173 84.262)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M123.583,117.783c.176-.1.326-.183.5-.277a4.719,4.719,0,0,1,.981-.936c-.839.439-1.654.964-1.481,1.213",
    transform: "translate(90.692 88.045)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M161.905,102.374a1.219,1.219,0,0,1-.121-.026c0,.06.051.053.121.026",
    transform: "translate(119.563 77.303)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M153.131,102.126a4.729,4.729,0,0,1,.574-.2,1.471,1.471,0,0,0-.574.2",
    transform: "translate(113.027 76.982)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M131.765,111.2c.269-.205.019-.07,0,0",
    transform: "translate(96.89 83.91)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M133.084,111.5a.271.271,0,0,0,0,.249.343.343,0,0,1,0-.249",
    transform: "translate(97.862 84.212)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M127.287,117.052l.025,0c.121-.088.1-.072-.025,0",
    transform: "translate(93.507 88.367)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M132.254,111.1a2.274,2.274,0,0,0-.432.121,2.211,2.211,0,0,0,.432-.121",
    transform: "translate(96.933 83.912)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M131.973,111.1l.27-.123c0-.084-.06-.1-.27.123",
    transform: "translate(97.047 83.775)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M131.547,111.429a2.558,2.558,0,0,1,.483-.255c-.07.011-.107,0-.1-.018l-.383.272",
    transform: "translate(96.725 83.957)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M176.667,100.1c-.011-.016-.026-.026-.039-.047-.272.142-.165.13.039.047",
    transform: "translate(130.652 75.57)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M141.392,115.37c-.014.007-.021.021-.033.026l.049.01Z",
    transform: "translate(104.136 87.139)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M142.486,115.1c-.42.607-.711.579-1.1.518l.546,1.194Z",
    transform: "translate(104.157 86.931)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M200.049,115.111l-.906-.033c.649-.985,1.388-1.064.467-1.264.442,1.308-2.859,1.373-2.442,2.673l-.611-.061c.147-.046.14-.13.288-.176-1.223-.209-.349,1.211-1.687,1.541-.481.077-.862.014-.621-.256l-.858.7c-.3.09-.312-.16-.019-.248l-1.464.683,0-.042a6.423,6.423,0,0,1-.7,1c-.453-.037.14-.209-.018-.33l-.721.623c-.467-.207.111-.781.7-.955-1.259-.979-.574.581-2.54.462l.732-.455c-.776-.537-1.294-.047-2.35-.184.293.163,2.2.5,1.41,1.148a1.311,1.311,0,0,0-1.046.506c-.17-.456-.607-.167-1.2.068l-.172-.62c-.59.4-.43.692-.718,1.1a1.219,1.219,0,0,1-1.369-.562c-1.2.295,1.065.483-.277,1.064a5.253,5.253,0,0,0-2.7,1.32c-.751.014,0-.412-.305-.507l-.446.686c-.153.037-.153-.13-.153-.212-.449.355.156.628-.6,1.05-.005.734-1.966-.444-2.724.6-.3-.105,0-.412-.144-.628a8.72,8.72,0,0,0-1.99,1.711l-1.073-.132c.832.258.088,1.083-.6,1.747a5.4,5.4,0,0,0,.757.349c-.395.242-.8.446-1.2.667-.183-.065-.107-.311.037-.621a2.619,2.619,0,0,0-.2.207c-.521-.118-.372-.535-.133-.964l.562.27a1.676,1.676,0,0,0,.239-1.3.915.915,0,0,1-.372.277c.056-.123.084-.228.03-.281s-.158.116-.325.325l-.469-.621v.291l-1.768-.028c-1.013,1-1.818,2.3-3.693,2.966.37-.614-.074-.862-.175-1.476.656.528,1.425-.562,2.429-.671-.527.058-.479-.26-.372-.393-.537.333-1.083.637-1.629.958-.065-.507-.453-.3-.953-.409.551.915-1.18.929-1.84,1.381-.107-.323,0-.7.888-.8-1.1-.541-1.027,1.422-2.1.946.214-.044.339-.014.393-.2-.449.381-1.724.358-1.483.018l.212-.042a15.6,15.6,0,0,0-2.73.52c-.92.249-1.675.6-1.725,1.036a6.057,6.057,0,0,1,.111-1.23c-.718,1.067-1.452,2.143-2.206,3.207.137-.758-.943-2.382.2-2.947a2.2,2.2,0,0,0-1.481.205c.246.079.709.992.395,1.094-.974-.716-.664-.367-1.82-.943.365.119.1,1.306-.463,1.331.07-.181-.16-1.125.03-1.267-.421.421-.844.86-1.274,1.269.33-.232-.028-.96-.365-1.253.163.209-1.194.077-1.553.219l.607.214c-1.573-.053-1.42,1.734-2.995,1.759.176-.244.372-1.46-.425-1.557-.321.59-1.45,2.887-2.844,3.381l-.283-.321-1.064.412a27.664,27.664,0,0,1,3.393-3.569c-.6-.228-.183-.381-1.055-.3-.323-.293.451-.5.706-.53-.678-.028-1.355-.054-2.033-.1.118.672-1.529.728-1.436,1.288l2.187-.774c.125.671-1.2,1.961-2.672,1.89-.376-.256.247-1.213.209-1.438a.721.721,0,0,1-.29.176c-.119.054-.358.107-.414.137-.188.063-.384.077-.4-.005a3.425,3.425,0,0,0,.355-.365c-.17-.126-.335.1-.583.279-.23.177-.558.307-.621-.014-.077-.021-.054-.239-.011-.4s.081-.272-.111-.072c-.535.781-1.98,3.189-2.945,3.735a6.6,6.6,0,0,1-.839-.453c-.353-.232-.591-.493-.541-.678.095-.286.874-.656,1.5-1a4.982,4.982,0,0,0,1.394-.95,4.509,4.509,0,0,1-.937.483c0-.163.9-.57.341-.5-1.162.681-.881-.084-1.166.57-.881.177-.318-.151-.953-.149a12.8,12.8,0,0,1-2.338.907,14.627,14.627,0,0,1-2.8.611,4.779,4.779,0,0,0,.9-.435,3.448,3.448,0,0,1-1.125-.276c.806-.513,1.536-.934,2.127-1.39a8.5,8.5,0,0,1,1.985-.613c-.179-.028-.611-.016-.356-.23,1.843-.6-.374.407,1.655-.169-.916.154-.635-.262-.7-.53a1.572,1.572,0,0,0-1.134.491.334.334,0,0,0,.082.462,4.193,4.193,0,0,1-2.215.07c-.362-.186-.337-.586.075-1.153.844-.92,1.4-.374,1.408-.535,1.188-.762,1.13-1.169,1.223-1.625.056-.439.311-.918,1.715-1.5.674-.133.878.051,1.023.253s.216.432.456.5c-.637.671-1.687.716-2.3,1.188l1.043-.423a1.5,1.5,0,0,1-.936.851,8.773,8.773,0,0,0,2.266-1.213c.444-.286.916-.593,1.373-.858a7.972,7.972,0,0,1,1.376-.639c.162-.318.511-.764.183-.811l-.425.36c-.662-.093.551-1.067-.147-.864a3.878,3.878,0,0,1,1.94-1.848l.49.423c-.112-.142-.778.042-.929.355.232-.46,1.8-.119,1.792-1.057l-.848.016c.479-.646.93-1.711,1.847-2-.678-.311-.153.163-1.088-.112.944.463-2.07,1.211-.8,1.529-1.011-.353-1.192.309-2.324.177.132.158.474.16-.244.5a.911.911,0,0,1-.049.244l-.053.016.049,0c-.012.044-.012.051.018,0a.886.886,0,0,1,.5.047c-.081.606-1.136,1.262-1.36,1.69-.441.169.039-.3-.291-.346l-.333.641c-.154-.453-1.892.372-.672-.774l-1.3.855a7.9,7.9,0,0,0-2.7,1.646c-.772.42-.907,1.292-.841.79l-1.553,1.5h-.19a18.388,18.388,0,0,0-2.285,2.11,14.293,14.293,0,0,1-3.456,2.389,6.794,6.794,0,0,1-1.852,1.687l.014,0-.713.328a7.556,7.556,0,0,1,1.747.248,3.837,3.837,0,0,0,1.736.039c-.535.479.665.651,2.134.72.748.019,1.524.042,2.238.061l.972.042a7.861,7.861,0,0,1,.807.06l.676-.486a24.578,24.578,0,0,0,4.313-.205l.174-.448a5.924,5.924,0,0,1,2.313,0c.43.058.915.126,1.4.176a5.207,5.207,0,0,0,1.008.042c-.088.176-.432.142-.678.046,1.653.967,3.379-.85,4.869-.207a.991.991,0,0,1,.886-.044.179.179,0,0,0-.088.028.884.884,0,0,0,.149,0c.167.068.339.149.523.211a1.719,1.719,0,0,0-.442-.216,4.646,4.646,0,0,0,1.113-.255l.212.469c.033-.007.06-.014.1-.021.423.144.311-.256.067-.6a2.118,2.118,0,0,0,.527-.335c.395.751,1.069-.353,1.594.441.248-.414,2.066-.5,2.2-1.383.026.111.154.149-.068.181a1.833,1.833,0,0,0,1.331-.193l.265.591.911-.934c.655.3.937.474.388,1.03,1.376-.925,1.159-.437,2.3-1.325l-.005.4c.444-.077,1.076-.7,1.392-.414,1.109.588,4.922-.671,7.585-.551-.732-1.046,1.288.27,1.2-.639.207.24.6.319.235.641,1.237-.523,2.041-.032,2.756-.981.212.235-.181.463-.012.592.091-.084.355-.335.528-.207s-.133.272-.311.439c1.313-.369,1.234-1.229,1.13-2.029.755.2,1.08.083,1.415-.563.295.188.748.342-.033.665.462-.093,2.877-.428,2.742-1.057.188.114.646-.137.742-.242a12.49,12.49,0,0,0,2.1-.592l-.3-.014c.156-.862.764-.423,1.525-.762l0,.082c1.984-.054.7-.507,2.682-.484l-.249-.425c-.161-1.039,1.771.051,2.679-.678l-.462-.133c.444-.527,2.033.788,2.645.711.154.042-.147.205-.3.328,1.69.058-.016-.662,1.037-1.192.319.247.028.909.8.7.469.13,1.773-1.82,3.007-1.583-.314-.165-.627-.328-.188-.7.742-.384,2.464.13,2.865-.925a.28.28,0,0,1,.214.137c.518-.43,1.8-1.092,1.98-1.657,1.187,1.329,3.337-2.264,3.921-.855l1.766-.865.018.165a2.416,2.416,0,0,0,1.687-1.464c.307-.026.176.193.188.276a3.975,3.975,0,0,0,2.981-2l.365.376c.239-.441,2.744-.5,4.064-1.9a.344.344,0,0,1-.067.291,8.7,8.7,0,0,1,3.012-1.459c1.018-.4,1.827-.881,1.634-1.85.3-.372.586-.762.869-1.148-1.511.906-.244-.793-1-.621.488-.463,1.74-.6,1.127-.018l-.161,0c.321.972,1.94-1.078,2.308-.581a16.494,16.494,0,0,0,2.35-2.459,5.525,5.525,0,0,0,1.239-3.042,3.65,3.65,0,0,0-1.259-2.905,6.781,6.781,0,0,0-3.009-1.55,5.553,5.553,0,0,1,.149.79c-.47-.118-.946-.291-1.424-.362-.33-.219-.414-.662.718-.418-.223-.274-.751-.253-1.178-.168a1,1,0,0,0-.7.381c-1.618-.455.734-.79.235-.857l-.707-.012.151.1c-.6.24-.658.567-1.648.476-.62-.163-.309-.46-.556-.493,0-.053-.081-.079-.379-.028-.491-.037-.971-.039-1.457-.056l.586.572c-.634.293-1.345-.009-.672.637-.49-.5-1.827-.537-3.1-.449a16.017,16.017,0,0,1-2.786.181,5.792,5.792,0,0,1-2.735.7c.277.083.52.707-.395.755.144-1.387-1.739-.344-2.622-1.18.753.521-2.552.586-1.374,1.313-.771.019-.13-.488-.757-.7-1.7.83-4.013.4-6.184,1.039,0,.181.427.365.011.725l-1.346-.611c-.416.183-.179,1.08-1.1.663.144.119.358.3.082.421-4.5.135-8.524,2.807-13.247,2.482.676.165.3.307-.142.448.311-.005.114.42.239.634l-1.978-.111c-.137.728-1.9.623-1.9,1.287l.53-.281c-.528.946,1.532,1.276,1.7,2.233.6-1.064,2.55.556,3.584-1,.356.1-.174.372.049.541.233-.495.632-.7,1.46-.739l-.06.123c2.164-.7,3.21-.562,5.743-.922l-.3-.416a2.025,2.025,0,0,1,.971.1c.437-.855-1.5.335-1.139-.576.937.755,3.762-.911,4.492.06.82-.183-.365-.481.456-.664l.283.24.123-.423a.889.889,0,0,1,.979.488,1.844,1.844,0,0,0-.49.2c.772.191,1.936-.549,2.2-.486l-.827-.009c2.184-.76,5-.913,7.067-1.878l-.2-.193c1.6-.693,1.376.018,3.174-.455l-.056.063a2.408,2.408,0,0,1,1.315-.5c-.427.325.939.384.37.758,1.748-.671.844-.462,1.948-1.434l.318.341a1.765,1.765,0,0,1,1.3-.748c-.725.384.639.513-.163,1.009,1.969.642,2.8-1.048,3.73.112.837-1.074-1.68-.5-1.2-.735-.437-.311.69-.82,1.306-.732.625,0,1.094,1.273,2.579,1.276-.149-.007-.16.07-.309.063.551.265,1.109-.323,1.759.14.421-.585.85.119,1.044-.662-.456.025-.908.023-1.371.068.765-.161,1.7-1.022,2.615-.365a3.916,3.916,0,0,1-.751.356c.184.26.569-.049.718.232a.728.728,0,0,1-.8.309,2.723,2.723,0,0,0-.481-.018,1.538,1.538,0,0,0-.716.2.468.468,0,0,0,.383.1,1.4,1.4,0,0,0,.393-.077c.174-.054.274-.053.067.353.276-.518.511-.439.669-.332.188.118.277.239.89.009l-.441.376c.126-.044.484-.14.611-.049a5.035,5.035,0,0,0-.809.353c.379-.142.432.053.349.235-.079.2-.251.356-.054.423-.06-.237.054-.326.3-.427s.583-.154.674-.4c.391.119.441.351.349.507a1.21,1.21,0,0,1-.577.395c-.518.221-1.05.312-1.088.57-.037-.056.528-.27.718-.1a1.217,1.217,0,0,1-.846.221c-.084.172.018.237.2.267s.43.014.463.193c-.356-.053-.334.014-.281.183a.939.939,0,0,1,.047.637l-.334-.353c-1.388.757.351,1.055-1.087,1.694l.1-.927-.52.62-.2-.541a2.306,2.306,0,0,1-1.538,1.264c.355.169.4.8-.249,1.234-.606.04,0-.548-.892.1.053-.391.074-.855.716-.732-.042-.158.037-.388-.007-.546-.648.026-1.227.693-1.566.9a1.1,1.1,0,0,1,.423-.125l-1.022,1.4c-.312-.033-.207-.256-.112-.481-.251.209-.339.511-.734.785-.086-.4-.312-.744.177-1.236l-1.1,1.129c-.174-.1-.914-.04-.809-.262-.843.2-1.473,1.653-2.622,1.887a.714.714,0,0,1-.281.37c-.993.4-2.045.369-2.961,1.39l-.946-.339c-.832.562,1.255.4-.135,1.334-.978.686-.648-.37-1.1-.381-.379.565-1.023,1.634-2.242,1.534.276-.263.572-.279.857-.46m-11.311,4.829c.19-.174.527-.637.79-.428-.063.614-.353.442-.79.428M171.2,126.657c.133-.2.42-.186.767-.081a1.3,1.3,0,0,1-.767.081m-35.987-2.638a.334.334,0,0,0-.016.037c-.879.372-.56.244.016-.037m1.6-.836c.1-.149.047-.2-.058-.205-.023.165-.335.386-.728.613.2.016.439-.04.786-.407M214.4,98.2l.225.132c-.516.13-.37.007-.225-.132",
    transform: "translate(89.82 73.972)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M151.281,113.644a.534.534,0,0,1,.167.226c.068-.105.046-.2-.167-.226",
    transform: "translate(111.63 85.835)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M170.5,105.809l.035-.012a.242.242,0,0,0-.005-.095Z",
    transform: "translate(126.145 79.837)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M131.356,116.035a.366.366,0,0,1-.105.255c.158-.119.232-.219.105-.255",
    transform: "translate(96.501 87.641)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M133.627,110.007l-.558.486a1.087,1.087,0,0,1,.644-.2c-.074-.09-.277-.158-.086-.283",
    transform: "translate(97.875 83.088)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M137.45,109.881c.063-.1.191-.111.254-.212l-.133-.184c-.386.225-.572.53-.121.4",
    transform: "translate(100.985 82.693)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M134.187,110.846c.26.323.57-.039.971-.353a.483.483,0,0,1-.077.044c-.161-.569-.534-.133-.893.309",
    transform: "translate(98.719 83.284)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M134.794,110.5a1.864,1.864,0,0,1,.4-.24c-.063-.228-.188.053-.4.24",
    transform: "translate(99.177 83.211)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M131.522,111.9c.26-.042-.154-.52.051-.455-.054-.581-1.018,1.4-.051.455",
    transform: "translate(96.383 84.092)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M134.968,111.28l-.411-.341-.033.495Z",
    transform: "translate(98.974 83.793)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M132.747,112.378l.751-.312c-.054-.065.005-.16.093-.258-.432.242-.939.456-.844.57",
    transform: "translate(97.623 84.449)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M133.223,111.982a1.336,1.336,0,0,0,.509-.405,2.9,2.9,0,0,0-.509.405",
    transform: "translate(97.991 84.274)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M134.615,111.531l-.256.033-.5.262Z",
    transform: "translate(98.469 84.239)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M128.551,115.073l-.5.546a1.046,1.046,0,0,0,.774-.318c-.04-.114.128-.321-.272-.228",
    transform: "translate(94.083 86.897)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M131.006,114.363a3.527,3.527,0,0,1-.76.058l.83.191a1.366,1.366,0,0,1-.07-.249",
    transform: "translate(95.742 86.378)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M129.921,115.062c.233.053.274.441.75.044-.29-.011-.035-.381-.75-.044",
    transform: "translate(95.497 86.799)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M131.208,117.02l-.216.007-1.065,1c.444-.335.851-.655,1.281-1.006",
    transform: "translate(95.501 88.385)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M137.494,115.422c-1.03-.163-.2.655-1.136.405-.225.255.769.205.537.428.6-.3.929-.186.6-.834",
    transform: "translate(100.334 87.162)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M136.782,115.888a2.131,2.131,0,0,0-.3.174,1.021,1.021,0,0,0,.3-.174",
    transform: "translate(100.449 87.53)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M152,102.141l-.706-.009.516.2Z",
    transform: "translate(111.641 77.14)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M151.361,103.014l-.344-.577-.211.683c.137-.072.4-.212.555-.105",
    transform: "translate(111.271 77.37)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M158.961,110.119l.005.165c.153.126.3.086.6.007Z",
    transform: "translate(117.431 83.173)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M163.866,108.59l-.147.046.486.439Z",
    transform: "translate(121.024 82.018)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M167.893,106.537c-.284.1-.555.367-.843.469.556-.367,1.22.169.843-.469",
    transform: "translate(123.54 80.467)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M125.669,118.185c-.191.228.223.363.263.441.181-.453-.36-.492-.263-.441",
    transform: "translate(92.247 89.252)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M127.035,115.636l.075.183.174-.906Z",
    transform: "translate(93.317 86.794)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M129.84,113.031c-.876-.1-1.125,1.525-1.919,2.073l-.225.014.183.686c.649-.92,1.285-2.3,1.961-2.773",
    transform: "translate(93.817 85.369)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M130.834,112.526c-.318-.061.216-.606-.49.42a.988.988,0,0,1,.13-.04,4.607,4.607,0,0,1,.36-.379",
    transform: "translate(95.816 84.84)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M130.458,112.662c-.344.418.409-.107,0,0",
    transform: "translate(95.832 85.083)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M131.455,111.577l-.311.686c.223.005.686-.427.611-.174.4-.621.184-.627-.3-.513",
    transform: "translate(96.421 84.231)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M131.45,111.066l-.181.342c.095,0,.181-.054.181-.342",
    transform: "translate(96.515 83.888)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M131.052,112l.381-.725c-.154,0-.332-.156-.191.318-.109-.193-.068.063-.19.407",
    transform: "translate(96.351 84.023)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M131.242,111.9c-.391.184-.823.495-.507-.2-.86,1.08-.358,1.259.507.2",
    transform: "translate(95.775 84.368)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M128.975,112.638l-.523.272-.119.52c.054-.265.834-.671.642-.792",
    transform: "translate(94.297 85.076)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M133.634,110.009c-.074-.14-.455-.126-.628-.23l-.256.493c.267-.114.7-.4.885-.263",
    transform: "translate(97.633 82.916)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M132.931,110.1l.386-.739c-.53.47-.535.649-.386.739",
    transform: "translate(97.707 82.598)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M131.313,110.779l-.505,1.327.676-1.515Z",
    transform: "translate(96.167 83.53)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M134.549,108.912l-.095.556.233-.922Z",
    transform: "translate(98.921 81.986)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M135.333,108.354c-.054.439.66.077.518.442a4.421,4.421,0,0,0,.728-1.316,2.515,2.515,0,0,1-1.246.874",
    transform: "translate(99.582 81.18)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M136.374,107.088a4.258,4.258,0,0,0-.332.688,2.221,2.221,0,0,0,.332-.688",
    transform: "translate(100.12 80.884)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M133.7,108.945a.9.9,0,0,0,.76-.091l-.523-.111-.237.2",
    transform: "translate(98.35 82.134)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M133.824,108.924l.018,0c.26-.216.441-.365.52-.428-.068.054-.23.181-.537.425",
    transform: "translate(98.445 81.949)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M133.667,108.91c.023-.019.039-.032.06-.051-.051-.011-.074-.009-.06.051",
    transform: "translate(98.323 82.218)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M132.2,110.462c.165-.5.692-1.362-.247-.964-.035.444.5.218.247.964",
    transform: "translate(97.026 82.628)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M133.587,108.815l-.676.518c.093.07.314.084.23.332Z",
    transform: "translate(97.755 82.188)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M133.5,108.6c-.074.123-.139.256-.207.384l.249-.191Z",
    transform: "translate(98.047 82.023)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M135.63,107.829a2.76,2.76,0,0,1,.786-.939,6.287,6.287,0,0,0-1.2.823c.037.147.04.469.414.116",
    transform: "translate(99.496 80.734)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M134.659,108.079c.014-.023.03-.051.044-.072-.061.005-.1.023-.044.072",
    transform: "translate(99.056 81.578)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M137.92,105.352l-.1-.021.03.068Z",
    transform: "translate(101.461 79.557)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M135.36,107.381a.929.929,0,0,0-.486.637,5.853,5.853,0,0,1,.6-.63c-.018-.067-.039-.1-.112-.007",
    transform: "translate(99.238 81.061)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M136.975,106.563a4.988,4.988,0,0,0-.634.205c.23-.009.651-.077.634-.205",
    transform: "translate(100.346 80.487)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M134.781,108.012a.367.367,0,0,1-.028.051c.149-.011.109-.033.028-.051",
    transform: "translate(99.146 81.581)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M134.842,108.233a2.194,2.194,0,0,0,.186-.514,3.19,3.19,0,0,0-.356.506.552.552,0,0,1,.17.009",
    transform: "translate(99.085 81.36)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M138.2,103.808c.177.363-.391,1.225-1.331,1.373-.493.721.746,1.443,1.752,1.624-.083-.154-.181-.283.358-.958-.363-.007-1.811.676-1.453-.026.786-.816.829-.421,1.39-.565-.667-.132.734-1.415.119-1.873l-.657.788c-.081-.081.105-.439-.179-.362",
    transform: "translate(100.658 78.084)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M137.186,106.22l-.237.253a3,3,0,0,1,1.253-.3c.341-.483.348-.671.3-.8-.469.305-.929.625-1.371.969Z",
    transform: "translate(100.805 79.586)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M136.656,107.069c-.065-.5.465-1.166-.221-1.215-.772.658-.326.727-.678,1.25,1.2-1.1-.211.477.858-.065a5.463,5.463,0,0,1-.609.635,7.4,7.4,0,0,1,.776-.37l-.046,0-.005.007,0-.007c-.088,0-.126-.009-.046-.035a.148.148,0,0,1,.021-.028.447.447,0,0,1-.046-.172c.421-.223.128.042.046.172a.391.391,0,0,0,.025.063h.009l1.113-1.2a6.839,6.839,0,0,0-1.194.962",
    transform: "translate(99.905 79.952)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M131.938,108.759a.119.119,0,0,1,.109.035c.039-.112.044-.167-.109-.035",
    transform: "translate(97.02 82.088)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M132.621,108.566a.745.745,0,0,1-.309.562c-.334.142-.142-.151-.255-.24-.089.248-.376.8.3.435l.044-.125c.581-.356,1.562-.553,1.52-.428a2.8,2.8,0,0,0-1.3-.2",
    transform: "translate(97.007 81.995)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M134.31,107.9l.885-1.069-.767.181.174.146c-.642.451-.333.548-.291.743",
    transform: "translate(98.728 80.691)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M138.02,105.606l.128.47.246-.971Z",
    transform: "translate(101.614 79.386)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M138.809,104.83l.177.362.235-.463Z",
    transform: "translate(102.21 79.101)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M177.04,110.494l-.249.365a1.794,1.794,0,0,0,.249-.365",
    transform: "translate(130.898 83.456)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M178.289,109.4l-.081-.193c-.03.176-.018.274.081.193",
    transform: "translate(131.957 82.485)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M161.6,96.64c.621.29,1.323.79,1.2.356l-.225-.414a1.824,1.824,0,0,1-.978.058",
    transform: "translate(119.422 72.948)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M178.612,96.94c-.026-.067-.054-.137-.083-.205-.2.053-.381.1-.551.163a5.987,5.987,0,0,1,.634.042",
    transform: "translate(131.794 73.064)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M179.094,96.109a7.227,7.227,0,0,1,.57.723,2.715,2.715,0,0,0-.57-.723",
    transform: "translate(132.637 72.591)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M169.305,115.971l-.221.625c.674-.367.27-.4.221-.625",
    transform: "translate(125.077 87.593)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M147.664,100a4.562,4.562,0,0,0,1.245-.165c-.639-.037-1.225-.226-1.245.165",
    transform: "translate(108.898 75.35)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M175.741,108.077c-.126.216-.144.349-.074.418.135-.218.183-.372.074-.418",
    transform: "translate(130.018 81.631)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M149.705,99.539c-.095-.012-.183-.005-.276-.011a4.2,4.2,0,0,1-1.057.49,1.457,1.457,0,0,0,1.332-.479",
    transform: "translate(109.434 75.174)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M136.283,122.208a1.228,1.228,0,0,1-.125-.074c-.023.056.037.068.125.074",
    transform: "translate(100.204 92.248)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M127.378,117.49c.161.03.418.107.66.177a2.075,2.075,0,0,0-.66-.177",
    transform: "translate(93.576 88.74)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M142.276,102.713c-.309.2-.028.07,0,0",
    transform: "translate(104.72 77.579)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M140.83,102.518a.282.282,0,0,0,.018-.262.359.359,0,0,1-.018.262",
    transform: "translate(103.736 77.234)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M150.737,97.428l.033-.009c-.133-.049-.111-.039-.033.009",
    transform: "translate(111.172 73.556)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M141.881,102.82a4.448,4.448,0,0,0,.476-.118,2.038,2.038,0,0,0-.476.118",
    transform: "translate(104.53 77.571)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M142.1,102.848c-.116.054-.207.1-.293.135,0,.088.056.105.293-.135",
    transform: "translate(104.477 77.681)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M142.7,102.563a3.007,3.007,0,0,1-.548.244c.079-.009.118,0,.109.019l.439-.263",
    transform: "translate(104.735 77.466)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M154.422,120.916a.656.656,0,0,1-.091-.019c-.335.277-.176.205.091.019",
    transform: "translate(113.79 91.314)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M167.058,93.625c-.018.005-.028.016-.044.021l.058.016Z",
    transform: "translate(123.513 70.715)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M168.441,93.435a1.247,1.247,0,0,1-1.394.372l.479,1.253Z",
    transform: "translate(123.538 70.571)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M210.247,127.795l1.048-.237c-.632,1.208-1.5,1.522-.4,1.446-.641-1.181,3.142-2.371,2.417-3.579l.7-.174c-.158.1-.133.186-.291.29,1.431-.267.147-1.364,1.541-2.245.507-.286.937-.413.746-.026l.748-1.1c.3-.228.39.007.091.235.469-.462.915-.953,1.371-1.427l.018.039a10.085,10.085,0,0,1,.377-1.36c.49-.221-.07.279.14.307.174-.341.355-.665.511-1.018.56-.093.209.825-.37,1.325,1.708.191.4-.858,2.459-2.057-.179.318-.362.63-.558.929a1.744,1.744,0,0,0,1.22-.521,13.54,13.54,0,0,1,1.3-1.055c-.377.149-2.493,1.2-1.978.026a1.855,1.855,0,0,0,.781-1.239c.395.276.7-.311,1.108-1.039l.513.391c.339-.872.01-.985.014-1.6a1.729,1.729,0,0,1,1.552-.909c.792-1.529-1.2.742-.506-1.125a5.873,5.873,0,0,0,.563-4.09c.246-1.022.388.2.581-.158q-.245-.49-.5-.936c.016-.223.163-.161.251-.126-.276-.767-.644-.042-.944-1.173-.4-.09-.226-.7-.235-1.487a2.4,2.4,0,0,0-.96-2.161c-.054-.4.432-.072.579-.295-.407-.348-.7-.6-.925-.792-.239-.17-.418-.281-.588-.384a5.275,5.275,0,0,0-1.481-.592,11.23,11.23,0,0,0-.762-1.136c.47.971-.83.635-1.9.581.142.36.247.664.339.834-.495-.154-.95-.342-1.448-.451-.107-.174.125-.3.474-.427-.118,0-.228,0-.319.011-.369-.456.037-.665.572-.8a4.74,4.74,0,0,1,.3.623c.523-.139,1.083-.3,1.215-.663a1.536,1.536,0,0,1-.558-.139c.146-.035.255-.079.244-.161s-.239-.058-.551-.056l.011-.807-.218.209a20.858,20.858,0,0,0-1.806-1.338c-1.743.1-3.261.69-5.545.486.669-.39.309-.813.47-1.417.477.792,1.857.153,3.03.665-.6-.253-.383-.5-.19-.548q-1.172-.053-2.313-.005c.167-.479-.369-.5-.9-.806.219,1.067-1.738.328-2.658.525-.005-.344.256-.653,1.32-.4-1.078-.93-1.7.915-2.761.151.262.023.395.091.52-.067-.644.216-2.1-.172-1.725-.425l.262.016c-1.729-.325-5.3-.3-5.554.562a4.972,4.972,0,0,1,.348-1.2c-1.052.939-2.059,1.913-3.031,2.894.255-.741-.836-2.463.592-2.914a2.9,2.9,0,0,0-1.794.086c.288.095.735,1.037.356,1.118-1.078-.783-.741-.42-2.073-1.037.428.133.028,1.309-.628,1.311.093-.177-.13-1.13.105-1.264-.528.4-1.048.83-1.56,1.25.391-.237,0-.962-.4-1.248.19.2-1.431.1-1.857.269l.723.186c-1.876.028-1.654,1.766-3.463,1.945.186-.26.36-1.5-.592-1.517-.358.63-1.481,3.021-2.961,3.723l-.356-.274-1.137.579a20.515,20.515,0,0,1,3.5-4.035c-.728-.154-.249-.356-1.281-.17-.414-.251.495-.551.8-.614-.818.054-1.638.109-2.452.188.219.651-1.727.983-1.529,1.529l2.484-1.144c.209.655-1.188,2.134-2.873,2.34-.477-.181.093-1.243.018-1.459a2.921,2.921,0,0,1-1.7.616l.646-.493c-1-.072-1.35,1.19-2.607.8-.4.037-1.353-.6-1.331-.186a4.632,4.632,0,0,1,1.162,3.565,14.7,14.7,0,0,1-2.675-.514c-.776-.432.6-1.629-.06-2,.021.186-.276.488-.4.6-.441-.049.028-.6-.827-.291.023.7-1.792.4-.269.667-.8.414-.946.088-1.934.4.432.339-.493,1.7-1.274,2.122,0-.181-.251-.348-.37-.42a39.563,39.563,0,0,0-4.33,1c-.2-.105-1.034-.021-.8-.416a1.9,1.9,0,0,1-.806.681c-1.16-.214,1.065-.479.095-.888.072.4-1.088.972-1.694,1.453.442.495,1.646-.463,2.27-.95.288.811-.627,2.038-2.063,3.026-1.157.755-.751-.262-.92-.053-2.41.937-1.38,2.217-3.542,2.579-.983-.081-.52-.941-.86-1.2.9-.725,1.715-.423,2.385-.771l-.962.153a2.353,2.353,0,0,1,1.318-.769,7.015,7.015,0,0,0-2.6.878,20.567,20.567,0,0,1-3.375,1.538c-.226.328-.674.785-.309.834l.521-.367c.723.1-.746,1.088.058.885-.606.642-1.118,1.6-2.25,2.006l-.516-.4c.118.139.848-.1,1.032-.439-.269.491-1.987.267-2.01,1.236l.934-.084a6.617,6.617,0,0,1-2,2.242c.727.228.156-.2,1.151-.035-1.03-.4,2.247-1.373.878-1.61,1.083.295,1.294-.4,2.487-.323-.13-.158-.493-.147.288-.523a.942.942,0,0,1,.068-.255c.025-.009.035-.011.056-.018l-.053,0c.018-.046.018-.053-.018,0a.959.959,0,0,1-.532-.03c.109-.66,1.35-1.287,1.641-1.725.5-.163-.075.307.277.362l.442-.649c.279.362,1.553.011.618.818l.962-.5a3.964,3.964,0,0,0,1.9-.779c.5-.119.96-.979.706-.477l1.432-.951.058.1c1.513-.693,2.949-1.966,5.015-1.862a4.706,4.706,0,0,1,1.95-.793l.291.321c.669-.346,2.226-.26,2.421-.727,1.044.788,3.5-.72,4.8-.834l-.072-.507a14.986,14.986,0,0,0,2.708-.953l-.163-.425c.86-.574,2.479-.2,3.951-.523-.07.19-.455.218-.741.167,1.947.655,3.628-1.394,5.369-.9a1.2,1.2,0,0,1,.979-.125.252.252,0,0,0-.1.037,1.349,1.349,0,0,0,.165-.016c.19.053.384.119.592.165a2.08,2.08,0,0,0-.5-.179,6.573,6.573,0,0,0,1.225-.337l.255.458.1-.025c.474.128.341-.267.056-.6a2.51,2.51,0,0,0,.583-.355c.453.741,1.2-.4,1.783.395.276-.435,2.308-.5,2.508-1.353.023.111.163.156-.09.177a2.381,2.381,0,0,0,1.513-.13l.248.607,1.113-.865c.706.349.99.567.318,1.057,1.638-.746,1.331-.3,2.745-1.009l-.074.4c.5,0,1.323-.523,1.618-.183.548.405,1.927.491,3.516.66a15.144,15.144,0,0,1,4.669,1.106c-.272-1.269,1.141.8,1.459-.046.09.305.418.551-.076.676,1.432.112,1.834,1.009,2.984.634.037.318-.414.263-.349.47.119-.014.479-.056.542.151s-.269.139-.5.168c1.241.465,1.715-.2,2.182-.874.486.656.764.8,1.506.63.072.358.247.8-.523.42.207.132.744.628,1.234,1.051s.923.8,1.18.614c-.012.109.086.233.207.339a1.1,1.1,0,0,0,.295.239,4.846,4.846,0,0,1,.514.925c.135.239.225.486.428.936v-.291c.881.109.465.764.662,1.548l-.081-.012c-.075.488-.118.765-.147.962a1.007,1.007,0,0,0,.044.4c.06.195.079.432-.4,1.294l.5,0c.477.188.244.623-.151,1.1a8.419,8.419,0,0,0-.616.746,1.582,1.582,0,0,0-.386.837l.421-.272c.037.37-.474.641-1.06.825a5.317,5.317,0,0,0-1.413.534c-.147.063-.011-.255.032-.442-1.371,1,.449.513-.123,1.608-.409-.014-.544-.728-1.065-.112-.216.084-.36.707-.621,1.392a2.5,2.5,0,0,1-1.308,1.6c.369,0,.742-.009.469.553-.574.743-2.431,1.023-2.5,2.177a.284.284,0,0,1-.262-.044c-.372.634-1.515,1.75-1.573,2.371-.776-.444-1.513.383-2.212,1.167s-1.341,1.517-1.775.872c-.592.428-1.169.876-1.778,1.285l-.037-.163a3.123,3.123,0,0,0-1.7,1.811c-.334.079-.2-.167-.221-.249a5.411,5.411,0,0,0-3.21,2.45l-.4-.351c-.281.486-2.98.725-4.545,2.11a.36.36,0,0,1,.1-.3c-1.8,1.553-5.5,1-5.548,2.995l-1.225.988c1.866-.614.028.839.89.811-.681.395-2.059.253-1.215-.195l.172.028c-.026-1-2.392.581-2.575-.042a46.026,46.026,0,0,1-5.422,1.7l-2.694.672c-.885.179-1.755.367-2.608.583l.583.606-1.211.277c-.356-.083-.556-.448.3-.642-.546-.288-1.339.716-1.334.879-1.734.151.46-1.008-.058-.89l-.676.237.174.042c-.5.43-.49.727-1.541.886-.69-.025-.425-.384-.69-.365-.007-.051-.1-.06-.4.051l-1.536.214.706.462c-.635.405-1.455.232-.641.753-.6-.369-2.061-.314-3.463-.174a11.864,11.864,0,0,1-3.084.207,6.722,6.722,0,0,1-3.112.486c.3.109.5.755-.544.716.177-.692-.3-.786-.918-.906a2.929,2.929,0,0,1-1.8-.672c.728.657-2.917.1-1.789,1.034-.857-.126-.032-.506-.667-.836-2.07.358-4.458-.614-6.96-.8-.061.17.327.49-.247.685l-1.2-1.039c-.5.028-.606.946-1.411.19.1.168.26.423-.081.423a58.784,58.784,0,0,0-7.388-1.631,17.922,17.922,0,0,1-7.111-2.74c.541.53.1.427-.4.284.3.179-.142.413-.153.66-.607-.412-1.192-.871-1.78-1.3-.592.514-2.122-.723-2.549-.212l.66.13c-1.109.39.585,2,.146,2.861,1.237-.465,2.163,2.089,4.151,1.418.3.3-.393.2-.27.474.53-.262,1.043-.193,1.913.237l-.133.07a26.066,26.066,0,0,1,3.152,1c.944.348,1.908.807,3.368,1.232l-.118-.511a2.734,2.734,0,0,1,1,.548c.876-.553-1.778-.414-.944-1.053.316.562,1.436.8,2.517,1.048,1.085.23,2.141.427,2.338,1.025.988.172-.2-.593.786-.421l.214.339.309-.337c.635.174.908.593.9.843a3.285,3.285,0,0,0-.632-.007c.793.493,2.412.191,2.684.349l-.936-.3c2.742.105,6.061.769,8.734.276l-.191-.23c2.024-.372,1.606.281,3.821.135l-.079.051a4.023,4.023,0,0,1,1.632-.342c-.555.284,1.065.47.339.79,2.18-.53,1.08-.393,2.475-1.283l.353.36a2.575,2.575,0,0,1,1.58-.73c-.872.413.748.492-.228,1.02,2.406.567,3.337-1.18,4.551-.111.916-1.137-2.075-.353-1.51-.637-.534-.286.774-.853,1.5-.836.721-.107,1.431,1.083,3.284.728-.184.028-.183.107-.367.137.744.132,1.287-.6,2.222-.33.342-.692,1.1-.24,1.053-1.041a14.882,14.882,0,0,1-1.629.56c.929-.341,1.562-1.557,3.207-1.5a2.726,2.726,0,0,1-.771.711c.511.107.83-.381,1.36-.272.074.8-1.971.7-2.849,1.559.57.2,1.79-1.067,1.483-.095.463-1.257,1.845-.344,2.851-1.478l.054.479a2.792,2.792,0,0,1,.874-.535c-.149.263-.311.511-.469.769.851-.767,2.024-.147,2.879-.711-1.948.641-.614-.405-1.545-.472,2.194-1.374,1.766.741,4.381-.391-.342.188-1.457.2-.962-.207a4.79,4.79,0,0,1,1.669-.023c1.731-.737-.437-.363.212-.913.8.325.785-.534,1.481-1l.177.451c2.1-.483.163-1.144,2.08-1.49l-.506.92.867-.528.014.59a3.833,3.833,0,0,1,2.257-1.088c-.36-.218-.214-.867.641-1.255.706.009-.146.567,1.053-.03-.154.4-.307.879-1.02.7.007.169-.154.4-.149.567a5,5,0,0,0,2.08-.832,1.383,1.383,0,0,1-.527.111l1.492-1.418c.355.037.2.27.037.5a11.316,11.316,0,0,1,1-.813c.033.421.244.778-.43,1.288.507-.386,1-.793,1.5-1.2.186.1,1.067.005.914.242,1.037-.256,1.927-1.817,3.272-2.2a.933.933,0,0,1,.348-.423c1.173-.53,2.415-.685,3.458-1.936l1.115.154c.944-.762-1.469-.147.093-1.415,1.067-.95.767.225,1.292.123.414-.676,1.018-1.959,2.417-2.224-.276.362-.62.458-.923.73m11.058-10.188c-.109.293-.244.969-.607.948-.2-.618.158-.651.607-.948M216.965,97.5c.267-.068.544.151.8.493a2.323,2.323,0,0,1-.8-.493m-58.539,9.844a.209.209,0,0,0,.014-.035c.613-.118.393-.083-.014.035m-1.2.409c-.079.121-.04.176.039.211.019-.151.263-.291.56-.414-.137-.07-.319-.07-.6.2m14.4,31.471.263.081c-.518.235-.388.084-.263-.081",
    transform: "translate(91.932 70.681)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M179.013,96.191a.446.446,0,0,1-.03.291c.146-.007.2-.083.03-.291",
    transform: "translate(132.553 72.653)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M169.253,115.905l-.042.016a.211.211,0,0,0,0,.1Z",
    transform: "translate(125.169 87.543)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M153.281,95.6a1.118,1.118,0,0,1,.565.119c-.014-.116-.158-.191-.565-.119",
    transform: "translate(113.141 72.187)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M140.475,104.191l.606-.532a1.3,1.3,0,0,1-.693.251c.077.084.295.142.088.281",
    transform: "translate(103.402 78.294)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M136.281,104.933c-.058.123-.2.165-.251.288l.165.156c.39-.332.56-.7.086-.444",
    transform: "translate(100.111 79.191)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M140.032,103.468c-.276-.3-.648.065-1.062.474a.654.654,0,0,1,.083-.06c.186.569.565.053.979-.414",
    transform: "translate(102.332 78.067)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M139.1,103.741a2.349,2.349,0,0,1-.423.316c.077.228.2-.084.423-.316",
    transform: "translate(102.106 78.356)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M142.772,102.328c-.284.035.109.535-.105.46-.009.6,1.25-1.39.105-.46",
    transform: "translate(105.122 77.097)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M138.926,103.012l.455.309.049-.511Z",
    transform: "translate(102.298 77.652)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M141.655,101.716l-.851.372c.056.065-.018.17-.119.279.488-.29,1.065-.534.971-.651",
    transform: "translate(103.626 76.826)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M140.935,102.087a1.737,1.737,0,0,0-.583.467,3.953,3.953,0,0,0,.583-.467",
    transform: "translate(103.375 77.106)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M139.489,102.63l.288-.058.574-.318Z",
    transform: "translate(102.723 77.233)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M146.327,99.533a7.846,7.846,0,0,1,.878-.507c.033-.195-.265-.2-.592-.009-.174.211-.488.425-.286.516",
    transform: "translate(107.839 74.681)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M144.391,99.429c.3-.019.36.075.572.161l-.233-.579Z",
    transform: "translate(106.426 74.783)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M146.089,98.768c.019-.212,1.185-1.053,0-.5-.032.2-.914.757,0,.5",
    transform: "translate(107.395 74.082)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M154.491,96.329l-.249.067.274.988Z",
    transform: "translate(113.866 72.757)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M162.353,93.6c-1.248-.09-.212.663-1.348.5-.253.277.927.133.662.377.7-.351,1.1-.244.686-.878",
    transform: "translate(118.948 70.691)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M161.519,94.1a2.871,2.871,0,0,0-.353.2,1.294,1.294,0,0,0,.353-.2",
    transform: "translate(119.096 71.071)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M126.275,116.873l-.62-.458.326.488Z",
    transform: "translate(92.275 87.928)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M125.323,117.075l.084-.667-.614.386c.151.032.46.1.53.281",
    transform: "translate(91.624 87.923)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M181.658,106.681l-.095-.144c-.212.025-.339.186-.6.5.23-.116.47-.221.7-.355",
    transform: "translate(134.049 80.467)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M176.935,111.292l.154-.111-.648-.232Z",
    transform: "translate(130.634 83.801)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M172.78,114.849c.328-.181.628-.528.958-.709-.63.53-1.436.14-.958.709",
    transform: "translate(127.759 86.21)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M149.9,112.216c.674-.255-.428-.074.425-.218a.442.442,0,0,1-.425.218",
    transform: "translate(110.591 84.592)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M175.351,120.209c2.033-1.243,5.113-1.624,7.406-2.77.274-.118.026.323.639.04a40.194,40.194,0,0,1,8.873-2.87l-.14.146c.56-.13,1.116-.642,1.7-.807.025.054-.153.144.005.174.084-.218,1-.448,1.2-.66.248-.016.274.125.592.091l.255-.309c.737-.781,2.2-.774,3.346-1.471-.044.067-.151.146-.037.153,1.866-1.016,4.341-1.919,6.477-2.91-.06.1-.091.255.067.277.028-.24.679-.567,1.243-.85.348.093.92-.6,1.645-.785l-.039.07c.409-.428.8-.2,1.09-.634l.386.018c.091-.381.786-.177,1.13-.511l-.039-.051c.353-.247.62-.2.953-.416l.049.016c.8-.47,1.352-.562,1.223-.765.377.028-.76.477-.181.5.876-.528,1.834-1.087,2.6-1.585a13.355,13.355,0,0,0,1.137-.806,3.925,3.925,0,0,0,.506-.476.751.751,0,0,0,.244-.623.715.715,0,0,0-.523-.362,3.4,3.4,0,0,0-.649-.1,10.242,10.242,0,0,0-1.313-.005c-.253-.084-.467-.1-.523-.184a6.942,6.942,0,0,0-1.417.309c.1-.016-.211-.1-.374-.089-.565-.019-.567.341-1.187.323.232-.1.3-.19.209-.267a9.248,9.248,0,0,1-1.782.5c.088-.056.232-.1.195-.176-.628.323-1.222.165-1.78.405l.193-.177c-.967.009-.223.337-1.05.393.186-.081.107-.121.132-.184a17.117,17.117,0,0,1-2.672.8.048.048,0,0,0,.021-.063,25.667,25.667,0,0,0-2.552.62c-.339.012.033-.356-.818-.112.093.265-1.436.449-.858.641a14.22,14.22,0,0,0-2.4.509c.305-.183-.439-.246.167-.416l-.5-.053c.042-.128.484-.077.3-.183a14.959,14.959,0,0,1-1.452.434,6.933,6.933,0,0,1-1.873,1.009c.4-.214-.319-.237-.039-.356l-1.143.843c-.3.091-.121-.2-.542-.012.04.067-.139.16-.258.253-.121,0-1.243.395-1.445.163-.161-.07.479-.186.119-.191-.562.149-.562.247-1.12.4l-.021-.033c-.381.06-1.058.4-.618.444.26-.06-.14-.133.262-.158a4.008,4.008,0,0,1-1.417.6c.179-.095.137-.16.193-.255a15.629,15.629,0,0,1-2.285,1.013c.021.13.249-.316.391-.283-1.123.119-2.148.862-3.112.858.14-.065.13.156.111.123-.521.13-.549-.058-.867.1-.063-.1-.412.154-.75.286-.156.128-.105-.026.193-.125a16.446,16.446,0,0,1-3.493,1.118c.042.065-.607.46-.865.527l.051-.195c-.262-.03-.851.267-.936.139-.486.362,2.052-.792,1.359-.418-.232-.082-.95.567-.858.295a4.992,4.992,0,0,1-1.488.483c.151-.016.348-.353-.063-.219-.72.249-.184.142-.758.374l-.349.179c.023.169-.658.176-.334.272-.13-.105-1.034.4-1.039.112l.037-.24c-.309.112-.448.379-.667.548-.046-.009-.142-.025-.137-.063.047.335-.758.2-1.055.565a11.717,11.717,0,0,1-2.048.409,4.942,4.942,0,0,1-1.494.637c.105-.067.26-.126.27-.205-.391.021-.453.135-.767.291a7.414,7.414,0,0,0-1.22.061c-.47.256-.242.372-.258.493-.563-.172-1.341.671-2.006.579.158-.1.676-.4.235-.339-.562-.158-.841.544-1.627.644l.27.2c-.383-.049-1.029.52-1.044.228-.214.177-.9.209-.725.435-1.278.207-2.868,1.173-3.769.985-.156.1-.6.216-.467.312.337.039.363-.244.5-.186-.151.063-.16.146-.163.186-.393.075-.693.163-.418-.172-.888.14-.7.744-1.78,1.037.009-.121-.086-.13-.386,0l-.516.4c-.693.216-.474-.09-.558-.26-.351.169-.8.327-.913.52l-.525-.054c.381.037-.256.221-.409.334l.153-.111c-.095-.047-.5.163-.7.267.091.09.535-.035.779-.095-.154.151-.448.246-.656.432.014-.2-.635.109-.929.205-.344.091-.311.3-.409.33-.044-.084-.542.2-.335-.028.1-.072.291-.014.446-.165-.244.019-.281-.146-.685.144-.305.218.221.3-.465.449.153-.111.156-.19.263-.3l-.637.149.037.165c-.1-.007-.047-.042-.093-.049-.114.232-.893.423-.955.662a9.164,9.164,0,0,1-.974.255l.049-.037a2.294,2.294,0,0,0-1.087.532l0-.04a2.969,2.969,0,0,0-.844.467c-.534.088-.407-.516-.862-.095-.488.214-.649.611-.409.627a20.831,20.831,0,0,1-2.737,1.06c-.1.118,0,.123-.248.272a22.028,22.028,0,0,1-3.79,1.539c.342-.232-.044-.163-.091-.247-.244.276-.434.025-.437.309.095.125.093.205.479.1a9.967,9.967,0,0,1-2.37,1.018c.24-.033.1.084-.051.2-.046-.244-.623-.016-1.011.258l0,.162-.341-.009c-.144.119-.049.363-.528.435a.261.261,0,0,0-.19-.084,3.941,3.941,0,0,1-1.439.909l-.481-.007c-.19.121-.472.4-.091.284a6.086,6.086,0,0,1-1.724.476,16.616,16.616,0,0,1-3.086,2.066l-.727-2.342,1.836-.228-.039.116c.49.04.221-.223.565-.193-.14.126.393.176.037.356.7.021.851-.312,1.288-.423.046-.153-.344.142-.284-.053.068-.06.958-.023,1.034-.258.183.061.074.24-.005.342l.4-.167c.548.177-1.1.625-.514.857l.381-.091c.4.174-.983.409,0,.342.4-.169.716-.537.328-.577.862-.191.326-.572,1.264-.7.276.088-.744.149-.537.3.469.107.869-.237,1.271-.237-.448-.012-.114-.29.16-.374.491.026-.276.255.4.17.093-.144.7-.335.147-.337.2-.319.713-.033,1.041-.316.253.163-.616.577.14.553-.149-.172.867-.414.43-.634.3.007.355.153.163.307.434.047.943-.52,1.144-.161l.109-.221c.14.044.334.06.564.126.365-.061,1.125-.474,1.144-.172.112-.053.944-.188.588-.335-.539-.032-.567.256-.9.032.4.16.739-.163,1.023-.291l.068.105c.17-.077.585-.125.672-.269-.125.09-.04.154.107.158l.154-.209c.7-.225.226.274.918.09l-.507.235c.111-.051.381.067.706-.053.1-.183.309-.42.4-.563.381-.146.211.144.569-.091l-.474.286c-.067.067.395.2.922.093.328-.119.806-.448.256-.434.265-.053.655-.026.467.128.588-.174-.111-.153.386-.356.232.063.918.079,1.346.153l-.486.374.36-.072c-.423.307.269.116.051.391a2.229,2.229,0,0,0,.76-.258c-.79-.211.7-.651.428-.936.96-.288.779.672,1.694-.06-.186-.047.242-.4-.353-.174.616-.095.344-.416,1.09-.435-.5.249.641.207-.086.567.028-.119-.446.01-.558.067.277.07.018.339.642.2.374-.112.893-.232.783-.386-.058-.183-.578.146-.376-.095.744-.228.932.028,1.174-.37-.474.128-.634-.037-.655-.167l.541-.2-.081.147c.909-.105.212-.279,1.083-.437l.458.151c-.156.262-1.274.188-1.046.5.565-.105.713-.325,1.26-.358-.111.058-.27.1-.379.16.2-.035.506.372,1.245-.077.39-.2.082-.147.063-.277.89-.246,1.127-.439,1.7-.592-.061.277,1.029-.212.449.191a3.35,3.35,0,0,0-1.89.548c.4.219-.716.121-.841.465.723-.16.757.14.916.3a1.587,1.587,0,0,0,.493-.216c.042-.2-.219-.135-.277-.318a5.36,5.36,0,0,0,1.973-.693c.29.023.247.225-.067.318a26.983,26.983,0,0,1,2.893-.683c-.66-.147,1-.318.534-.462-.5.054-.971-.051-.735-.249.307-.054.021.132.163.161.348-.255.665.109.981-.237-.848.309-.081.4-.183.667.6-.284.014.169.637.016a18.975,18.975,0,0,1,2.019-.821,13.213,13.213,0,0,0,2.986-.8c.437,0,.232.335.685.256.516-.149-.46-.17.339-.267l-.06.072c.214-.125,1.453-.219,1.576-.651l-.158.344a.962.962,0,0,0,.374-.179c.032.09.223.125.005.249.528.06.986-.309,1.5-.462l-.377-.07c.842-.374,1.473-.4,2.3-.707l.023.168.474-.247c-.076.191.416.153.644-.056l-1.194.786c-.393.014.339-.314.065-.4a1.51,1.51,0,0,0-1.088.391,1.278,1.278,0,0,0,.525-.239c.167.193-.293.321-.474.537.154-.056.4-.054.411-.135a3.533,3.533,0,0,1-1.1.47c.325-.186-.23-.084-.116-.186.016.209-.462.407-1.118.532-.521-.1-1.162.484-1.922.63a3.149,3.149,0,0,1,1.015-.76c-.493.03-.516.151-1.011.181a1.9,1.9,0,0,1-.864.748l-.074-.139c-.53.23-.472.448-1.187.592-1.227.244-2.468.569-3.393.792l-.074-.139c-.43.455-1.683.542-2.338.855-1.213.147-2.526.776-3.195.651a58.927,58.927,0,0,1-6.042,1.534l.318-.3c-.355.244-.279-.07-.653.044.476.079-.479.339-.721.53a9.919,9.919,0,0,0-3.035.793l-.063-.144a9.008,9.008,0,0,1-2.993.567,1.151,1.151,0,0,0-.678-.065,7.025,7.025,0,0,1-1.692.7,17.822,17.822,0,0,1-2.324.251c-2.321.749-4.792.916-7.248,1.476l-.205-.153a18.04,18.04,0,0,1-3.13.6l-5.731.671,5.1-2.691c1.4-.741,2.814-1.359,3.869-2.006l-.046.363c.627-.2,1.3-.725,1.055-.848.627-.205,1.406-.839,1.887-.792.627-.235.676-.483,1.162-.753a19.635,19.635,0,0,0,2.821-1.267l-.293.111c-.1.119-.054.242.241.132.391-.272,1.606-.637,1.03-.779,1.308-.367,2.8-1.431,4.109-1.7-.142-.047.153-.2.255-.316a23.151,23.151,0,0,0,3.105-1.288c.193-.028-.209.274.237.095.248-.146-.044-.123.256-.311,1.7-.893,3.651-1.3,5.254-1.973,2.8-1.318,5.852-2.375,8.631-3.4l-.007.081c.841-.6,2.282-.525,2.893-1.174.246-.009.858-.258.741-.067.683-.444,2.152-.537,3.152-1.144a.811.811,0,0,0-.258.13c1.143-.212,2.047-.725,3.249-.96-.107.068-.314.16-.326.24.49-.009.967-.637,1.32-.377.255-.086.128-.228-.026-.168,2.579-.678,5.226-1.71,7.857-2.577,1.962-.358.284.537,1.711-.158.14.03.049-.156.091-.091.553-.265,1.015.116,1.367-.179-.228-.161.233-.195.209-.326a6.854,6.854,0,0,0,2.366-.5l-.039.13c.992-.618,2.289-.8,3.1-1.415,5.947-1.713,11.645-3.4,17.56-4.743,2.424-.495,4.827-.992,7.279-1.394q.921-.15,1.855-.276l.943-.114.49-.051c.307-.03.606-.054.9-.068a9.134,9.134,0,0,1,3.195.212,2.5,2.5,0,0,1,.944.53,2.2,2.2,0,0,1,.572.888,2.087,2.087,0,0,1-.295,1.706,5.988,5.988,0,0,1-1.857,1.676c-.613.323-1.092.528-1.474.707l-.723.314c-.372.176-.734.405-1.416.813.035-.072.119-.126,0-.119.04.26-.992.511-1.025.786-2.075.932-3.955,1.815-6.094,2.7.328-.165.42-.421.025-.24l-.362.319-.095-.035c-.26.146-.514.383-.2.339-5.315,2.392-10.846,3.881-16.179,5.8-1.306.344-3.088,1.053-4.46,1.566a115.135,115.135,0,0,0-12.141,3.539s.36-.779,2.045-1.464",
    transform: "translate(87.837 75.63)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M149.635,112.392c-.184-.074-.685.005-.349-.267.081.1.369.146.349.267",
    transform: "translate(110.038 84.688)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M141.985,113.7c-.007.04-.2,0-.244-.012.158-.049.283-.188.427-.154-.16.049-.121.1-.183.167",
    transform: "translate(104.424 85.751)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M139.977,114.268a3.052,3.052,0,0,1,1.13-.5Z",
    transform: "translate(103.092 85.933)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M138.228,114.293c-.29-.028-.226-.095.135-.176.04.051-.074.107-.135.176",
    transform: "translate(101.634 86.193)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M138.288,114.416a1.022,1.022,0,0,1-.539,0c.03.09.583-.2.539,0",
    transform: "translate(101.409 86.364)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M134.457,115.064c-.161.042-.495.2-.672.114.188.049.765-.3.672-.114",
    transform: "translate(98.415 86.867)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M132.54,115.544a.633.633,0,0,0-.262.053c-.2-.014-.014-.13.142-.17Z",
    transform: "translate(97.213 87.181)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M145.165,108.959l-.312.163.014-.119Z",
    transform: "translate(106.774 82.297)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M159.041,104.763c.318-.158.262.037.321.037-.3.093.075-.161-.321-.037",
    transform: "translate(117.491 79.081)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M166.672,102.594l-.1.026-.016-.226Z",
    transform: "translate(123.166 77.338)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M131.489,163.078s20.021-23.284,20.016-52-8.977-52-20.037-51.994-20.021,23.284-20.016,52,20.037,51.994,20.037,51.994m-9.184-51.939C122.3,84.331,126.418,62.6,131.5,62.6s9.212,21.731,9.217,48.538a138.091,138.091,0,0,1-9.2,48.541,138.111,138.111,0,0,1-9.217-48.538",
    transform: "translate(81.547 44.625)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M131.489,163.078s20.021-23.284,20.016-52-8.977-52-20.037-51.994-20.021,23.284-20.016,52,20.037,51.994,20.037,51.994m-9.184-51.939C122.3,84.331,126.418,62.6,131.5,62.6s9.212,21.731,9.217,48.538a138.091,138.091,0,0,1-9.2,48.541,138.111,138.111,0,0,1-9.217-48.538",
    transform: "translate(81.547 44.625)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M116.444,88.978c.03-.3-.388-.193-.465-.239.1.507.574.225.465.239",
    transform: "translate(84.966 67.025)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M116.928,91.733l-.177-.081.465.711Z",
    transform: "translate(85.55 69.225)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M117.2,95.621c.688-.491-.218-1.666-.012-2.508l.154-.146-.6-.339a11.665,11.665,0,0,1,.456,2.993",
    transform: "translate(85.547 69.962)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M116.276,96.072c.263-.181.291.514.03-.588a.769.769,0,0,1-.06.112,3.8,3.8,0,0,1,.03.476",
    transform: "translate(85.168 72.119)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M116.292,95.616c-.068-.49-.2.344,0,0",
    transform: "translate(85.122 72.099)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M116.714,97.095l-.311-.618c-.151.151-.132.734-.272.53.2.651.351.495.583.088",
    transform: "translate(85.081 72.869)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M116.873,97.282l-.14-.321c-.061.067-.079.158.14.321",
    transform: "translate(85.505 73.235)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M116.549,96.571l.291.685c.105-.107.337-.142-.112-.318.218.035,0-.082-.179-.367",
    transform: "translate(85.397 72.94)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M116.613,96.784c.119-.377.172-.853.483-.233-.219-1.218-.7-.99-.483.233",
    transform: "translate(85.403 72.315)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M117.482,94.816l.176-.493-.265-.4c.13.2-.139.937.09.89",
    transform: "translate(86.029 70.942)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M116.544,99.486c.156.019.374-.274.562-.348l-.237-.451c-.07.258-.105.735-.325.8",
    transform: "translate(85.393 74.538)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M116.864,98.951l.353.672c-.053-.637-.191-.735-.353-.672",
    transform: "translate(85.635 74.725)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M117.541,97.63l-.667-1.1c.235.442.451.886.7,1.322Z",
    transform: "translate(85.642 72.908)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M116.946,100.839l-.416-.348.646.632Z",
    transform: "translate(85.383 75.901)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M117.249,101.728c-.337-.247-.421.493-.649.209a2.986,2.986,0,0,0,.744,1.187,1.829,1.829,0,0,1-.095-1.4",
    transform: "translate(85.435 76.796)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M117.47,103.066a3.833,3.833,0,0,0-.446-.565,1.987,1.987,0,0,0,.446.565",
    transform: "translate(85.756 77.419)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M117.271,100.019a.793.793,0,0,0-.341.621l.379-.342c-.011-.086-.025-.181-.039-.279",
    transform: "translate(85.685 75.544)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M117.158,100.171l-.012.012c.039.3.063.513.076.6-.009-.077-.026-.262-.063-.614",
    transform: "translate(85.848 75.659)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M117.118,99.979l.009.07c.039-.033.049-.051-.009-.07",
    transform: "translate(85.827 75.514)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M117.173,98.236c.293.384.662,1.209.915.328-.33-.258-.474.247-.915-.328",
    transform: "translate(85.868 74.198)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M117.563,100.066l-.005-.764c-.111.032-.256.191-.4,0Z",
    transform: "translate(85.855 75.003)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M117.583,100.082l-.195-.344.009.281Z",
    transform: "translate(86.031 75.332)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M117.373,102.194a2.651,2.651,0,0,1,.43,1.03,8.427,8.427,0,0,0-.109-1.308c-.142-.037-.413-.179-.321.277",
    transform: "translate(86.005 76.94)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M117.283,101.136c.012.021.025.047.035.068.03-.051.035-.088-.035-.068",
    transform: "translate(85.951 76.384)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M118.059,104.9l.063-.079-.077,0Z",
    transform: "translate(86.527 79.171)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M117.7,102.135a.766.766,0,0,0-.267-.671,4.8,4.8,0,0,1,.2.757c.063.016.1.014.067-.086",
    transform: "translate(86.065 76.636)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M117.531,103.683a4.214,4.214,0,0,0,.125-.6c-.1.19-.246.562-.125.6",
    transform: "translate(86.104 77.859)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M117.275,101.266a.386.386,0,0,1-.026-.046c-.074.121-.032.1.026.046",
    transform: "translate(85.896 76.451)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M117.247,101.3a1.8,1.8,0,0,0,.328.383,2.639,2.639,0,0,0-.23-.511.5.5,0,0,1-.1.128",
    transform: "translate(85.924 76.416)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M120.98,105.952c-.4.033-.944-.714-.685-1.515-.442-.637-1.631.084-2.206.858.174-.016.332-.047.723.63.156-.3.139-1.718.627-1.181.414.916.037.814-.063,1.327.4-.5.976,1.062,1.639.69l-.435-.778c.107-.04.351.223.4-.032",
    transform: "translate(86.56 78.697)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M118.133,104.146l-.107-.293a2.932,2.932,0,0,1-.325,1.157c.3.463.469.535.606.542-.1-.5-.176-1-.253-1.5Z",
    transform: "translate(86.267 78.44)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M117.849,103.412c.472.154.793.841,1.167.309-.2-.874-.476-.549-.764-1.043.383,1.408-.316-.365-.358.713a4.278,4.278,0,0,1-.262-.751,6.2,6.2,0,0,1-.051.778l.021-.039,0-.005h.007c.04-.072.07-.1.053-.023l.014.028a.486.486,0,0,1,.174.033c-.007.432-.1.088-.174-.033a.278.278,0,0,0-.067-.005l0,.005.513,1.39a5.769,5.769,0,0,0-.267-1.357",
    transform: "translate(86.177 77.524)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M118.318,98.787a.122.122,0,0,1-.093.06c.065.084.105.114.093-.06",
    transform: "translate(86.663 74.614)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M118.582,99.533a.6.6,0,0,1-.258-.5c.091-.312.207-.028.346-.063-.14-.186-.4-.671-.527,0l.072.093c-.07.6-.507,1.42-.579,1.329a3.034,3.034,0,0,0,.946-.855",
    transform: "translate(86.218 74.491)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M118,101.115l.405,1.155.27-.671-.218.07c-.025-.692-.274-.5-.458-.555",
    transform: "translate(86.491 76.372)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M118.158,104.995l-.483-.061.785.551Z",
    transform: "translate(86.247 79.256)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M118.349,105.842l-.4.03.325.356Z",
    transform: "translate(86.454 79.943)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M126.447,78.622l-.139-.339a1.378,1.378,0,0,0,.139.339",
    transform: "translate(92.768 59.127)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M126.472,79.935l.2.049c-.116-.111-.2-.153-.2-.049",
    transform: "translate(92.892 60.33)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M127.353,107.172c.486-.42,1.167-.864.72-.9l-.46.058a1.392,1.392,0,0,1-.26.844",
    transform: "translate(93.557 80.266)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M128.064,91.706l-.142.144.4.365c-.077-.154-.163-.328-.254-.509",
    transform: "translate(93.987 69.266)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M126.986,91.741l.295-.655a2.45,2.45,0,0,0-.295.655",
    transform: "translate(93.28 68.797)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M125.434,70.906l-.5-.321c.1.616.279.309.5.321",
    transform: "translate(91.729 53.313)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M121.637,116.908a14.681,14.681,0,0,0,.53,2.034c-.244-1.274-.337-2.543-.53-2.034",
    transform: "translate(89.24 88.213)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M129.183,78.973c-.095-.211-.191-.3-.288-.284.091.218.184.339.288.284",
    transform: "translate(94.722 59.432)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M122.659,119.791c-.04-.2-.077-.369-.118-.56a4.825,4.825,0,0,1-.6-1.215c.174.93.434,1.866.721,1.775",
    transform: "translate(89.467 89.138)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M119.488,78.051a1.1,1.1,0,0,1-.061.109c.058.016.065-.035.061-.109",
    transform: "translate(87.571 58.952)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M116.587,86.547a4.726,4.726,0,0,1-.025-.609,1.474,1.474,0,0,0,.025.609",
    transform: "translate(85.391 64.909)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M118.976,109.459c-.116-.318-.063-.039,0,0",
    transform: "translate(87.179 82.561)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M119.656,108.247a.271.271,0,0,0,.237.075.342.342,0,0,1-.237-.075",
    transform: "translate(87.744 81.759)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M123.236,115.461l.011-.023c-.047-.142-.039-.114-.011.023",
    transform: "translate(90.43 87.12)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M118.986,109.086a2.2,2.2,0,0,0-.011.448,2.341,2.341,0,0,0,.011-.448",
    transform: "translate(87.225 82.393)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M118.922,109.283c-.014-.116-.026-.207-.037-.295-.081-.021-.116.026.037.295",
    transform: "translate(87.109 82.315)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M119.093,109.879a2.4,2.4,0,0,1-.1-.537c-.011.072-.028.105-.047.091.032.095.075.226.147.446",
    transform: "translate(87.207 82.586)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M121.669,63.309c-.018.005-.033.018-.056.023.056.3.074.2.056-.023",
    transform: "translate(89.222 47.817)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M125.819,101.463c0,.016.012.026.014.04a.277.277,0,0,0,.023-.046Z",
    transform: "translate(92.399 76.631)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M125.744,100.773c.455.581.342.851.169,1.2l1.3-.167Z",
    transform: "translate(92.342 76.114)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M133.3,86.446l-.3.857c-.748-.915-.6-1.643-1.069-.822,1.38-.035.465,3.137,1.829,3.124l-.239.565c0-.156-.082-.174-.082-.326-.562,1.1,1.053.692.971,2.068-.068.481-.24.827-.427.516l.416,1.029c0,.309-.246.251-.242-.056l.218,1.6-.042-.009a6.626,6.626,0,0,1,.751.962c-.17.423-.158-.2-.321-.081l.381.874c-.335.384-.713-.337-.7-.955-1.308.911.386.721-.311,2.559l-.218-.83c-.742.581-.43,1.22-.872,2.191.242-.233,1.132-1.959,1.513-1.008a1.324,1.324,0,0,0,.174,1.15c-.486.026-.341.53-.29,1.167l-.644-.018c.209.681.534.614.837,1.011-.037.772-.53.946-.943,1.139-.072,1.234.778-.872.934.581a5.245,5.245,0,0,0,.462,2.968c-.211.721-.395-.119-.574.14l.521.63c-.009.156-.169.107-.247.083.205.535.646.037.825.881.7.223-1.006,1.747-.237,2.779-.188.255-.391-.125-.642-.049a8.653,8.653,0,0,0,1.044,2.408l-.442.986c.493-.718,1.06.237,1.492,1.088a5.393,5.393,0,0,0,.556-.618c.114.448.188.9.279,1.346-.114.154-.326.009-.581-.219.047.091.095.181.139.249-.267.463-.621.2-.96-.158l.425-.456c-.367-.344-.792-.665-1.171-.613a.921.921,0,0,1,.154.437c-.1-.09-.193-.147-.26-.111s.063.184.214.405l-.734.263.281.086-.551,1.682c.651,1.262,1.654,2.415,1.738,4.406-.476-.535-.844-.186-1.462-.272.7-.469-.112-1.525.079-2.517-.1.52-.39.381-.484.239.16.611.288,1.223.432,1.84-.5-.088-.418.344-.672.79,1.037-.256.537,1.4.774,2.166-.341.007-.667-.207-.5-1.085-.843.893,1.055,1.4.281,2.289.021-.218.088-.328-.072-.435.232.544-.167,1.754-.421,1.424l.021-.218a15.69,15.69,0,0,0-.311,2.759c-.035.955.074,1.78.477,1.955a5.967,5.967,0,0,1-1.143-.467c.806,1,1.617,2.02,2.41,3.056-.685-.355-2.554.195-2.758-1.06a2.192,2.192,0,0,0-.242,1.476c.147-.211,1.157-.384,1.16-.054-.972.72-.548.525-1.439,1.46.223-.316,1.278.291,1.134.836-.153-.119-1.123-.179-1.2-.4.277.527.57,1.06.834,1.59-.125-.381-.925-.256-1.3-.021.248-.093-.281,1.164-.251,1.548l.383-.516c-.516,1.487,1.236,1.869.793,3.382-.181-.24-1.285-.79-1.613-.056.469.481,2.328,2.24,2.387,3.718l-.391.174.079,1.137a27.693,27.693,0,0,1-2.4-4.3c-.395.5-.418.063-.6.918-.374.221-.341-.579-.3-.832-.226.641-.453,1.28-.7,1.913.678.086.244,1.675.807,1.752l-.091-2.317c.678.079,1.515,1.731,1.013,3.11-.356.283-1.085-.6-1.309-.625a.728.728,0,0,1,.081.33c.016.128,0,.372.007.434.005.2-.04.391-.125.384a3.021,3.021,0,0,0-.244-.446c-.17.125,0,.349.095.639.1.272.128.623-.2.59-.042.067-.244-.019-.388-.111s-.235-.16-.1.084c.586.742,2.457,2.837,2.694,3.92a6.867,6.867,0,0,1-.683.669c-.325.269-.646.42-.806.314-.246-.174-.369-1.029-.511-1.731a4.921,4.921,0,0,0-.5-1.613,4.563,4.563,0,0,1,.184,1.039c-.158-.046-.279-1.025-.376-.474.305,1.311-.342.818.2,1.281-.091.9-.239.258-.427.867a12.65,12.65,0,0,1,.176,2.5,14.522,14.522,0,0,1-.247,2.856,4.74,4.74,0,0,0-.149-.983,3.468,3.468,0,0,1-.6.992c-.251-.92-.437-1.743-.7-2.443a8.469,8.469,0,0,1,0-2.076c-.079.161-.195.577-.325.27-.023-1.934.279.479.328-1.631-.121.921-.437.53-.713.509a1.583,1.583,0,0,0,.135,1.229.333.333,0,0,0,.465.058,4.186,4.186,0,0,1-.592,2.138c-.283.288-.656.147-1.078-.416-.627-1.078.058-1.446-.093-1.5-.376-1.362-.783-1.429-1.19-1.652-.4-.182-.785-.569-.927-2.082.074-.683.311-.823.546-.9s.476-.079.616-.288c.451.807.184,1.824.453,2.547l-.095-1.118a1.492,1.492,0,0,1,.535,1.144,8.723,8.723,0,0,0-.486-2.524c-.142-.509-.295-1.05-.412-1.564a7.973,7.973,0,0,1-.2-1.506c-.255-.248-.577-.713-.72-.413l.218.511c-.286.606-.857-.843-.867-.114a3.889,3.889,0,0,1-1.192-2.4l.549-.342c-.169.065-.19.753.063.992-.37-.358.421-1.757-.477-2.026l-.237.814c-.474-.651-1.359-1.4-1.362-2.356-.5.553.111.195-.43,1.006.723-.765.544,2.335,1.223,1.213-.635.862-.056,1.229-.518,2.273.188-.079.291-.405.4.379a.884.884,0,0,1,.218.121v.054l.011-.047c.039.025.046.026.005-.018a.855.855,0,0,1,.193-.465c.553.256.869,1.459,1.211,1.8.03.474-.276-.123-.418.179l.514.507c-.479.014-.205,1.919-.939.414l.434,1.488a7.868,7.868,0,0,0,.772,3.07c.17.862.964,1.25.506,1.036l.967,1.929-.054.181a18.186,18.186,0,0,0,1.338,2.808,14.273,14.273,0,0,1,1.257,4.009,6.773,6.773,0,0,1,1.064,2.27l.007-.012.1.776a7.7,7.7,0,0,1,.753-1.6,3.816,3.816,0,0,0,.551-1.645c.3.653.82-.444,1.32-1.826.242-.709.491-1.445.723-2.119l.328-.916a7.646,7.646,0,0,1,.3-.755l-.263-.79a24.66,24.66,0,0,0,1.079-4.178l-.376-.3a5.958,5.958,0,0,1,.69-2.21c.183-.393.391-.834.581-1.281a5.217,5.217,0,0,0,.339-.95c.142.135.007.455-.156.66,1.413-1.292.19-3.477,1.244-4.713a.989.989,0,0,1,.219-.858.206.206,0,0,0,0,.093,1,1,0,0,0,.04-.144c.116-.139.242-.279.356-.437a1.733,1.733,0,0,0-.337.358,4.648,4.648,0,0,0,.088-1.137l.509-.065.009-.1c.263-.362-.153-.372-.555-.24a2.08,2.08,0,0,0-.165-.6c.836-.154-.019-1.125.893-1.392-.323-.358.133-2.122-.671-2.507.112.007.188-.1.153.119a1.851,1.851,0,0,0,.211-1.329l.642-.079L135.831,134c.483-.537.728-.757,1.1-.067-.477-1.587-.075-1.236-.585-2.593l.383.125c.058-.448-.353-1.236.018-1.452.89-.886.816-4.9,1.72-7.407-1.215.39.641-1.151-.255-1.336.29-.125.481-.472.681-.033-.132-1.338.576-1.959-.119-2.923.286-.133.388.309.56.186-.053-.111-.214-.437-.04-.565s.219.209.328.427c.035-1.362-.809-1.543-1.6-1.682.414-.66.4-1.006-.119-1.517.267-.226.549-.614.625.226.049-.467.446-2.872-.2-2.93.167-.146.061-.658-.011-.783a12.27,12.27,0,0,0,.056-2.178l-.1.286c-.778-.4-.177-.855-.274-1.683l.079.023c.535-1.912-.279-.816.332-2.707l-.479.112c-1.041-.153.574-1.675.146-2.758l-.263.4c-.372-.583,1.353-1.708,1.464-2.317.086-.135.151.2.225.383.555-1.6-.637-.181-.832-1.345.33-.23.878.242.906-.549.263-.411-1.213-2.235-.621-3.342-.249.251-.5.5-.725-.03-.149-.821.853-2.315-.035-3.009a.282.282,0,0,1,.195-.165c-.258-.621-.513-2.04-1-2.382,1.62-.739-1.174-3.858.346-4l-.3-1.943.163.033a2.413,2.413,0,0,0-.9-2.045c.065-.3.235-.111.319-.1a3.976,3.976,0,0,0-1.03-3.44l.465-.239c-.349-.358.337-2.768-.609-4.443a.345.345,0,0,1,.258.151,8.684,8.684,0,0,1-.5-3.31c-.081-1.092-.3-2.006-1.283-2.11-.267-.395-.555-.785-.839-1.169.416,1.711-.83,0-.892.774-.3-.6-.06-1.84.318-1.079l-.044.154c1.023-.018-.455-2.171.128-2.377a16.388,16.388,0,0,0-1.652-2.973,5.533,5.533,0,0,0-2.538-2.085,3.652,3.652,0,0,0-3.147.342,6.775,6.775,0,0,0-2.373,2.414,5.469,5.469,0,0,1,.8.091c-.253.414-.56.818-.769,1.253-.305.249-.753.2-.186-.811-.328.133-.463.644-.509,1.076a1,1,0,0,0,.154.786c-.915,1.41-.537-.937-.746-.481l-.223.672.14-.114c.053.641.348.8-.035,1.717-.339.542-.53.158-.635.383-.049-.018-.1.054-.14.355-.179.458-.323.916-.484,1.374l.721-.39c.091.692-.407,1.281.407.832-.621.319-1.053,1.585-1.346,2.826a15.825,15.825,0,0,1-.653,2.714,5.779,5.779,0,0,1-.14,2.821c.161-.24.83-.286.6.6-1.281-.548-.843,1.56-1.9,2.157.721-.567-.2,2.61.848,1.7-.211.742-.506-.019-.9.516.291,1.869-.807,3.949-.839,6.214.174.051.476-.3.7.2l-.981,1.106c.051.451.978.49.307,1.25.156-.1.391-.255.427.046-1.2,4.336.154,8.973-1.553,13.388.356-.6.379-.193.383.267.088-.3.437.016.678-.039l-.692,1.855c.655.348.03,2,.665,2.2l-.112-.592c.748.786,1.673-1.085,2.635-.958-.837-.885,1.288-2.273.107-3.721.2-.309.3.276.532.114-.4-.372-.483-.811-.272-1.615l.1.095c-.023-2.273.414-3.233.821-5.757l-.486.161a2.067,2.067,0,0,1,.381-.9c-.686-.669-.123,1.532-.886.918,1-.672.244-3.862,1.388-4.271.068-.837-.569.205-.5-.634l.314-.2-.367-.24a.891.891,0,0,1,.755-.792,1.909,1.909,0,0,0,.049.528c.411-.681.049-2.013.188-2.247l-.253.786c-.079-2.312.607-5.041.3-7.306l-.246.137c-.188-1.734.425-1.308.507-3.168l.042.076a2.426,2.426,0,0,1-.086-1.4c.184.5.646-.781.834-.13-.123-1.868-.191-.943-.793-2.285l.421-.2a1.755,1.755,0,0,1-.328-1.467c.153.807.679-.458.916.456,1.2-1.692-.174-2.982,1.211-3.53-.776-1.118-.972,1.457-1.057.929-.428.326-.579-.9-.312-1.464.186-.6,1.538-.667,1.983-2.085-.053.14.019.174-.032.314.416-.448.019-1.155.655-1.638-.434-.576.365-.778-.321-1.2-.114.444-.249.874-.342,1.332.074-.779-.47-1.933.425-2.607a3.718,3.718,0,0,1,.119.821c.3-.1.121-.558.434-.616a.728.728,0,0,1,.06.851,2.559,2.559,0,0,0-.16.453,1.522,1.522,0,0,0-.023.742.46.46,0,0,0,.211-.334,1.4,1.4,0,0,0,.042-.4c0-.183.032-.277.358.04-.413-.416-.269-.618-.119-.737.169-.144.311-.193.274-.848l.226.534c0-.133.009-.506.133-.6a5.241,5.241,0,0,0,.1.878c-.023-.405.177-.4.328-.265.167.135.267.346.388.177-.244-.014-.295-.147-.318-.412s.025-.6-.186-.764c.23-.339.467-.316.59-.183a1.2,1.2,0,0,1,.205.669c.058.56-.014,1.1.223,1.208-.065.018-.1-.583.116-.714a1.214,1.214,0,0,1-.039.872c.14.132.232.054.314-.107s.139-.407.319-.386c-.154.323-.084.323.091.323a.939.939,0,0,1,.623.144l-.435.212c.311,1.55,1.113-.023,1.3,1.541l-.857-.374.439.681-.578.033a2.3,2.3,0,0,1,.751,1.841c.267-.288.883-.147,1.1.6-.14.59-.52-.165-.17.881-.358-.165-.793-.323-.486-.9-.163-.005-.36-.149-.523-.153-.167.627.3,1.376.4,1.762a1.086,1.086,0,0,1,.005-.442l1.03,1.39c-.123.288-.305.123-.493-.035.126.3.388.474.532.932-.411-.037-.8.077-1.127-.534l.75,1.388c-.147.135-.307.86-.49.7-.06.862,1.144,1.894,1.027,3.063a.71.71,0,0,1,.27.377c.084,1.067-.255,2.064.451,3.242l-.606.8c.291.96.757-1.08,1.236.525.365,1.137-.546.509-.692.939a2.581,2.581,0,0,1,.8,2.6,4.151,4.151,0,0,1-.186-.955m1.26,12.234c-.111-.233-.451-.692-.176-.881.569.242.319.467.176.881m1.218,18.743c-.149-.186-.053-.455.149-.757a1.289,1.289,0,0,1-.149.757m-13.184,33.589a.118.118,0,0,0,.032.023c.095.953.068.607-.032-.023m-.323-1.775c-.112-.139-.172-.1-.214-.007.151.072.27.435.37.879a.957.957,0,0,0-.156-.872m-.874-81.509.191-.177c-.028.534-.1.356-.191.177",
    transform: "translate(85.235 45.321)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M127.1,91.558a.523.523,0,0,1,.265-.091c-.079-.1-.174-.1-.265.091",
    transform: "translate(93.369 69.036)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M125.311,70.828v-.037a.241.241,0,0,0-.093-.023Z",
    transform: "translate(91.945 53.451)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M123.471,111.293c.074.007.144.081.212.176-.068-.186-.14-.286-.212-.176",
    transform: "translate(90.625 84.025)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M118.329,107.5l.3.678a1.089,1.089,0,0,1,0-.676c-.107.044-.232.218-.295,0",
    transform: "translate(86.741 81.198)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M119.362,103.775c-.077-.091-.049-.216-.128-.305l-.214.072c.1.435.337.7.342.233",
    transform: "translate(87.263 78.151)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M119.286,107.358c.386-.153.132-.555-.051-1.032a.4.4,0,0,1,.019.088c-.59-.014-.284.469.032.944",
    transform: "translate(87.187 80.308)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M119.169,106.458a1.964,1.964,0,0,1-.112-.453c-.233-.007-.005.195.112.453",
    transform: "translate(87.215 80.066)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M119.531,110.032c.037-.262-.542-.007-.42-.183-.57-.121,1.032,1.385.42.183",
    transform: "translate(87.238 82.964)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M120.008,106.51l-.446.291.462.179Z",
    transform: "translate(87.673 80.447)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M120.295,109.169l-.076-.809c-.079.033-.151-.054-.219-.167.1.484.158,1.032.295.976",
    transform: "translate(88.003 81.718)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M120.1,108.455a1.326,1.326,0,0,0-.237-.606,3,3,0,0,0,.237.606",
    transform: "translate(87.902 81.458)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M120.07,107.094l-.044.255.1.558Z",
    transform: "translate(88.023 80.888)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M121.66,113.933l.374.642a1.044,1.044,0,0,0-.075-.834c-.121,0-.269-.216-.3.191",
    transform: "translate(89.257 85.867)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M121.759,111.381a3.479,3.479,0,0,1-.17.744l.43-.737a1.439,1.439,0,0,1-.26-.007",
    transform: "translate(89.204 84.126)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M122.083,112.6c.119-.207.5-.132.263-.7-.095.274-.376-.079-.263.7",
    transform: "translate(89.557 84.513)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M124.242,112.189l-.058.209.639,1.313c-.188-.523-.372-1.006-.581-1.522",
    transform: "translate(91.164 84.736)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M124.613,105.675c-.462.936.567.381.049,1.2.177.29.427-.672.57-.386-.111-.66.1-.941-.62-.818",
    transform: "translate(91.395 79.795)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M124.912,106.129a2.488,2.488,0,0,0,.075.342,1,1,0,0,0-.075-.342",
    transform: "translate(91.714 80.159)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M116.331,87.683l-.216.672.346-.434Z",
    transform: "translate(85.069 66.227)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M116.948,88.42l-.653.156.588.4c-.028-.151-.083-.446.065-.56",
    transform: "translate(85.205 66.784)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M126.013,83.338l.16.044c.165-.109.17-.263.184-.571Z",
    transform: "translate(92.545 62.547)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M125.988,78.112v.154l.563-.334Z",
    transform: "translate(92.526 58.863)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M125.132,73.881c.012.3.186.639.2.943-.184-.639.523-1.115-.2-.943",
    transform: "translate(91.88 55.776)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M123.846,117.412c.162.251.413-.105.5-.121-.379-.307-.576.2-.5.121",
    transform: "translate(90.896 88.514)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M121.79,115.341l.2-.018-.813-.435Z",
    transform: "translate(88.89 86.775)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M119.913,112.668c-.355.807,1.123,1.527,1.411,2.445l-.053.219.709.03c-.686-.892-1.82-1.91-2.068-2.694",
    transform: "translate(87.897 85.098)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M119.928,110.865c-.154.286-.514-.386.255.592a1.067,1.067,0,0,1,0-.135,4.622,4.622,0,0,1-.256-.456",
    transform: "translate(87.783 83.736)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M119.979,111.175c.3.453.019-.423,0,0",
    transform: "translate(87.988 83.881)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M119.192,110.14l.563.5c.072-.212-.2-.783.016-.635-.474-.569-.546-.362-.579.135",
    transform: "translate(87.393 82.829)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M118.743,109.742l.274.274c.028-.091,0-.188-.274-.274",
    transform: "translate(87.054 82.888)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M119.511,110.475l-.577-.577c-.051.146-.247.27.247.276-.218.047.037.084.33.3",
    transform: "translate(87.136 83.006)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M119.441,110.48c.06.428.228.934-.337.427.776,1.141,1.1.714.337-.427",
    transform: "translate(87.327 83.446)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M119.452,112.768l.105.579.46.269c-.237-.13-.393-1-.565-.848",
    transform: "translate(87.59 85.161)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M118.37,107.6c-.156.028-.256.4-.406.532l.393.391c-.028-.29-.174-.79.012-.923",
    transform: "translate(86.466 81.273)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M118.22,108.159l-.592-.588c.291.644.462.7.592.588",
    transform: "translate(86.212 81.248)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M118.366,109.99l1.118.876-1.248-1.094Z",
    transform: "translate(86.671 82.911)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M117.6,106.165l.5.255-.809-.495Z",
    transform: "translate(85.957 80.005)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M117.167,105.669c.4.181.269-.607.577-.363a4.473,4.473,0,0,0-1.043-1.087,2.522,2.522,0,0,1,.465,1.45",
    transform: "translate(85.513 78.717)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M116.383,103.922a4.18,4.18,0,0,0,.56.521,2.26,2.26,0,0,0-.56-.521",
    transform: "translate(85.272 78.492)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M117.376,107.189a.893.893,0,0,0,.139-.753l-.262.467c.039.088.081.186.123.286",
    transform: "translate(85.929 80.391)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M117.356,106.986l.009-.016-.256-.623c.032.081.105.274.247.639",
    transform: "translate(85.819 80.324)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M117.361,106.938l-.03-.072c-.026.046-.032.068.03.072",
    transform: "translate(85.974 80.716)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M118.373,108.985c-.423-.305-1.1-1.064-.993-.049.414.165.355-.412.993.049",
    transform: "translate(86.016 81.893)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M117.163,107.237l.293.8c.095-.065.174-.274.386-.119Z",
    transform: "translate(85.861 80.996)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M116.989,107.059c.095.107.2.209.305.312l-.109-.295Z",
    transform: "translate(85.729 80.862)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M116.76,105.21a2.75,2.75,0,0,1-.664-1.029,6.239,6.239,0,0,0,.43,1.39c.151.009.46.1.233-.362",
    transform: "translate(85.056 78.688)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M116.857,105.747l-.056-.063c-.012.06-.007.1.056.063",
    transform: "translate(85.583 79.823)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M115.226,101.835l-.051.093.076-.009Z",
    transform: "translate(84.359 76.916)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M116.334,105.079a.931.931,0,0,0,.465.653,5.942,5.942,0,0,1-.425-.758c-.068,0-.107.007-.04.105",
    transform: "translate(85.208 79.286)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M116.025,103.317a4.721,4.721,0,0,0,.009.665c.06-.221.119-.644-.009-.665",
    transform: "translate(84.995 78.035)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M116.833,105.619a.307.307,0,0,1,.04.042c.035-.146,0-.114-.04-.042",
    transform: "translate(85.611 79.728)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M117.021,105.735a2.168,2.168,0,0,0-.437-.33,3.154,3.154,0,0,0,.379.49.542.542,0,0,1,.058-.16",
    transform: "translate(85.423 79.612)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M113.543,102.041c.4-.061,1.053.737.918,1.678.542.685,1.6-.286,2.068-1.194-.172.035-.323.09-.809-.625-.114.344.109,1.931-.455,1.38-.548-.992-.156-.915-.128-1.5-.323.6-1.136-1.12-1.754-.667l.558.86c-.1.053-.388-.232-.4.063",
    transform: "translate(83.006 76.316)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M115.638,103.392l.172.3a3,3,0,0,1,.082-1.285c-.362-.469-.537-.532-.676-.525.153.539.321,1.072.52,1.6Z",
    transform: "translate(84.391 76.951)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M116.4,104.338c-.5-.086-.976-.79-1.227-.147.4.932.6.527.993,1.016-.7-1.473.395.342.191-.839a5.317,5.317,0,0,1,.428.769,7.2,7.2,0,0,1-.125-.85l-.011.044,0,.007h-.007c-.025.086-.046.119-.046.035-.007,0-.016-.021-.021-.028a.441.441,0,0,1-.179-.009c-.088-.467.077-.109.179.009a.432.432,0,0,0,.067-.007l0-.007-.816-1.418a6.986,6.986,0,0,0,.565,1.425",
    transform: "translate(84.361 77.73)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M116.693,108.571a.117.117,0,0,1,.065-.093c-.095-.072-.146-.091-.065.093",
    transform: "translate(85.476 81.895)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M116.633,108.605c.109.081.311.093.446.462.039.36-.184.091-.3.172.207.16.648.6.5-.16l-.105-.077c-.169-.662-.067-1.655.042-1.578a2.81,2.81,0,0,0-.581,1.181",
    transform: "translate(85.46 81.134)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M116.488,106.407l-.758-1.16-.056.785.191-.123c.24.748.425.481.623.5",
    transform: "translate(84.736 79.493)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M115.45,101.929l.488.018-.855-.523Z",
    transform: "translate(84.29 76.605)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M114.948,100.961l.4-.063-.374-.362Z",
    transform: "translate(84.188 75.935)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M131.7,66.057l.276.346a1.765,1.765,0,0,0-.276-.346",
    transform: "translate(96.838 49.893)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M131.052,64.453l-.207.021c.158.079.256.1.207-.021",
    transform: "translate(96.195 48.681)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M113.9,77.041c.462-.507,1.146-1.029.7-1.044l-.463.095a1.825,1.825,0,0,1-.233.95",
    transform: "translate(83.394 57.401)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M119.184,60.673l-.221.018c-.009.207-.018.393-.007.576a5.479,5.479,0,0,1,.228-.593",
    transform: "translate(87.211 45.826)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M118.6,59.874a8,8,0,0,1,.86-.332,2.7,2.7,0,0,0-.86.332",
    transform: "translate(86.945 44.972)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M134.639,75.09l.53.4c-.151-.753-.3-.379-.53-.4",
    transform: "translate(99.06 56.657)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M112.975,91.405a4.533,4.533,0,0,0,.211-1.237c-.225.6-.579,1.1-.211,1.237",
    transform: "translate(82.577 68.104)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M129.02,66.542c.169.184.291.24.376.195-.167-.195-.3-.286-.376-.195",
    transform: "translate(94.816 50.233)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M113.03,89.362c-.04.088-.058.172-.091.262a4.176,4.176,0,0,1,.154,1.153,1.46,1.46,0,0,0-.063-1.415",
    transform: "translate(82.67 67.495)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M130.839,108.4a1.4,1.4,0,0,1-.109.1c.047.037.079-.016.109-.1",
    transform: "translate(96.108 81.872)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M123.695,115.708c.077-.144.226-.367.365-.576a2.034,2.034,0,0,0-.365.576",
    transform: "translate(90.794 86.959)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M113.977,96.912c.1.355.058.046,0,0",
    transform: "translate(83.454 73.198)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M113.378,98.183a.279.279,0,0,0-.244-.093.353.353,0,0,1,.244.093",
    transform: "translate(82.818 74.085)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M111.455,87.24l0-.033c-.086.112-.07.093,0,.033",
    transform: "translate(81.506 65.867)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M113.934,97.457c.009-.146.032-.314.028-.49a2.061,2.061,0,0,0-.028.49",
    transform: "translate(83.42 73.239)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M114.036,97.178c.018.126.03.226.042.321.083.028.118-.023-.042-.321",
    transform: "translate(83.499 73.399)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M113.908,96.629a3.11,3.11,0,0,1,.072.593c.014-.077.032-.112.049-.1-.025-.105-.061-.253-.121-.5",
    transform: "translate(83.402 72.984)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M134.956,90.759a.753.753,0,0,1-.044.081c.163.4.142.23.044-.081",
    transform: "translate(99.267 68.55)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M112.654,70.51c0,.019.007.032.007.049l.032-.051Z",
    transform: "translate(82.455 53.255)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M112.735,69.686a1.25,1.25,0,0,1-.058,1.441l1.339-.086Z",
    transform: "translate(82.472 52.634)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M150.509,78.993l.084-1.071c.967.962,1.009,1.878,1.264.811-1.32.262-1.334-3.7-2.7-3.368l.04-.72c.053.183.139.183.191.363.168-1.445-1.259-.544-1.689-2.136-.121-.57-.116-1.016.2-.721l-.832-1.039c-.128-.353.123-.37.253-.018-.3-.585-.641-1.157-.958-1.732l.042-.005a10.531,10.531,0,0,1-1.187-.764c-.067-.534.246.149.335-.044-.274-.265-.53-.535-.82-.788.076-.563.848.044,1.155.746.688-1.575-.7-.635-1.236-2.959.249.265.5.534.721.809a1.744,1.744,0,0,0-.137-1.32,13.466,13.466,0,0,1-.623-1.55c.03.405.4,2.735-.562,1.9a1.85,1.85,0,0,0-.951-1.113c.381-.3-.09-.758-.665-1.366l.527-.374c-.734-.583-.937-.3-1.52-.486a1.724,1.724,0,0,1-.407-1.752c-1.227-1.209.351,1.367-1.227.149a5.86,5.86,0,0,0-3.739-1.75c-.9-.537.311-.311.023-.6-.36.058-.709.125-1.043.2-.209-.081-.105-.2-.046-.276-.814.035-.23.6-1.4.555-.2.353-.732.011-1.49-.216a2.4,2.4,0,0,0-2.347.276c-.395-.065.058-.434-.111-.639l-1.029.648c-.235.177-.393.316-.542.448a5.274,5.274,0,0,0-1,1.241,10.894,10.894,0,0,0-1.309.39c1.065-.161.36.981-.009,1.985.386-.03.707-.04.9-.077-.293.427-.609.806-.86,1.25-.2.051-.253-.209-.265-.579-.037.112-.067.219-.086.307-.544.218-.625-.232-.59-.781a4.606,4.606,0,0,1,.683-.1c.023-.541.032-1.123-.274-1.357a1.521,1.521,0,0,1-.3.491c.009-.149,0-.265-.081-.281s-.126.211-.218.511l-.769-.249.135.27a21.063,21.063,0,0,0-1.813,1.329c-.423,1.692-.307,3.319-1.178,5.438-.176-.755-.685-.534-1.215-.867.9-.221.7-1.729,1.534-2.7-.421.5-.588.219-.579.019-.267.735-.495,1.471-.69,2.208-.409-.3-.586.205-1.036.616,1.083.107-.2,1.757-.286,2.694-.33-.1-.548-.439.005-1.38-1.208.753.369,1.9-.672,2.68.1-.242.2-.349.088-.516.016.679-.785,1.955-.915,1.522l.091-.246c-.823,1.557-1.857,4.973-1.109,5.471a4.98,4.98,0,0,1-1.039-.685c.585,1.281,1.216,2.531,1.864,3.751-.632-.463-2.6.068-2.607-1.429a2.9,2.9,0,0,0-.449,1.741c.176-.247,1.209-.395,1.173-.011-1.065.8-.618.583-1.6,1.673.255-.37,1.259.362,1.067.988-.144-.14-1.12-.211-1.178-.474.228.623.483,1.245.732,1.859-.111-.442-.92-.281-1.311.014.249-.121-.328,1.4-.295,1.854l.393-.635c-.528,1.8,1.2,2.1.832,3.883-.193-.255-1.323-.785-1.624.118.5.528,2.445,2.31,2.679,3.932l-.367.26.216,1.257a20.443,20.443,0,0,1-2.816-4.543c-.365.649-.416.133-.542,1.174-.363.321-.381-.635-.353-.944-.188.8-.381,1.6-.546,2.4.686-.018.427,1.94,1.008,1.912l-.358-2.71c.688-.005,1.687,1.766,1.385,3.437-.314.4-1.16-.456-1.388-.449a2.916,2.916,0,0,1,.082,1.811l-.279-.764c-.363.932.737,1.641-.009,2.728-.083.39-.969,1.115-.57,1.215a4.644,4.644,0,0,1,3.749-.054,14.9,14.9,0,0,1-1.285,2.4c-.642.611-1.378-1.055-1.929-.537.183.035.383.407.451.562-.177.405-.562-.205-.523.7.678.186-.147,1.831.558.455.156.89-.2.929-.193,1.966.451-.312,1.478.974,1.648,1.847-.172-.056-.405.135-.509.228a39.807,39.807,0,0,0-.326,4.432c-.16.158-.327.981-.635.646a1.91,1.91,0,0,1,.412.971c-.549,1.044-.142-1.16-.82-.353.4.047.606,1.327.886,2.048.6-.277.044-1.711-.235-2.449.858-.035,1.761,1.2,2.278,2.865.377,1.329-.472.641-.323.864.181,2.579,1.708,1.975,1.413,4.148-.369.914-1.053.218-1.4.465-.427-1.072.1-1.764-.03-2.508l-.139.965a2.342,2.342,0,0,1-.344-1.487,7.056,7.056,0,0,0,.07,2.738,20.719,20.719,0,0,1,.467,3.681c.247.314.549.876.706.541l-.2-.606c.312-.66.818,1.034.862.207a5.826,5.826,0,0,1,1.25,2.744l-.539.374c.167-.072.154-.841-.114-1.116.391.4-.332,1.978.586,2.285l.2-.916a6.627,6.627,0,0,1,1.546,2.579c.434-.627-.144-.207.307-1.111-.685.867-.644-2.552-1.276-1.313.6-.948,0-1.357.428-2.473-.19.077-.288.428-.414-.428a.941.941,0,0,1-.223-.142l0-.06-.011.053c-.039-.03-.046-.032,0,.018a.938.938,0,0,1-.186.5c-.6-.3-.827-1.669-1.16-2.078-.007-.528.27.163.428-.158l-.491-.614c.43-.16.472-1.481.965-.348l-.191-1.067a3.971,3.971,0,0,0-.179-2.048c.035-.516-.653-1.208-.247-.814l-.486-1.65.111-.028c-.214-1.65-1-3.4-.291-5.34a4.671,4.671,0,0,1-.181-2.1l.393-.184c-.133-.739.411-2.2.023-2.528,1.062-.762.349-3.551.625-4.834l-.506-.081a14.87,14.87,0,0,0-.105-2.868l-.455.028c-.295-.99.544-2.424.671-3.927.16.123.074.5-.06.755,1.2-1.664-.256-3.877.732-5.392a1.19,1.19,0,0,1,.17-.974.249.249,0,0,0,.005.1,1.414,1.414,0,0,0,.035-.163c.107-.163.228-.33.332-.514a1.91,1.91,0,0,0-.318.427,6.639,6.639,0,0,0,.039-1.271l.514-.107c0-.039,0-.068.007-.107.263-.414-.154-.4-.56-.232a2.465,2.465,0,0,0-.167-.664c.843-.211-.028-1.262.906-1.585-.334-.393.209-2.352-.548-2.8.112.011.2-.111.142.137a2.362,2.362,0,0,0,.323-1.483l.655-.056-.5-1.318c.544-.572.837-.778,1.1.009-.226-1.787.105-1.36-.149-2.921l.356.188c.146-.479-.107-1.42.305-1.6.549-.405,1.041-1.7,1.673-3.165a15.1,15.1,0,0,1,2.438-4.13c-1.292-.116,1.106-.853.388-1.406.319,0,.651-.237.623.272.534-1.336,1.51-1.453,1.49-2.663.316.058.128.474.346.472.021-.116.09-.474.305-.472s.051.3.012.53c.811-1.048.316-1.7-.19-2.343.772-.27.992-.49,1.048-1.25.365.037.836,0,.246.623.188-.158.822-.525,1.371-.867s1.041-.644.936-.944a.473.473,0,0,0,.386-.1,1.145,1.145,0,0,0,.316-.212,4.833,4.833,0,0,1,1.036-.216c.267-.06.53-.072,1.02-.133l-.279-.086c.367-.809.867-.218,1.676-.174l-.039.074.878.427a1,1,0,0,0,.39.075c.205,0,.437.053,1.12.764l.142-.476c.323-.4.669-.049,1,.469a8.538,8.538,0,0,0,.53.809,1.579,1.579,0,0,0,.685.616l-.135-.483c.365.075.472.644.476,1.257a5.346,5.346,0,0,0,.09,1.508c.018.16-.246-.065-.412-.16.549,1.6.621-.279,1.5.592-.135.388-.857.305-.423.985.016.232.569.553,1.144,1.008a2.5,2.5,0,0,1,1.137,1.72c.107-.351.211-.711.667-.283.539.767.256,2.624,1.339,3.03a.286.286,0,0,1-.121.237c.5.544,1.223,1.966,1.8,2.2-.655.611-.083,1.56.46,2.457s1.051,1.732.309,1.954c.232.693.488,1.378.7,2.08l-.167-.014a3.124,3.124,0,0,0,1.227,2.159c-.023.342-.218.144-.3.139a5.41,5.41,0,0,0,1.39,3.79l-.455.276c.383.413-.19,3.061.669,4.968a.372.372,0,0,1-.255-.186c.95,2.18-.669,5.545,1.216,6.186l.579,1.464c-.033-1.966.811.221,1.039-.611.176.767-.367,2.041-.544,1.1l.077-.156c-.958-.27-.154,2.457-.8,2.447a45.853,45.853,0,0,1,.018,5.684q-.079,1.4-.156,2.772c-.091.9-.17,1.785-.218,2.665l.753-.377-.095,1.237c-.184.318-.592.4-.525-.474-.435.437.286,1.492.446,1.534-.37,1.7-.827-.737-.867-.207l.025.714.093-.153c.263.6.548.683.39,1.734-.228.651-.493.291-.553.551-.053-.009-.088.077-.07.4l-.251,1.531.649-.537c.2.727-.209,1.459.53.836-.528.462-.911,1.875-1.192,3.256a12.009,12.009,0,0,1-.716,3.007,6.721,6.721,0,0,1-.458,3.116c.193-.253.869-.251.523.734-.607-.376-.839.049-1.137.607s-.586,1.28-1.176,1.518c.844-.5-.771,2.816.458,2.015-.376.781-.491-.119-1,.39-.272,2.082-1.908,4.076-2.828,6.41.144.109.565-.167.581.439l-1.35.841c-.121.49.725.858-.235,1.4.191-.049.479-.123.379.2a58.641,58.641,0,0,0-3.746,6.574,17.962,17.962,0,0,1-4.724,5.98c.665-.362.437.03.153.463.258-.23.353.258.586.342-.576.456-1.185.879-1.771,1.315.316.716-1.318,1.813-.958,2.37l.321-.592c.042,1.174,2.08.033,2.775.709-.077-1.32,2.636-1.446,2.584-3.544.374-.195.075.435.374.4-.093-.585.123-1.053.793-1.757l.026.147a26.177,26.177,0,0,1,1.894-2.712c.611-.8,1.336-1.585,2.175-2.854l-.523-.039a2.7,2.7,0,0,1,.82-.79c-.269-1-.923,1.575-1.285.588.628-.135,1.188-1.134,1.745-2.094s1.043-1.917,1.671-1.927c.458-.893-.625.014-.169-.876l.388-.105-.232-.395c.355-.555.837-.69,1.071-.607a3.455,3.455,0,0,0-.193.6c.706-.611.9-2.247,1.129-2.461l-.565.806c.913-2.589,2.529-5.561,2.851-8.26l-.276.114c.242-2.043.744-1.45,1.26-3.611l.026.093a4.061,4.061,0,0,1,.156-1.662c.109.614.765-.878.855-.09.139-2.24-.054-1.148-.492-2.744l.448-.23a2.573,2.573,0,0,1-.23-1.725c.137.955.692-.569.908.52,1.253-2.129-.139-3.537,1.243-4.38-.816-1.213-.953,1.876-1.057,1.253-.43.425-.585-.992-.353-1.68.111-.72,1.459-1.044,1.669-2.921-.028.184.047.205.021.391.348-.672-.186-1.4.342-2.22-.558-.532.1-1.12-.681-1.315a14.9,14.9,0,0,1,.053,1.722c-.051-.988-1.025-1.954-.481-3.507a2.731,2.731,0,0,1,.449.946c.255-.456-.118-.906.144-1.38.79.169.086,2.091.644,3.184.358-.486-.49-2.027.349-1.445-1.064-.816.218-1.864-.567-3.163l.474.091a2.782,2.782,0,0,1-.253-.993c.207.221.4.449.6.676-.479-1.041.458-1.976.176-2.961.035,2.052-.57.469-.911,1.336-.662-2.5,1.232-1.467.925-4.3.079.383-.242,1.45-.481.858a4.756,4.756,0,0,1,.47-1.6c-.191-1.871-.476.311-.807-.472.546-.665-.277-.907-.513-1.711l.484-.035c.161-2.148-1.044-.5-.807-2.428l.728.755-.247-.983.567.161a3.862,3.862,0,0,1-.37-2.48c-.314.281-.89-.053-1.009-.985.218-.669.5.309.284-1.013.333.263.748.555.369,1.183.163.042.335.265.5.309a4.984,4.984,0,0,0-.179-2.233,1.378,1.378,0,0,1-.049.537l-.913-1.847c.14-.326.318-.107.49.114a11.714,11.714,0,0,1-.481-1.192c.413.091.814,0,1.1.792-.219-.6-.462-1.192-.7-1.783.151-.147.321-1.018.5-.8.063-1.069-1.164-2.382-1.134-3.779a.928.928,0,0,1-.3-.456c-.16-1.278.061-2.51-.825-3.877l.476-1.018c-.446-1.129-.574,1.359-1.324-.509-.59-1.3.442-.665.5-1.2a3.862,3.862,0,0,1-1.409-2.966,5.333,5.333,0,0,1,.425,1.1m-6.454-13.579c.247.19.855.52.727.86-.651.009-.576-.344-.727-.86M123.563,63.6c.014-.276.305-.476.709-.618a2.375,2.375,0,0,1-.709.618m-7.944,58.827a.124.124,0,0,0-.028-.025c.068-.621.037-.4.028.025m.037,1.264c.091.111.156.09.212.026-.139-.063-.2-.339-.23-.658-.107.109-.161.284.018.632m34.323-4.425.156-.228c.07.565-.035.4-.156.228",
    transform: "translate(80.64 43.799)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M118.649,59.865a.459.459,0,0,1,.27.114c.037-.14-.021-.216-.27-.114",
    transform: "translate(86.983 45.181)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M134.583,75.015l0,.046a.2.2,0,0,0,.095.026Z",
    transform: "translate(99.018 56.659)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M110.453,84.449a1.1,1.1,0,0,1,.283-.5c-.116-.023-.23.093-.283.5",
    transform: "translate(80.793 63.402)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M114.785,99.3l-.328-.735a1.3,1.3,0,0,1,.033.735c.1-.047.223-.239.295,0",
    transform: "translate(83.817 74.442)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M114.282,103.452c.1.091.1.237.2.326l.2-.112c-.2-.472-.5-.742-.4-.214",
    transform: "translate(83.669 77.919)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M113.952,99.642c-.367.174-.128.639.139,1.155a.7.7,0,0,1-.033-.1c.6-.009.218-.525-.105-1.058",
    transform: "translate(83.293 75.26)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M113.981,100.369a2.379,2.379,0,0,1,.177.5c.239-.007-.023-.218-.177-.5",
    transform: "translate(83.457 75.809)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M113.709,96.5c-.051.283.542.054.409.237.567.184-.958-1.606-.409-.237",
    transform: "translate(83.16 72.494)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M113.225,100.348l.428-.344-.472-.2Z",
    transform: "translate(82.853 75.384)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M112.735,97.551l.1.923c.079-.033.156.067.23.2-.13-.551-.193-1.174-.334-1.12",
    transform: "translate(82.516 73.678)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M112.926,98.188a1.763,1.763,0,0,0,.272.7,3.858,3.858,0,0,0-.272-.7",
    transform: "translate(82.661 74.161)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M112.981,99.844l.03-.293-.133-.641Z",
    transform: "translate(82.624 74.707)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M112.071,92.416a7.8,7.8,0,0,1-.225-.988c-.176-.089-.272.193-.184.563.149.23.262.593.409.425",
    transform: "translate(81.681 69.043)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M111.442,94.02c.07-.29.179-.321.325-.5l-.623.049Z",
    transform: "translate(81.315 70.638)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M111.246,92.429c-.2-.082-.655-1.445-.479-.146.184.09.453,1.1.479.146",
    transform: "translate(81 69.28)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M111.49,83.4l-.009.258,1.023.032Z",
    transform: "translate(81.569 62.99)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M111.113,75.57c-.455,1.166.57.4.079,1.436.19.323.4-.846.556-.52-.128-.771.093-1.127-.635-.916",
    transform: "translate(81.201 57.033)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M111.424,76.066a2.788,2.788,0,0,0,.09.4,1.326,1.326,0,0,0-.09-.4",
    transform: "translate(81.526 57.453)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M122.778,116.527l-.62.456.562-.167Z",
    transform: "translate(89.633 88.013)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M122.613,117.553l-.614-.279.184.7c.079-.135.233-.411.43-.423",
    transform: "translate(89.513 88.577)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M129.382,60.682l-.167.047c-.037.211.077.379.3.721-.044-.255-.072-.514-.133-.769",
    transform: "translate(94.958 45.833)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M132.459,66.529l-.06-.181-.412.551Z",
    transform: "translate(97.057 50.113)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M134.484,71.767c-.076-.367-.318-.757-.393-1.125.318.762-.291,1.413.393,1.125",
    transform: "translate(98.646 53.356)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M125.3,92.556c-.046-.72-.2.388-.082-.47a.448.448,0,0,1,.082.47",
    transform: "translate(91.91 69.553)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M129.415,111.256c-.585-2.31-.035-5.364-.451-7.894-.03-.3.316.07.226-.6a40.179,40.179,0,0,1-.109-9.326l.095.177c.042-.572-.281-1.257-.267-1.861.06-.009.093.19.167.046-.183-.144-.13-1.088-.276-1.338.06-.242.2-.226.263-.539l-.219-.335c-.528-.936-.086-2.335-.414-3.63.051.06.095.188.135.081-.416-2.085-.546-4.715-.86-7.049.079.086.218.161.284.018-.221-.1-.341-.816-.442-1.439.191-.3-.3-1.055-.263-1.8l.056.056c-.288-.518.042-.82-.283-1.229l.132-.363c-.335-.2.063-.8-.153-1.232l-.061.023c-.13-.411-.007-.651-.114-1.034l.03-.042c-.212-.9-.135-1.457-.369-1.4.139-.351.23.867.427.321q-.271-1.106-.548-2.22a18.664,18.664,0,0,0-.6-1.983,3.3,3.3,0,0,0-.477-.9.48.48,0,0,0-.444-.205.69.69,0,0,0-.391.316,6.754,6.754,0,0,0-.727,1.91c-.156.214-.233.416-.332.442a7,7,0,0,0-.123,1.446c.014-.1-.16.172-.2.33-.184.535.158.642-.042,1.229-.028-.249-.091-.344-.193-.277a9.061,9.061,0,0,1-.047,1.85c-.026-.1-.03-.251-.109-.239.121.7-.205,1.216-.14,1.82l-.112-.237c-.279.927.256.312.065,1.12-.023-.2-.084-.139-.137-.181a17.187,17.187,0,0,1-.03,2.789.046.046,0,0,0-.053-.039,26.1,26.1,0,0,0-.165,2.619c-.088.328-.332-.135-.349.75.281-.011,0,1.506.358,1.009a14.011,14.011,0,0,0-.225,2.44c-.084-.346-.365.346-.348-.283l-.2.463c-.111-.079.07-.486-.083-.344a14.9,14.9,0,0,1-.018,1.515,6.953,6.953,0,0,1,.411,2.089c-.086-.449-.323.235-.355-.068l.469,1.341c0,.314-.225.058-.174.514.076-.021.111.179.165.319-.039.116.009,1.3-.272,1.429-.114.133-.035-.513-.149-.17-.021.579.072.609.051,1.188l-.037.009c-.056.383.072,1.132.24.723.019-.267-.169.093-.074-.3a3.949,3.949,0,0,1,.149,1.529c-.037-.2-.111-.177-.186-.26a15.379,15.379,0,0,1,.29,2.482c.132.018-.226-.33-.153-.456-.219,1.108.186,2.306-.1,3.226-.019-.153.188-.077.151-.068-.03.535-.219.507-.158.858-.112.032.026.441.051.8.077.188-.056.093-.061-.221a16.531,16.531,0,0,1,.033,3.669,2.2,2.2,0,0,1,.247.981l-.172-.107c-.105.242,0,.893-.146.936.2.572-.147-2.194,0-1.422-.146.2.26,1.076.028.907a4.983,4.983,0,0,1,.019,1.564c.028-.147-.233-.437-.226,0,.023.76.079.218.132.834l.067.388c.167.028-.028.679.161.4-.139.093.077,1.106-.2,1.025l-.218-.105c.014.328.226.539.323.8-.021.042-.065.128-.1.112.334.054-.032.785.226,1.176a11.617,11.617,0,0,1-.216,2.077,4.942,4.942,0,0,1,.167,1.615c-.033-.119-.044-.284-.118-.318a1.477,1.477,0,0,0,.053.818,7.144,7.144,0,0,0-.3,1.183c.105.525.284.342.395.393-.332.488.242,1.48-.04,2.089-.051-.181-.184-.764-.256-.325-.316.49.272.964.135,1.743l.269-.2c-.16.351.191,1.136-.091,1.065.107.256-.065.916.2.822-.179,1.281.272,3.086-.176,3.891.053.179.028.637.162.537.135-.311-.126-.418-.03-.535.016.163.091.195.128.211-.044.4-.049.711-.288.348-.128.89.506.885.465,2.008-.114-.044-.151.044-.114.37l.226.609c0,.727-.226.427-.412.456a2.576,2.576,0,0,0,.225,1.025l-.207.486c.147-.355.135.311.2.488l-.06-.177c-.074.077.009.52.049.744.112-.061.125-.521.14-.772.1.191.1.5.218.755-.191-.074-.084.639-.081.948-.012.356.195.384.2.488-.095.016.026.576-.128.312-.039-.118.072-.283-.026-.474-.053.237-.221.223-.063.7.118.356.355-.121.29.576-.06-.177-.135-.2-.211-.339l-.047.653.169.014c-.035.09-.054.032-.074.074.186.177.139.979.349,1.108a9.069,9.069,0,0,1-.047,1.006l-.019-.058a2.289,2.289,0,0,0,.186,1.2l-.039-.014a2.972,2.972,0,0,0,.2.944c-.074.535-.614.237-.346.8.06.53.391.8.476.577a20.564,20.564,0,0,1,.2,2.928c.082.13.114.039.186.316a22.205,22.205,0,0,1,.348,4.076c-.119-.4-.17-.007-.263.014.19.316-.105.421.165.509.147-.053.225-.028.237-.428a10.129,10.129,0,0,1,.27,2.564c.039-.24.107-.068.177.109-.247-.03-.2.59-.054,1.041l.156.046-.109.323c.07.172.332.153.258.632a.26.26,0,0,0-.135.156,3.97,3.97,0,0,1,.441,1.645l-.147.456c.056.219.242.572.244.172a6.118,6.118,0,0,1-.058,1.789,16.681,16.681,0,0,1,1.06,3.56h-2.452c.112-.628.223-1.248.325-1.822l.1.07c.184-.455-.147-.277-.018-.6.079.17.286-.325.351.07.226-.66-.044-.907-.021-1.357-.133-.089.033.37-.135.256-.037-.084.262-.923.061-1.064.111-.156.249,0,.323.107l-.04-.434c.332-.47.272,1.232.667.746l.026-.39c.283-.332.1,1.058.325.1-.042-.435-.3-.843-.455-.484.074-.879-.449-.481-.295-1.415.165-.237-.079.755.125.6.242-.414.032-.9.151-1.283-.146.425-.311.023-.311-.263.172-.462.161.339.281-.334-.109-.13-.112-.762-.277-.239-.247-.283.179-.69.007-1.088.23-.193.369.76.569.03-.209.091-.139-.951-.477-.6.1-.283.251-.293.341-.065.176-.4-.214-1.055.186-1.141l-.179-.168c.083-.121.156-.3.288-.5.049-.369-.119-1.216.174-1.146-.016-.121.1-.957-.144-.66-.191.506.075.618-.239.872.272-.339.063-.753.025-1.064l.121-.035c-.023-.184.054-.593-.056-.72.049.144.135.083.181-.056l-.153-.209c-.005-.739.328-.135.356-.851l.075.555c-.016-.121.176-.344.16-.69-.146-.151-.309-.42-.421-.548-.025-.407.2-.158.081-.57l.135.537c.044.084.3-.318.36-.853-.018-.348-.188-.9-.337-.372.028-.269.167-.634.26-.409.009-.613-.179.061-.225-.472.128-.2.348-.855.544-1.243l.212.576.039-.365c.168.495.19-.221.388.067a2.273,2.273,0,0,0-.019-.8c-.437.692-.414-.865-.767-.686.009-1,.872-.546.444-1.636-.1.163-.311-.351-.27.286.091-.616-.295-.451-.093-1.171.088.555.388-.551.516.249-.105-.061-.123.43-.1.553.149-.244.33.084.386-.553,0-.39.042-.922-.137-.86-.191,0-.032.593-.2.328,0-.778.3-.881-.007-1.23-.018.49-.223.6-.353.576l-.03-.574.118.121c.17-.9-.2-.288-.1-1.165l.279-.393c.2.228-.2,1.274.163,1.146.067-.57-.1-.776.032-1.309.021.123.018.288.04.409.026-.2.506-.372.295-1.211-.074-.43-.116-.121-.246-.142.028-.923-.084-1.208-.061-1.8.248.14.1-1.046.316-.374a3.363,3.363,0,0,0-.037,1.968c.328-.312-.1.72.195.943.063-.739.358-.681.562-.786a1.614,1.614,0,0,0-.06-.534c-.177-.1-.195.169-.384.169a5.414,5.414,0,0,0-.077-2.089c.105-.27.286-.17.281.158a27.473,27.473,0,0,1,.205-2.965c-.335.585-.009-1.044-.283-.648-.1.5-.337.913-.455.63.037-.311.13.018.2-.109-.14-.407.3-.6.065-1.008.044.9.356.195.583.372-.095-.655.165.037.2-.6a19.161,19.161,0,0,1-.186-2.171,13.183,13.183,0,0,0,.125-3.088c.132-.416.39-.121.448-.579.011-.535-.3.39-.154-.4l.051.079c-.054-.242.221-1.453-.154-1.7l.283.253a.973.973,0,0,0-.06-.409c.093,0,.184-.176.239.068.212-.486,0-1.034,0-1.566l-.181.339c-.107-.916.054-1.525.007-2.408l.167.028-.095-.527c.161.13.27-.353.137-.632l.4,1.373c-.1.379-.2-.418-.365-.181a1.5,1.5,0,0,0,.053,1.155,1.276,1.276,0,0,0-.074-.572c.233-.1.219.374.372.613-.007-.165.067-.4-.007-.434a3.536,3.536,0,0,1,.123,1.19c-.081-.367-.147.195-.211.054.2.047.251.563.176,1.225-.249.47.119,1.253.032,2.022a3.165,3.165,0,0,1-.425-1.192c-.118.479-.009.537-.126,1.018a1.9,1.9,0,0,1,.458,1.046l-.154.03c.063.574.288.583.212,1.308-.13,1.245-.186,2.526-.247,3.476l-.154.028c.307.546.019,1.769.123,2.489-.218,1.2-.007,2.64-.323,3.242a59.086,59.086,0,0,1-.326,6.226l-.19-.391c.128.409-.149.246-.151.635.216-.428.183.56.293.846a9.913,9.913,0,0,0-.142,3.135l-.156.018a8.974,8.974,0,0,1-.346,3.026,1.141,1.141,0,0,0-.262.628,6.994,6.994,0,0,1,.165,1.822,17.556,17.556,0,0,1-.449,2.3c.028,2.438-.544,4.846-.737,7.358l-.207.151a17.9,17.9,0,0,1-.353,3.167l-1.058,5.673-1.057-5.673c-.291-1.56-.463-3.089-.771-4.288l.333.149c-.005-.656-.307-1.453-.5-1.257-.011-.66-.384-1.592-.2-2.038-.04-.669-.262-.788-.376-1.332a19.735,19.735,0,0,0-.374-3.07l.019.312c.084.128.214.123.195-.19-.142-.455-.132-1.724-.437-1.215.035-1.359-.537-3.1-.4-4.429-.088.121-.144-.205-.226-.335a23.068,23.068,0,0,0-.309-3.349c.03-.191.2.281.161-.2-.067-.279-.132.007-.221-.337-.351-1.889-.161-3.872-.328-5.6-.43-3.066-.535-6.293-.688-9.25l.074.03c-.319-.979.176-2.335-.263-3.11.063-.237.009-.9.154-.727-.221-.785.126-2.215-.158-3.351a.794.794,0,0,0,.047.286c.135-1.155-.086-2.17.047-3.388.032.123.058.346.132.383.137-.47-.321-1.113.032-1.373-.007-.269-.181-.191-.169-.025.114-2.663-.086-5.5-.135-8.267.239-1.98.6-.112.356-1.68.072-.128-.133-.095-.06-.116-.09-.607.412-.936.233-1.359-.221.169-.116-.281-.249-.3a6.818,6.818,0,0,0,.225-2.408l.112.075c-.3-1.129-.088-2.422-.432-3.381.126-6.187.2-12.129.674-18.176.3-2.986.577-5.94,1.064-8.936l.2-1.129.118-.59c.074-.367.16-.714.247-1.065a6.673,6.673,0,0,1,1.506-3.256,2.276,2.276,0,0,1,1.45-.553l.358.06a1.709,1.709,0,0,1,.562.221,2.865,2.865,0,0,1,.922.993,7.617,7.617,0,0,1,.7,1.776c.126.679.181,1.2.239,1.618.032.295.058.537.086.783.058.407.169.82.356,1.594-.058-.056-.086-.153-.114-.04.26.04.195,1.1.449,1.215.274,2.257.56,4.313.774,6.621-.061-.363-.279-.527-.223-.095l.2.439-.063.079c.063.293.212.606.265.293.711,5.784.491,11.508.744,17.17-.058,1.35.091,3.261.176,4.724a114.918,114.918,0,0,0-.219,12.645,3.726,3.726,0,0,1-.792-2.387",
    transform: "translate(87.664 47.995)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M125.407,92.851c-.125.153-.2.656-.36.255.118-.049.249-.309.36-.255",
    transform: "translate(91.815 70.125)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M124.364,100.563c.035.019-.061.188-.084.228,0-.165-.095-.325-.023-.453,0,.169.06.146.107.225",
    transform: "translate(91.198 75.785)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M124.207,102.938a3.024,3.024,0,0,1-.137-1.227Z",
    transform: "translate(91.076 76.822)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M123.82,104.281c-.112.267-.158.188-.128-.181.06-.023.081.1.128.181",
    transform: "translate(90.785 78.625)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M123.965,104.347a1.036,1.036,0,0,1-.165.514c.095,0-.012-.616.165-.514",
    transform: "translate(90.874 78.805)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M123.407,108.259c-.009.167.047.534-.09.676.1-.165-.058-.818.09-.676",
    transform: "translate(90.509 81.753)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M123.337,110.08a.616.616,0,0,0-.026.265c-.072.184-.13-.025-.121-.186Z",
    transform: "translate(90.412 83.143)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M120.8,96.073l.063.346-.111-.047Z",
    transform: "translate(88.57 72.564)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M120.9,81.567c-.058-.349.112-.239.13-.295,0,.314-.132-.121-.13.295",
    transform: "translate(88.675 61.385)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M121.111,73.54l-.005.105-.221-.053Z",
    transform: "translate(88.672 55.545)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M164.38,139.3s-14.736-26.942-41.613-37.056-51.823-9.923-55.718.428,14.736,26.942,41.613,37.056,55.718-.428,55.718-.428M112.535,129.6c-25.089-9.442-43.976-20.955-42.185-25.713s23.582-.964,48.671,8.476a138.072,138.072,0,0,1,42.185,25.715,138.1,138.1,0,0,1-48.671-8.478",
    transform: "translate(47.62 71.592)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M164.38,139.3s-14.736-26.942-41.613-37.056-51.823-9.923-55.718.428,14.736,26.942,41.613,37.056,55.718-.428,55.718-.428M112.535,129.6c-25.089-9.442-43.976-20.955-42.185-25.713s23.582-.964,48.671,8.476a138.072,138.072,0,0,1,42.185,25.715,138.1,138.1,0,0,1-48.671-8.478",
    transform: "translate(47.62 71.592)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M92.545,115.978c-.272-.133-.318.295-.388.351.513.082.414-.458.388-.351",
    transform: "translate(66.974 87.579)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M95.293,116.413l-.137.137.827-.184Z",
    transform: "translate(69.239 87.891)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M99.029,117.635c-.216-.818-1.636-.383-2.352-.872l-.081-.195-.528.441a11.606,11.606,0,0,1,2.961.627",
    transform: "translate(69.928 88.044)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M99.115,118.5c-.075-.309.585-.091-.539-.235a.771.771,0,0,1,.082.095,3.774,3.774,0,0,1,.456.14",
    transform: "translate(71.822 89.324)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M98.7,118.325c-.483-.109.249.311,0,0",
    transform: "translate(71.786 89.357)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M100.2,118.565l-.69.074c.09.195.641.381.4.441.679.042.585-.154.286-.514",
    transform: "translate(72.524 89.552)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M100.461,118.366l-.349.018c.037.081.119.13.349-.018",
    transform: "translate(72.982 89.402)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M99.688,118.492l.742-.032c-.063-.135-.014-.365-.335-.007.109-.19-.077-.028-.407.039",
    transform: "translate(72.662 89.323)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M99.886,118.527c-.312-.246-.737-.462-.049-.534-1.216-.225-1.174.309.049.534",
    transform: "translate(72.102 89.08)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M98.373,116.951l-.4-.337-.463.109c.23-.054.828.46.864.228",
    transform: "translate(71.016 88.079)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M102.364,119.583c.072-.14-.123-.446-.128-.648l-.5.061c.216.158.649.358.632.586",
    transform: "translate(74.206 89.832)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M102.02,119.015l.753-.095c-.614-.174-.755-.079-.753.095",
    transform: "translate(74.423 89.751)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M101.029,117.94l-1.266.235c.5-.063.988-.109,1.487-.191Z",
    transform: "translate(72.718 89.08)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M103.821,119.69l-.47.267.818-.381Z",
    transform: "translate(75.428 90.316)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M104.688,119.809c-.351.228.312.567-.033.683a3.025,3.025,0,0,0,1.373-.279,1.836,1.836,0,0,1-1.339-.4",
    transform: "translate(76.358 90.492)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M106.091,119.915a3.919,3.919,0,0,0-.686.218,2.019,2.019,0,0,0,.686-.218",
    transform: "translate(76.98 90.572)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M103.117,119.071a.789.789,0,0,0,.463.537l-.19-.476-.274-.061",
    transform: "translate(75.252 89.934)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M103.269,119.1l.007.016.59.142-.6-.158",
    transform: "translate(75.367 89.954)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M103.078,119.074l.068.016c-.018-.047-.03-.063-.068-.016",
    transform: "translate(75.222 89.915)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M101.466,118.715c.463-.139,1.366-.193.63-.741-.358.219.065.532-.63.741",
    transform: "translate(74.005 89.106)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M103.316,118.837l-.716-.263c-.011.114.088.307-.14.376Z",
    transform: "translate(74.755 89.559)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M103.338,118.689l-.391.061.267.09Z",
    transform: "translate(75.123 89.646)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M105.226,119.732a2.662,2.662,0,0,1,1.116-.04,8.56,8.56,0,0,0-1.264-.358c-.082.121-.312.323.147.4",
    transform: "translate(76.634 90.133)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M104.217,119.336l.075-.011c-.037-.044-.068-.061-.075.011",
    transform: "translate(76.083 90.098)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M108.013,119.946l-.051-.086-.026.07Z",
    transform: "translate(78.891 90.53)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M105.3,119.319a.756.756,0,0,0-.721.014,4.749,4.749,0,0,1,.778.079c.039-.054.051-.093-.056-.093",
    transform: "translate(76.356 90.057)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M106.664,120.048a3.9,3.9,0,0,0-.518-.326c.14.161.441.427.518.326",
    transform: "translate(77.54 90.426)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M104.331,119.388a.258.258,0,0,1-.051.009c.086.112.083.065.051-.009",
    transform: "translate(76.13 90.174)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M104.345,119.463a1.831,1.831,0,0,0,.474-.172,2.7,2.7,0,0,0-.558.033.586.586,0,0,1,.084.139",
    transform: "translate(76.116 90.099)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M109.8,118.45c-.111.386-1,.632-1.659.107-.753.188-.5,1.555.025,2.368.047-.169.074-.328.846-.456-.23-.251-1.56-.734-.885-1,1-.065.776.253,1.22.528-.33-.548,1.338-.539,1.223-1.292l-.883.133c0-.114.334-.251.112-.386",
    transform: "translate(78.689 89.465)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M107.286,119.713l-.312,0a2.935,2.935,0,0,1,.969.713c.539-.118.665-.251.72-.376-.5-.084-.993-.188-1.49-.293Z",
    transform: "translate(78.165 90.416)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M106.541,120.012c.311-.386,1.067-.446.7-.983-.89-.121-.681.251-1.244.346,1.452.139-.455.169.541.586a4.33,4.33,0,0,1-.8-.019,6.245,6.245,0,0,1,.709.321l-.028-.032h-.007l0-.007c-.054-.063-.068-.1,0-.056l.032,0a.462.462,0,0,1,.093-.151c.4.16.046.123-.093.151a.31.31,0,0,0-.028.06l0,.007,1.481.011a5.676,5.676,0,0,0-1.364-.23",
    transform: "translate(77.234 89.885)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M102.37,117.557a.123.123,0,0,1,.023.109c.1-.032.144-.058-.023-.109",
    transform: "translate(74.688 88.791)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M103.074,117.9a.6.6,0,0,1-.562.063c-.26-.193.047-.2.063-.344-.225.065-.769.14-.186.492l.112-.035c.532.277,1.15.976,1.039,1.011a3.021,3.021,0,0,0-.467-1.187",
    transform: "translate(74.505 88.837)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M104.451,118.838l1.223.028-.532-.49-.011.228c-.656-.221-.563.081-.681.233",
    transform: "translate(76.259 89.409)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M108.138,120.089l-.228.43.792-.541Z",
    transform: "translate(78.872 90.62)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M108.986,120.137l-.112.386.448-.179Z",
    transform: "translate(79.6 90.74)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M86.377,102.811l-.365.011a1.353,1.353,0,0,0,.365-.011",
    transform: "translate(62.332 77.653)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M87.61,103.308l.118-.17c-.144.07-.214.132-.118.17",
    transform: "translate(63.506 77.9)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M113.354,112.356c-.221-.6-.4-1.4-.592-.992l-.107.451a1.4,1.4,0,0,1,.7.541",
    transform: "translate(82.456 84.03)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M99.171,105.986c.028.06.056.121.084.183.172-.086.333-.167.481-.242-.172.019-.363.039-.565.06",
    transform: "translate(72.271 80.006)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M98.8,107.043l-.509-.507a2.448,2.448,0,0,0,.509.507",
    transform: "translate(71.607 80.467)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M78.8,101.188l-.477.358c.614.119.386-.154.477-.358",
    transform: "translate(56.524 76.427)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M120.5,120.847a14.642,14.642,0,0,0,2.091.221c-1.278-.221-2.5-.581-2.091-.221",
    transform: "translate(88.321 91.16)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M87.67,100.442c-.232.014-.346.074-.367.169.235-.009.381-.053.367-.169",
    transform: "translate(63.307 75.864)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M123.57,120.918l-.565-.088a4.692,4.692,0,0,1-1.348.135c.93.167,1.9.255,1.913-.047",
    transform: "translate(89.255 91.263)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M83.382,109.141c.025.033.06.061.081.095.033-.049-.011-.072-.081-.095",
    transform: "translate(60.346 82.434)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M90.316,114.834a4.671,4.671,0,0,1-.577-.191,1.462,1.462,0,0,0,.577.191",
    transform: "translate(65.147 86.59)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M112.6,120.669c-.339,0-.058.042,0,0",
    transform: "translate(82.293 91.141)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M111.709,119.685a.272.272,0,0,0,.154-.195.347.347,0,0,1-.154.195",
    transform: "translate(81.741 90.251)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M119.722,118.793l-.018-.018c-.149-.005-.119,0,.018.018",
    transform: "translate(87.706 89.709)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M112.257,120.53a2.21,2.21,0,0,0,.416.169,2.26,2.26,0,0,0-.416-.169",
    transform: "translate(82.155 91.036)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M112.416,120.679l-.288-.068c-.051.068-.018.116.288.068",
    transform: "translate(82.043 91.098)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M113.031,120.721a2.468,2.468,0,0,1-.537-.095c.061.035.088.061.068.075.1,0,.239.009.469.019",
    transform: "translate(82.334 91.109)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M70.355,101.9a.337.337,0,0,1,0,.06c.3.056.212,0,0-.06",
    transform: "translate(50.507 76.967)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M107.531,111.458a.342.342,0,0,0,.042,0l-.035-.037Z",
    transform: "translate(78.586 84.156)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M106.861,111.7c.7-.221.916-.021,1.185.265l.3-1.276Z",
    transform: "translate(78.08 83.606)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M94.5,105.326l.7.583c-1.12.379-1.75-.012-1.146.713.453-1.3,3.1.671,3.569-.613l.446.425c-.146-.056-.191.016-.335-.04.836.916,1.02-.741,2.278-.179.427.233.688.518.332.583l1.109-.028c.288.112.147.318-.139.207l1.576.362-.025.035a6.512,6.512,0,0,1,1.166-.363c.335.307-.239.079-.19.272l.953-.049c.24.449-.567.549-1.143.321.393,1.546.811-.105,2.287,1.194l-.855-.088c.283.9.992.83,1.743,1.587-.133-.309-1.434-1.748-.409-1.771a1.318,1.318,0,0,0,1.137.242c-.147.465.376.506.99.685l-.244.6c.711.046.764-.283,1.241-.427.711.307.7.828.735,1.283,1.127.5-.544-1.036.872-.669a5.241,5.241,0,0,0,2.94.613c.6.453-.251.328-.072.588l.774-.267c.142.065.042.195-.009.262.572,0,.262-.592,1.115-.462.456-.577,1.28,1.557,2.517,1.2.172.265-.256.323-.272.585a8.681,8.681,0,0,0,2.621-.13l.767.762c-.5-.714.6-.907,1.545-1.011a5.234,5.234,0,0,0-.383-.741c.46.053.906.14,1.359.212.105.163-.105.311-.411.469.1-.012.2-.025.284-.042.339.413-.037.651-.488.843l-.277-.558c-.451.221-.9.507-.985.879a.908.908,0,0,1,.463.011c-.119.063-.205.128-.195.2s.193.005.455-.058l-.012.779.179-.232,1.38,1.108c1.41-.165,2.844-.7,4.736-.074-.669.256-.472.725-.769,1.273-.195-.82-1.469-.432-2.329-.962.451.277.219.5.053.539.628.067,1.246.161,1.873.244-.258.441.176.511.5.907.126-1.06,1.5-.009,2.3.04-.114.319-.428.549-1.192.084.539,1.1,1.683-.493,2.242.544-.2-.1-.276-.2-.432-.086.59-.026,1.582.774,1.183.9l-.195-.1a15.579,15.579,0,0,0,2.471,1.264c.881.37,1.69.558,2,.242a6.154,6.154,0,0,1-.841.9c1.22-.4,2.461-.8,3.709-1.178-.572.516-.718,2.459-1.964,2.206a2.2,2.2,0,0,0,1.3.748c-.144-.212.049-1.218.36-1.106.33,1.164.3.7.858,1.861-.218-.318.723-1.092,1.183-.765-.167.1-.565.988-.8.983.592-.075,1.194-.161,1.783-.219-.4-.019-.565.774-.479,1.213,0-.265.99.672,1.36.779L143,124.9c1.209,1.006,2.185-.5,3.444.449-.288.084-1.19.925-.621,1.49.618-.269,2.917-1.388,4.322-.923l.025.427,1.094.327a27.585,27.585,0,0,1-4.869.735c.332.548-.088.412.648.885.075.43-.662.116-.883-.014.52.437,1.039.874,1.543,1.33.319-.6,1.653.362,1.924-.137l-2.2-.732c.314-.606,2.154-.807,3.268.147.139.434-.939.806-1.046,1.006a.72.72,0,0,1,.337.04c.125.03.348.135.409.147.188.065.351.174.316.251a3.229,3.229,0,0,0-.5.07c.058.2.327.126.63.139s.63.1.483.391c.049.063-.1.223-.24.325s-.232.165.044.125c.9-.288,3.521-1.3,4.618-1.141a6.63,6.63,0,0,1,.384.874c.137.4.165.751.01.865-.249.169-1.092-.018-1.8-.133a5.043,5.043,0,0,0-1.683-.105,4.5,4.5,0,0,1,1.036.195c-.1.132-1.057-.1-.576.184,1.336.176.646.609,1.271.265.806.4.158.314.662.7a12.724,12.724,0,0,1,2.4.716,14.772,14.772,0,0,1,2.587,1.239,4.8,4.8,0,0,0-.974-.207,3.478,3.478,0,0,1,.718.909c-.95-.09-1.785-.205-2.533-.209a8.515,8.515,0,0,1-1.941-.734c.123.132.472.384.139.4-1.82-.66.546-.091-1.411-.883.82.441.342.6.226.848a1.576,1.576,0,0,0,1.2.305.333.333,0,0,0,.218-.414c.913.46,1.687.971,1.792,1.306.17.367-.095.669-.769.864-1.23.207-1.334-.563-1.438-.442-1.408-.128-1.611.228-1.964.532-.314.312-.809.535-2.275.133-.614-.309-.662-.581-.653-.829s.095-.474-.051-.678c.915-.139,1.769.469,2.542.472l-1.08-.305a1.488,1.488,0,0,1,1.26-.1,8.711,8.711,0,0,0-2.533-.434c-.527-.047-1.088-.095-1.611-.167a7.856,7.856,0,0,1-1.48-.341c-.323.153-.871.29-.641.53l.555-.025c.467.481-1.09.5-.413.771a3.881,3.881,0,0,1-2.666.27l-.126-.635c0,.183.639.444.951.291-.465.221-1.5-1.013-2.064-.267l.679.509c-.776.214-1.785.779-2.684.444.342.662.221-.035.79.757-.462-.946,2.375.314,1.566-.718.583.9,1.13.486,1.943,1.287-.005-.205-.274-.416.5-.244a.924.924,0,0,1,.19-.161l.053.019-.042-.028c.037-.026.04-.033-.014-.009a.875.875,0,0,1-.369-.346c.435-.428,1.671-.3,2.112-.5.453.139-.214.214.019.455l.656-.3c-.156.455,1.722.869.056,1.025l1.546.119a7.891,7.891,0,0,0,3.146.36c.865.144,1.51-.463,1.146-.109l2.147-.226.149.116a18.6,18.6,0,0,0,3.1-.262,14.292,14.292,0,0,1,4.2.235,6.8,6.8,0,0,1,2.5-.195l-.009-.011.762.177a7.636,7.636,0,0,1-1.227-1.267,3.857,3.857,0,0,0-1.345-1.1c.716-.051-.126-.923-1.244-1.878l-1.729-1.424c-.262-.221-.511-.434-.741-.63a7.814,7.814,0,0,1-.6-.542l-.832-.032a24.607,24.607,0,0,0-3.53-2.484l-.411.246a5.916,5.916,0,0,1-1.825-1.424c-.305-.311-.644-.66-1-1a5.273,5.273,0,0,0-.769-.651c.176-.084.428.154.563.381-.713-1.78-3.189-1.4-3.974-2.828a.986.986,0,0,1-.725-.507.213.213,0,0,0,.088.032,1.038,1.038,0,0,0-.121-.09c-.09-.156-.176-.325-.283-.488a1.717,1.717,0,0,0,.216.444,4.548,4.548,0,0,0-1.034-.483l.119-.5-.089-.042c-.246-.374-.4.011-.421.434a2.122,2.122,0,0,0-.623-.06c.149-.836-1.06-.377-.988-1.325-.448.176-1.94-.872-2.582-.258.047-.1-.03-.211.165-.1a1.829,1.829,0,0,0-1.167-.665l.153-.628-1.292.177c-.332-.642-.449-.95.326-1.053-1.655-.112-1.183-.365-2.633-.367l.251-.314c-.4-.211-1.28-.105-1.353-.527-.514-1.146-4.3-2.491-6.324-4.222-.065,1.274-.851-1-1.339-.232-.016-.316-.274-.616.209-.649-1.3-.348-1.631-1.229-2.777-.918-.025-.314.425-.255.37-.458-.123.011-.484.047-.544-.16s.274-.133.516-.158c-1.264-.514-1.729.214-2.138.909-.472-.621-.8-.727-1.464-.423-.118-.33-.381-.73.435-.506-.421-.211-2.533-1.429-2.814-.848-.077-.207-.593-.29-.735-.267a12.293,12.293,0,0,0-2.019-.82l.232.2c-.653.585-.864-.137-1.673-.337l.049-.067c-1.6-1.174-.862-.026-2.415-1.264l-.065.488c-.509.92-1.366-1.127-2.528-1.108l.283.388c-.676.142-1.122-1.869-1.653-2.187-.095-.126.242-.07.437-.075-1.3-1.083-.393.532-1.552.305-.1-.391.537-.737-.195-1.043-.29-.391-2.517.349-3.346-.6.147.321.293.642-.284.667-.821-.149-1.866-1.613-2.828-1.027a.285.285,0,0,1-.086-.24c-.671.023-2.087-.239-2.579.093-.121-1.776-4.025-.26-3.621-1.731l-1.926-.4.088-.14a2.412,2.412,0,0,0-2.229.119c-.26-.167-.021-.26.021-.332a3.983,3.983,0,0,0-3.584-.249l-.058-.52c-.458.2-2.471-1.292-4.374-1a.347.347,0,0,1,.232-.188,8.688,8.688,0,0,1-3.272-.7c-1.051-.309-1.983-.427-2.428.458-.463.111-.93.24-1.39.372,1.75.214-.293.776.411,1.108-.669.067-1.741-.592-.9-.678l.13.095c.342-.964-2.192-.339-2.18-.957a16.211,16.211,0,0,0-3.365.5,5.534,5.534,0,0,0-2.845,1.639,3.656,3.656,0,0,0-.79,3.067,6.771,6.771,0,0,0,1.425,3.07,5.692,5.692,0,0,1,.365-.716c.3.383.569.813.9,1.16.126.376-.079.776-.823-.111.009.353.439.662.827.855a1,1,0,0,0,.79.132c1,1.353-1.065.174-.713.532l.551.444-.058-.172c.618.176.867-.044,1.594.637.39.509-.039.553.135.73-.035.04.016.112.283.256.365.33.742.625,1.115.937l-.111-.811c.679.156,1.057.832.923-.09.079.7,1.111,1.545,2.17,2.256a16.094,16.094,0,0,1,2.31,1.567,5.785,5.785,0,0,1,2.591,1.127c-.169-.237.025-.879.774-.355-.964,1.006,1.162,1.339,1.348,2.542-.276-.876,2.373,1.1,1.889-.195.621.458-.2.467.167,1.022,1.852.388,3.412,2.149,5.519,2.975.109-.144-.112-.549.437-.579l.688,1.309c.441.111.8-.742,1.278.153-.042-.183-.1-.456.193-.383,3.633,2.652,8.452,3.017,11.982,6.172-.434-.546-.047-.425.386-.265-.249-.188.167-.4.2-.648l1.492,1.3c.555-.491,1.885.676,2.292.153l-.592-.1c1-.423-.427-1.948.032-2.8-1.123.472-1.673-2-3.444-1.411-.219-.3.365-.186.291-.456-.488.246-.929.165-1.6-.314l.123-.06c-2.136-.778-2.88-1.527-5.1-2.8l-.019.513a2.05,2.05,0,0,1-.707-.674c-.869.407,1.392.656.546,1.155-.277-1.171-3.528-1.59-3.507-2.8-.76-.358-.009.6-.769.244l-.075-.363-.356.258a.889.889,0,0,1-.474-.986,1.918,1.918,0,0,0,.511.142c-.491-.625-1.866-.757-2.036-.969l.646.514c-2.189-.741-4.5-2.345-6.73-2.856l.042.279c-1.689-.435-1.076-.858-2.787-1.59l.086-.014a2.429,2.429,0,0,1-1.345-.414c.535.005-.5-.879.172-.827-1.79-.542-.95-.153-2.417-.063l-.042-.463a1.754,1.754,0,0,1-1.488-.211c.809.14-.19-.8.75-.7-1.162-1.717-2.852-.888-2.875-2.378-1.322.334,1.02,1.424.495,1.316.154.516-1.048.225-1.48-.223-.491-.384-.082-1.675-1.253-2.591.114.1.17.044.283.14-.272-.548-1.074-.425-1.3-1.19-.692.2-.6-.616-1.232-.121.376.263.73.542,1.125.79-.7-.342-1.973-.24-2.289-1.316a3.8,3.8,0,0,1,.811.179c.016-.319-.479-.311-.423-.625a.728.728,0,0,1,.816.246,2.856,2.856,0,0,0,.369.309,1.522,1.522,0,0,0,.686.283.465.465,0,0,0-.239-.314,1.37,1.37,0,0,0-.358-.181c-.17-.065-.247-.126.165-.319-.535.239-.672.033-.732-.149-.075-.207-.072-.358-.7-.555l.579-.025c-.126-.042-.47-.186-.514-.335a5.339,5.339,0,0,0,.857.218c-.386-.121-.309-.307-.132-.4s.418-.126.3-.3c-.1.225-.244.226-.5.153s-.555-.235-.778-.095c-.237-.335-.133-.549.037-.616a1.2,1.2,0,0,1,.7.044c.546.142,1.02.4,1.208.218-.005.067-.581-.111-.627-.362a1.208,1.208,0,0,1,.8.344c.174-.084.133-.2.011-.332s-.332-.274-.247-.435c.247.258.272.193.334.028a.937.937,0,0,1,.355-.532l.046.483c1.56.255.37-1.05,1.9-.671l-.649.669.792-.17-.172.551a2.3,2.3,0,0,1,1.987-.053c-.176-.353.174-.878.955-.821.5.339-.337.43.764.469-.281.277-.581.63-1.015.139-.063.151-.267.283-.328.435.528.377,1.394.205,1.789.251a1.122,1.122,0,0,1-.411-.161l1.664-.476c.226.218.007.33-.207.449a6.1,6.1,0,0,1,1.06-.168c-.179.372-.211.778-.9.865l1.564-.212c.075.186.7.593.477.7.786.36,2.175-.4,3.23.119a.708.708,0,0,1,.448-.121c1.029.3,1.841.965,3.193.721l.537.85c1,.067-.744-1.09.927-.971,1.192.058.283.69.635.978a2.584,2.584,0,0,1,2.712.163,4.068,4.068,0,0,1-.96-.163m11.9,3.133c-.258.021-.807.179-.888-.147.428-.446.551-.133.888.147m17.971,5.464c-.228.074-.446-.111-.656-.405a1.3,1.3,0,0,1,.656.405M151.157,138.1a.155.155,0,0,0,.033-.021c.925.248.592.151-.033.021m-1.776-.323c-.169.058-.156.126-.079.2.119-.116.5-.1.951-.037a.961.961,0,0,0-.872-.161m-76.587-27.9-.1-.242c.488.214.3.223.1.242",
    transform: "translate(48.366 73.668)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M98.7,106.847a.507.507,0,0,1,.009-.281c-.121.04-.158.126-.009.281",
    transform: "translate(71.839 80.489)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M78.683,101.155l-.035-.012a.229.229,0,0,0-.053.079Z",
    transform: "translate(56.73 76.393)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M115.9,117.155a.36.36,0,0,1,.239-.135c-.2,0-.316.03-.239.135",
    transform: "translate(84.886 88.385)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M110.546,120.7l.739-.04a1.089,1.089,0,0,1-.634-.235c0,.116.123.295-.105.276",
    transform: "translate(80.863 90.956)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M107.392,118.392c-.112.04-.219-.03-.332.012l-.007.226c.442.06.778-.067.339-.239",
    transform: "translate(78.225 89.42)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M110.7,119.766c-.007-.414-.474-.319-.983-.316a.364.364,0,0,1,.088.012c-.221.548.339.432.9.3",
    transform: "translate(80.236 90.212)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M109.856,119.467a1.852,1.852,0,0,1-.463-.056c-.09.219.181.076.463.056",
    transform: "translate(79.978 90.191)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M113.329,120.544c-.232-.126-.2.506-.319.328-.312.491,1.661-.477.319-.328",
    transform: "translate(82.698 91.034)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M110.141,118.838l.116.521.33-.37Z",
    transform: "translate(80.557 89.759)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M112.8,119.39l-.785-.214c0,.086-.1.123-.232.146.49.075,1.022.216,1.016.068",
    transform: "translate(81.796 90.014)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M112.061,119.275a1.327,1.327,0,0,0-.651.009,3.036,3.036,0,0,0,.651-.009",
    transform: "translate(81.515 90.062)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M110.77,118.825l.223.132.558.1Z",
    transform: "translate(81.032 89.748)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M117.722,119.847l.734-.125a1.042,1.042,0,0,0-.807-.221c-.039.114-.3.174.074.346",
    transform: "translate(86.134 90.247)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M115.358,118.908a3.493,3.493,0,0,1,.635.421l-.537-.662a1.473,1.473,0,0,1-.1.24",
    transform: "translate(84.497 89.63)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M116.591,118.979c-.153-.184.054-.516-.565-.495.223.186-.205.323.565.495",
    transform: "translate(85.002 89.491)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M117.006,116.726l.174.128,1.455-.135c-.556-.009-1.072-.007-1.629.007",
    transform: "translate(85.742 88.154)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M111.02,114.3c.713.762.556-.395,1.144.377.334-.063-.479-.634-.16-.669-.656-.13-.848-.423-.985.291",
    transform: "translate(81.221 85.982)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M111.58,113.936a2.127,2.127,0,0,0,.346.049,1.064,1.064,0,0,0-.346-.049",
    transform: "translate(81.644 86.054)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M91.261,115.569l.551.439-.281-.476Z",
    transform: "translate(66.297 87.262)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M92.136,115.411l-.082.667.585-.409c-.151-.026-.446-.079-.5-.258",
    transform: "translate(66.896 87.17)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M90.587,105.012l.1-.133c-.042-.193-.184-.253-.469-.374Z",
    transform: "translate(65.507 78.933)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M85.667,103.282l.144.054-.114-.644Z",
    transform: "translate(62.072 77.564)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M81.463,102.491c.288.095.664.051.951.147-.664-.053-.858-.883-.951-.147",
    transform: "translate(58.896 77.183)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M121.728,119.1c.291-.063.047-.423.063-.509-.421.246-.018.609-.063.509",
    transform: "translate(89.21 89.573)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M119.1,120.364l.053-.19-.693.607Z",
    transform: "translate(86.84 90.768)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M115.929,121.363c.63.616,1.826-.514,2.786-.458l.188.126.277-.653c-1.078.326-2.429,1.029-3.251.985",
    transform: "translate(84.929 90.922)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M114.241,120.391c.214.244-.542.346.642-.032a.855.855,0,0,1-.126-.047,4.475,4.475,0,0,1-.516.079",
    transform: "translate(83.62 90.872)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M114.559,120.358c.528-.119-.388-.167,0,0",
    transform: "translate(83.819 90.825)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M113.3,120.884l.667-.351c-.174-.14-.8-.084-.59-.239-.7.242-.53.383-.077.59",
    transform: "translate(82.642 90.858)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M112.787,121.066l.353-.16c-.075-.058-.176-.068-.353.16",
    transform: "translate(82.556 91.294)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M113.732,120.7l-.744.335c.119.1.165.328.346-.132-.033.219.091-.005.4-.2",
    transform: "translate(82.707 91.165)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M113.672,120.768c.421.095.953.116.281.467,1.341-.325,1.055-.774-.281-.467",
    transform: "translate(83.224 91.139)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M115.864,121.481l.579.105.414-.335c-.205.176-1.071.018-.993.23",
    transform: "translate(84.876 91.581)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M110.594,120.74c-.028.156.281.379.355.567l.506-.232c-.281-.074-.8-.114-.86-.335",
    transform: "translate(80.898 91.195)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M111.121,121.063l-.758.346c.706-.046.821-.183.758-.346",
    transform: "translate(80.725 91.439)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M112.886,121.759l1.213-.737-1.462.781Z",
    transform: "translate(82.442 91.408)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M109.036,121.045l.416-.381-.75.583Z",
    transform: "translate(79.47 91.137)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M108.42,121.276c.312-.314-.474-.465-.137-.667a4.446,4.446,0,0,0-1.383.592,2.512,2.512,0,0,1,1.52.075",
    transform: "translate(78.109 91.096)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M106.509,121.287a4.129,4.129,0,0,0,.685-.341,2.246,2.246,0,0,0-.685.341",
    transform: "translate(77.814 91.351)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M109.877,121.467a.894.894,0,0,0-.655-.395l.344.409.311-.014",
    transform: "translate(79.863 91.446)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M109.719,121.317l-.012-.012-.672.018.685-.005",
    transform: "translate(79.721 91.622)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M109.673,121.295l-.079,0c.033.04.053.053.079,0",
    transform: "translate(80.144 91.614)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M111.926,121.381c-.434.288-1.381.651-.4.913.3-.33-.262-.477.4-.913",
    transform: "translate(81.28 91.679)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M109.886,121.749l.85.005c-.028-.111-.195-.258.023-.4Z",
    transform: "translate(80.364 91.657)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M109.658,121.755c.133-.051.267-.118.4-.177l-.314,0Z",
    transform: "translate(80.192 91.826)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M107.847,121.355a2.763,2.763,0,0,1-1.2.258,6.173,6.173,0,0,0,1.453.088c.061-.139.256-.395-.256-.346",
    transform: "translate(77.92 91.655)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M108.383,121.354l-.079.03c.051.033.091.042.079-.03",
    transform: "translate(79.169 91.659)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M104.14,121.507l.068.081.019-.074Z",
    transform: "translate(76.024 91.774)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M107.569,121.679a.921.921,0,0,0,.774-.205,5.676,5.676,0,0,1-.858.13c-.026.063-.032.1.084.076",
    transform: "translate(78.539 91.749)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M105.815,121.279a4.819,4.819,0,0,0,.627.226c-.186-.133-.562-.339-.627-.226",
    transform: "translate(77.29 91.578)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M108.248,121.337a.28.28,0,0,1,.053-.023c-.123-.084-.105-.04-.053.023",
    transform: "translate(79.097 91.593)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M108.43,121.307a2.136,2.136,0,0,0-.462.293,3.289,3.289,0,0,0,.59-.183.593.593,0,0,1-.128-.111",
    transform: "translate(78.916 91.623)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M103.724,124.177c.084-.395,1.062-.727,1.892-.267.834-.267.3-1.6-.386-2.357-.028.174-.03.333-.871.537.283.228,1.845.579,1.13.913-1.12.161-.911-.176-1.443-.407.446.513-1.448.667-1.243,1.4l1-.218c.014.114-.353.281-.081.395",
    transform: "translate(75.003 91.809)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M105.75,121.842l.342-.054a3.019,3.019,0,0,1-1.174-.53c-.565.172-.686.316-.728.446.558.049,1.116.079,1.678.077Z",
    transform: "translate(76.062 91.585)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M106.805,121.657c-.256.437-1.083.635-.57,1.1,1.015-.046.7-.372,1.3-.57-1.624.133.458-.248-.718-.476a5.276,5.276,0,0,1,.871-.128,7.39,7.39,0,0,1-.841-.184l.039.026.007,0,0,.007c.07.053.095.086.016.056l-.033.009a.474.474,0,0,1-.07.165c-.469-.082-.075-.112.07-.165a.272.272,0,0,0,.018-.065l-.005-.005-1.615.263a6.924,6.924,0,0,0,1.532-.026",
    transform: "translate(76.88 91.689)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M110.967,122.523a.113.113,0,0,1-.063-.095c-.1.065-.139.105.063.095",
    transform: "translate(81.071 92.47)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M110.9,122.788a.745.745,0,0,1,.588-.255c.351.093.021.207.053.346.223-.139.786-.4.03-.527l-.109.07c-.678-.075-1.573-.521-1.464-.593a2.778,2.778,0,0,0,.9.958",
    transform: "translate(80.438 92.018)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M108.863,122.068l-1.353.3.716.33-.047-.223c.783.039.6-.228.685-.407",
    transform: "translate(78.57 92.198)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M104.314,121.575l.188-.451-.79.616Z",
    transform: "translate(75.701 91.485)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M103.228,121.544l.082-.395-.47.223Z",
    transform: "translate(75.043 91.504)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M76.469,93.523l.421-.135a1.849,1.849,0,0,0-.421.135",
    transform: "translate(55.125 70.536)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M74.733,93.586l-.054.2c.132-.121.181-.205.054-.2",
    transform: "translate(53.773 70.685)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M80.4,114.322c-.312-.611-.56-1.434-.732-1.018l-.075.465a1.836,1.836,0,0,1,.807.553",
    transform: "translate(57.486 85.493)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M67.012,103.371c-.019.068-.04.14-.061.212.191.081.362.156.535.211a5.817,5.817,0,0,1-.474-.423",
    transform: "translate(47.936 78.076)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M65.952,103.891a7.67,7.67,0,0,1-.007-.922,2.685,2.685,0,0,0,.007.922",
    transform: "translate(47.148 77.773)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M85.928,94.05l.558-.358c-.758-.123-.462.153-.558.358",
    transform: "translate(62.269 70.743)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M93.539,120.068a4.518,4.518,0,0,0-1.085-.634c.483.421.828.932,1.085.634",
    transform: "translate(67.198 90.209)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M75.972,96.258c.232-.093.328-.188.314-.284-.24.09-.372.181-.314.284",
    transform: "translate(54.739 72.489)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M91.688,119.2c.067.068.14.116.212.177a4.217,4.217,0,0,1,1.132.263,1.45,1.45,0,0,0-1.345-.441",
    transform: "translate(66.619 90.003)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M115.775,109.232c.016.046.044.091.054.135.051-.03.012-.077-.054-.135",
    transform: "translate(84.812 82.503)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M120.062,118.6c-.109-.123-.263-.342-.413-.546a2.054,2.054,0,0,0,.413.546",
    transform: "translate(87.738 89.165)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M99.1,120.926c.367.032.063-.039,0,0",
    transform: "translate(72.218 91.327)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M100.079,122.013a.277.277,0,0,0-.174.2.349.349,0,0,1,.174-.2",
    transform: "translate(72.826 92.156)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M89.151,119.9l-.03-.014c.074.121.061.1.03.014",
    transform: "translate(64.681 90.548)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M99.591,121.165a4.2,4.2,0,0,0-.448-.2,2.121,2.121,0,0,0,.448.2",
    transform: "translate(72.25 91.366)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M99.37,120.967c.125.028.223.051.316.074.054-.068.021-.118-.316-.074",
    transform: "translate(72.422 91.354)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M98.812,120.886a3.125,3.125,0,0,1,.581.142c-.068-.04-.095-.07-.074-.081l-.507-.061",
    transform: "translate(72 91.305)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M100.728,99.137a.826.826,0,0,1,.06.07c.435-.011.265-.053-.06-.07",
    transform: "translate(73.447 74.878)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M73.925,112.871c.018.007.032.005.047.011l-.035-.047Z",
    transform: "translate(53.203 85.224)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M73.174,112.823a1.25,1.25,0,0,1,1.331.563L74.9,112.1Z",
    transform: "translate(52.636 84.671)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M92.263,94.028l-.972-.456c1.241-.567,2.113-.284,1.2-.9-.219,1.325-3.937-.058-4.106,1.343l-.658-.293c.19.014.219-.065.407-.051-1.292-.667-.953.986-2.594.827-.576-.086-.992-.249-.6-.437l-1.267.412c-.376-.005-.3-.246.072-.242-.653.075-1.308.191-1.959.286l.011-.042a10.229,10.229,0,0,1-1.132.843c-.523-.126.226-.179.077-.33-.346.163-.688.309-1.027.49-.5-.27.341-.779,1.106-.818-1.232-1.2-.844.434-3.205.114.335-.14.672-.276,1.011-.39a1.749,1.749,0,0,0-1.285-.339,13.519,13.519,0,0,1-1.669.039c.39.114,2.7.586,1.578,1.194a1.849,1.849,0,0,0-1.378.5c-.142-.462-.741-.183-1.511.14l-.165-.625c-.8.483-.613.772-.99,1.253a1.728,1.728,0,0,1-1.783-.237c-1.564.721,1.4.153-.291,1.2a5.867,5.867,0,0,0-2.956,2.882c-.82.655-.181-.4-.555-.233q-.108.537-.183,1.046c-.149.167-.226.026-.274-.056-.255.776.483.43.025,1.508.258.314-.247.688-.727,1.318a2.4,2.4,0,0,0-.569,2.294c-.2.346-.384-.209-.637-.123.107.525.184.9.244,1.192.084.281.156.479.228.665a5.3,5.3,0,0,0,.806,1.376,10.728,10.728,0,0,0-.095,1.364c.225-1.055,1.044.009,1.854.707.109-.372.212-.678.244-.867.3.425.539.853.865,1.244-.021.2-.283.165-.635.046.093.072.183.14.26.188.011.586-.439.5-.939.277a4.592,4.592,0,0,1,.144-.676c-.5-.211-1.041-.425-1.366-.221a1.517,1.517,0,0,1,.356.451c-.137-.061-.251-.093-.293-.023s.153.193.4.383l-.5.632.3-.032a20.8,20.8,0,0,0,.6,2.164c1.436.993,3,1.457,4.674,3.019-.767-.1-.741.453-1.239.83.109-.918-1.373-1.259-1.984-2.384.321.569,0,.627-.186.548q.893.761,1.822,1.424c-.425.276-.014.62.212,1.187.483-.976,1.573.807,2.421,1.216-.207.276-.6.358-1.29-.492.279,1.4,1.9.323,2.273,1.574-.193-.177-.256-.312-.453-.265.641.225,1.553,1.424,1.1,1.394l-.2-.172c1.166,1.318,4,3.49,4.729,2.965a4.9,4.9,0,0,1-1.009.732c1.408-.1,2.8-.246,4.169-.423-.655.428-.851,2.457-2.256,1.936a2.9,2.9,0,0,0,1.471,1.034c-.169-.251.056-1.271.4-1.1.37,1.28.328.785,1,2.091-.258-.369.781-1.051,1.3-.649-.183.084-.592.972-.86.934.665.007,1.338-.012,2-.03-.453-.053-.586.762-.449,1.234-.026-.277,1.192.8,1.632.927l-.456-.592c1.5,1.13,2.389-.377,3.927.592-.307.091-1.2.96-.463,1.56.669-.279,3.024-1.476,4.623-1.122l.114.435,1.252.24a20.486,20.486,0,0,1-5.243,1.034c.481.57-.021.435.907.922.174.453-.728.132-1.008,0,.679.458,1.359.918,2.052,1.355.226-.648,1.966.284,2.145-.269l-2.665-.62c.239-.646,2.249-.957,3.705-.084.267.437-.837.925-.909,1.141a2.926,2.926,0,0,1,1.724.56l-.813-.007c.742.669,1.8-.111,2.549.969.337.214.7,1.3.937.962a4.636,4.636,0,0,1,1.269-3.526,14.608,14.608,0,0,1,1.8,2.048c.346.816-1.473.918-1.183,1.617.1-.158.518-.216.685-.225.318.309-.388.455.474.737.412-.569,1.662.783.623-.362.886.167.8.511,1.771.872-.133-.532,1.432-1.041,2.308-.892-.112.14-.016.428.035.558a39.987,39.987,0,0,0,4.032,1.868c.093.2.8.649.381.822a1.908,1.908,0,0,1,1.055-.044c.783.881-1.136-.276-.621.642.188-.358,1.457-.1,2.229-.107-.046-.662-1.585-.646-2.373-.642.27-.818,1.745-1.225,3.484-1.125,1.378.116.434.669.693.607,2.478.741,2.45-.9,4.379.139.727.669-.167,1.062-.058,1.476-1.153.021-1.613-.72-2.357-.857l.855.47a2.35,2.35,0,0,1-1.511-.2,7.036,7.036,0,0,0,2.586.9,20.49,20.49,0,0,1,3.609.858c.381-.121,1.015-.207.757-.469l-.637-.03c-.507-.527,1.257-.4.5-.734a5.814,5.814,0,0,1,3.007-.2l.16.635c-.007-.181-.732-.441-1.083-.286.513-.225,1.732,1.008,2.343.258l-.788-.507a6.6,6.6,0,0,1,2.959-.539c-.435-.627-.246.061-.932-.679.57.946-2.615-.3-1.68.732-.674-.9-1.269-.477-2.163-1.273.005.205.3.42-.548.237a1.009,1.009,0,0,1-.211.16.574.574,0,0,0-.056-.021l.044.028c-.04.026-.046.033.018.011a.939.939,0,0,1,.4.349c-.491.455-1.854.186-2.356.353-.5-.179.249-.195.005-.455l-.748.242c0-.458-1.222-.964.014-1.027l-1.065-.2a3.966,3.966,0,0,0-1.98-.553c-.472-.216-1.36.184-.85-.056l-1.717-.126.012-.114c-1.618-.381-3.533-.256-5.1-1.608a4.68,4.68,0,0,1-2.027-.57l-.033-.432c-.739-.137-1.917-1.162-2.357-.913-.341-1.262-3.2-1.578-4.3-2.289l-.255.444a14.907,14.907,0,0,0-2.722-.911l-.133.435c-1.032-.074-2.077-1.364-3.439-2.012.17-.107.491.107.686.321-1.134-1.71-3.719-1.125-4.79-2.584a1.183,1.183,0,0,1-.85-.5.209.209,0,0,0,.1.032,1.211,1.211,0,0,0-.142-.09c-.116-.158-.228-.33-.363-.493a1.928,1.928,0,0,0,.286.449,6.8,6.8,0,0,0-1.174-.486l.081-.516c-.035-.018-.063-.03-.1-.046-.295-.393-.432,0-.414.442a2.448,2.448,0,0,0-.679-.077c.1-.862-1.192-.42-1.164-1.406-.486.174-2.127-1.025-2.81-.474.049-.1-.035-.223.179-.084a2.371,2.371,0,0,0-1.276-.825l.179-.632h-1.41c-.344-.709-.434-1.057.4-1.029-1.75-.418-1.234-.579-2.786-.89l.3-.267c-.4-.305-1.367-.4-1.388-.85-.186-.658-1.222-1.571-2.371-2.68a15.09,15.09,0,0,1-3.007-3.739c-.563,1.169-.409-1.334-1.18-.858.116-.3.007-.692.474-.488-1.064-.967-.829-1.924-1.968-2.331.167-.276.49.046.565-.158-.1-.061-.412-.251-.335-.453s.3.058.5.177c-.693-1.129-1.476-.893-2.259-.649.019-.816-.109-1.1-.8-1.422.163-.328.293-.783.671-.011-.083-.232-.2-.953-.33-1.587s-.235-1.2-.553-1.209a.472.472,0,0,0,.044-.395,1.091,1.091,0,0,0-.086-.37,4.866,4.866,0,0,1,.161-1.046c.039-.27.121-.521.237-1l-.179.23c-.628-.627.1-.888.428-1.629l.054.061c.36-.341.565-.534.707-.671a1.035,1.035,0,0,0,.211-.339c.072-.191.2-.39,1.108-.778l-.395-.3c-.262-.442.19-.642.792-.774a8.5,8.5,0,0,0,.944-.212,1.58,1.58,0,0,0,.818-.421l-.5-.046c.2-.314.767-.214,1.343,0a5.329,5.329,0,0,0,1.443.446c.156.04-.147.207-.295.33,1.7.051-.042-.679,1.083-1.194.314.263-.018.907.771.743.223.067.72-.339,1.346-.716a2.493,2.493,0,0,1,2.012-.458c-.291-.225-.592-.448-.03-.725.909-.233,2.547.686,3.307-.184.123.065.17.132.179.195.685-.27,2.271-.451,2.7-.906.341.829,1.431.627,2.463.437s1.991-.376,1.936.4c.73.026,1.46.028,2.192.079l-.07.151a3.113,3.113,0,0,0,2.45-.388c.312.142.06.256.023.333a5.422,5.422,0,0,0,4.039.035l.1.521c.518-.212,2.8,1.257,4.882,1.123a.357.357,0,0,1-.263.174c2.375-.121,4.955,2.58,6.219,1.041l1.573-.026c-1.852-.662.493-.679-.2-1.187.779.105,1.78,1.064.839.9l-.119-.128c-.59.8,2.245,1.011,2.008,1.613a46.263,46.263,0,0,1,5.324,1.987l2.54,1.123c.809.4,1.61.788,2.417,1.143l-.089-.837,1.125.525c.232.284.167.7-.628.325.255.56,1.5.256,1.592.123,1.462.946-.981.514-.5.739l.679.228-.111-.14c.655-.035.832-.274,1.761.246.53.444.1.565.319.713-.025.046.042.109.348.205l1.343.774-.272-.8c.751.07,1.29.709.967-.2.247.656,1.434,1.511,2.628,2.261a11.957,11.957,0,0,1,2.563,1.731,6.723,6.723,0,0,1,2.754,1.527c-.169-.27.072-.9.871-.23-.565.435-.249.8.168,1.278s.99,1,1.006,1.636c-.172-.967,2.363,1.711,2.047.281.6.627-.284.418.016,1.069,1.852.988,3.14,3.221,5,4.9.154-.1.044-.588.616-.39l.311,1.56c.416.286,1.058-.376,1.232.716.021-.2.054-.493.321-.284a58.823,58.823,0,0,0,4.834,5.822,17.954,17.954,0,0,1,3.93,6.528c-.1-.751.183-.4.488.019-.125-.323.365-.239.527-.428.225.7.407,1.42.607,2.12.781-.042,1.23,1.873,1.88,1.732l-.441-.509c1.115.374.764-1.934,1.641-2.347-1.262-.391-.425-2.977-2.407-3.667-.051-.42.435.083.5-.209-.577-.119-.941-.488-1.364-1.362l.147.026a26.348,26.348,0,0,1-1.871-2.728c-.532-.853-1.011-1.808-1.9-3.04l-.219.476a2.716,2.716,0,0,1-.451-1.046c-1.032-.1,1.148,1.418.1,1.411.095-.637-.642-1.513-1.345-2.371s-1.427-1.652-1.216-2.243c-.674-.744-.207.588-.878-.153l.039-.4-.451.077a1.055,1.055,0,0,1-.191-1.216,3.294,3.294,0,0,0,.5.393c-.323-.876-1.787-1.631-1.906-1.924l.555.813c-2.1-1.766-4.313-4.325-6.726-5.578l.011.3c-1.827-.948-1.1-1.208-2.935-2.452l.095.009a4.038,4.038,0,0,1-1.5-.734c.613.116-.553-1.025.218-.83-2.048-.92-1.094-.353-2.742-.506l-.058-.5a2.59,2.59,0,0,1-1.7-.393c.943.207-.288-.848.807-.665-1.552-1.926-3.36-1.118-3.662-2.707-1.422.335,1.422,1.552.8,1.429.246.553-1.134.2-1.7-.26-.634-.358-.462-1.734-2.145-2.593.163.091.211.028.374.118-.506-.562-1.38-.319-1.957-1.1-.693.335-1.013-.484-1.469.176a14.349,14.349,0,0,1,1.629.556c-.941-.3-2.189.27-3.451-.785a2.7,2.7,0,0,1,1.044-.088c-.337-.4-.89-.211-1.241-.621.437-.679,1.985.656,3.207.518-.328-.506-2.069-.255-1.229-.836-1.139.707-1.669-.86-3.16-.583l.251-.411a2.818,2.818,0,0,1-1.018-.114c.279-.116.56-.214.843-.319-1.144.081-1.689-1.125-2.71-1.208,1.933.69.237.7.93,1.322-2.575-.262-.939-1.669-3.7-2.38.384.061,1.271.739.632.753A4.754,4.754,0,0,1,119,99.134c-1.82-.481.123.556-.728.59-.43-.746-.946-.061-1.78-.123l.137-.465c-1.954-.909-.832.8-2.557-.1l.965-.416-1.009-.114.351-.476a3.844,3.844,0,0,1-2.45-.527c.151.393-.363.816-1.278.6-.549-.439.465-.356-.848-.621.365-.219.783-.506,1.236.072.1-.139.367-.221.467-.356a4.988,4.988,0,0,0-2.154-.62,1.355,1.355,0,0,1,.484.235l-2.05.2c-.256-.248.012-.335.279-.42a10.936,10.936,0,0,1-1.283.03c.232-.353.284-.762,1.13-.753-.637-.005-1.278.012-1.915.026-.086-.195-.841-.66-.574-.753-.976-.435-2.638.251-3.935-.27a.933.933,0,0,1-.534.121c-1.252-.3-2.328-.943-3.92-.6l-.785-.8c-1.213.019,1.071,1.016-.941,1.058-1.427.095-.469-.648-.946-.89a3.861,3.861,0,0,1-3.272.272,5.281,5.281,0,0,1,1.176-.009M77.28,95.282c.265-.165.788-.616,1.062-.376-.221.611-.525.416-1.062.376m-8.917,18.538c-.251-.111-.337-.453-.328-.879a2.341,2.341,0,0,1,.328.879m52.254,28.166-.032.018c-.558-.283-.362-.176.032-.018m1.2.411c.135-.046.139-.114.1-.19-.107.107-.386.068-.7-.018.065.14.209.253.6.207m7.953-33.681-.158-.226c.553.133.358.172.158.226",
    transform: "translate(46.655 69.997)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M66.058,103.6a.45.45,0,0,1,.2-.212c-.119-.084-.209-.058-.2.212",
    transform: "translate(47.261 78.054)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M85.87,93.95l.044.012a.2.2,0,0,0,.058-.079Z",
    transform: "translate(62.225 70.91)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M86.16,119.94a1.131,1.131,0,0,1-.372-.442c-.061.1.007.249.372.442",
    transform: "translate(62.148 90.257)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M101.616,121.025l-.8.047a1.3,1.3,0,0,1,.7.228c-.007-.114-.144-.291.1-.276",
    transform: "translate(73.511 91.41)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M105.323,123.033c.121-.061.256-.011.376-.072l-.035-.226c-.513.025-.872.211-.341.3",
    transform: "translate(76.72 92.702)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M101.618,122.033c.033.405.553.346,1.129.277a.5.5,0,0,1-.1,0c.2-.562-.413-.388-1.027-.274",
    transform: "translate(74.12 92.082)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M102.337,122.18a2.41,2.41,0,0,1,.528.011c.079-.226-.211-.056-.528-.011",
    transform: "translate(74.663 92.204)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M98.615,121.188c.246.147.242-.488.365-.3.372-.463-1.84.332-.365.3",
    transform: "translate(71.464 91.197)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M102.051,123l-.17-.523-.351.374Z",
    transform: "translate(74.053 92.504)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M99.26,122.335l.9.228c0-.084.118-.123.265-.146-.562-.072-1.167-.233-1.166-.083",
    transform: "translate(72.339 92.352)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M99.924,122.364a1.729,1.729,0,0,0,.746-.011,3.848,3.848,0,0,0-.746.011",
    transform: "translate(72.84 92.404)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M101.494,122.886l-.263-.132-.648-.1Z",
    transform: "translate(73.338 92.641)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M94.2,121.206a7.632,7.632,0,0,1-1-.139c-.146.133.086.323.462.372.269-.06.648-.037.542-.233",
    transform: "translate(67.726 91.442)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M95.483,122.525c-.246-.167-.24-.281-.351-.479l-.176.6Z",
    transform: "translate(69.088 92.181)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M93.937,122c-.146.154-1.582.1-.305.4.149-.14,1.185-.037.305-.4",
    transform: "translate(67.691 92.145)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M85.575,118.854l.237.1.391-.948Z",
    transform: "translate(62.002 89.13)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M78.076,116.325c.93.837.574-.393,1.371.432.37-.063-.651-.674-.29-.7-.767-.151-1.022-.483-1.081.272",
    transform: "translate(56.338 87.501)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M78.692,115.966a3.171,3.171,0,0,0,.4.056,1.344,1.344,0,0,0-.4-.056",
    transform: "translate(56.804 87.588)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M120.465,119.846l.207.741.042-.585Z",
    transform: "translate(88.354 90.52)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M121.46,120.318l-.476.476.721.074c-.1-.119-.3-.362-.246-.549",
    transform: "translate(88.747 90.876)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M70.6,93.808l-.014.172c.184.111.381.061.779-.026-.253-.047-.506-.112-.765-.146",
    transform: "translate(50.683 70.853)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M77.117,93.084l-.19-.009.369.581Z",
    transform: "translate(55.471 70.3)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M82.8,92.869c-.37-.06-.82.032-1.192-.028.823-.032,1.22.769,1.192.028",
    transform: "translate(59.003 70.122)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M99.007,108.824c-.688-.212.293.321-.469-.09a.442.442,0,0,1,.469.09",
    transform: "translate(71.793 82.103)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M117.2,114.3c-2.368-.267-5.032-1.857-7.546-2.359-.288-.075.177-.27-.479-.423a40.278,40.278,0,0,1-8.768-3.184l.2-.026c-.521-.242-1.274-.181-1.836-.407.014-.058.209-.019.1-.14-.2.121-1.064-.26-1.35-.212-.205-.14-.139-.267-.409-.437l-.393.088c-1.06.165-2.213-.743-3.542-.892.074-.026.209-.023.123-.1-2.1-.344-4.6-1.15-6.9-1.678.109-.044.228-.146.116-.26-.169.174-.883.03-1.5-.093-.216-.286-1.094-.09-1.778-.39l.072-.032c-.585.086-.751-.328-1.248-.169l-.295-.251c-.305.244-.73-.342-1.206-.291v.065c-.432-.023-.613-.223-1.009-.256l-.028-.044c-.918-.118-1.411-.386-1.436-.147-.281-.253.893.091.451-.284-1.015-.121-2.115-.269-3.024-.346a13.82,13.82,0,0,0-1.394-.061,3.972,3.972,0,0,0-.69.065.744.744,0,0,0-.576.342.717.717,0,0,0,.191.607,3.519,3.519,0,0,0,.449.479,10.435,10.435,0,0,0,1.034.809c.147.221.309.365.3.467a7.064,7.064,0,0,0,1.309.625c-.09-.049.105.209.239.3.435.363.658.079,1.136.474-.244-.063-.355-.037-.328.082a9.21,9.21,0,0,1,1.715.7c-.1-.009-.246-.06-.262.019.7.132,1.065.62,1.655.772l-.262.021c.769.588.383-.128,1.069.335-.195-.051-.158.03-.216.065a17.15,17.15,0,0,1,2.6,1.009c-.051,0-.056.037-.056.037a25.977,25.977,0,0,0,2.394,1.076c.276.2-.244.263.577.592.09-.265,1.41.528,1.071.021a14.028,14.028,0,0,0,2.2,1.069c-.353-.042.195.463-.386.226l.362.349c-.111.077-.43-.235-.351-.042a14.8,14.8,0,0,1,1.413.549,6.948,6.948,0,0,1,2.1.353c-.449-.079.107.383-.188.305l1.42.035c.293.114-.026.23.42.344.007-.077.207-.04.358-.04.095.075,1.223.449,1.241.757.084.154-.493-.147-.211.079.534.225.593.147,1.129.372l0,.037c.337.188,1.085.332.76.03-.242-.112.028.191-.3-.035a3.972,3.972,0,0,1,1.483.4c-.2-.035-.205.042-.309.082a15.5,15.5,0,0,1,2.426.6c.063-.116-.39.1-.481-.018.96.6,2.224.639,2.982,1.234-.149-.037-.005-.2-.011-.167.491.218.4.384.748.451-.011.116.421.132.767.233.2-.005.067.086-.228-.019a16.46,16.46,0,0,1,3.444,1.262,2.186,2.186,0,0,1,1.006.114l-.16.123c.188.184.836.312.823.465.606.014-2.1-.634-1.329-.5.132.207,1.1.137.858.295a4.926,4.926,0,0,1,1.471.534c-.128-.081-.491.063-.084.211.72.246.232,0,.828.17l.386.074c.084-.147.627.265.43-.012.037.163,1.062.318.888.549l-.176.167a2.431,2.431,0,0,0,.862-.021c.032.035.1.107.068.133.169-.293.725.305,1.181.2.6.355,1.634.63,1.868.934a4.926,4.926,0,0,1,1.569.414c-.123-.012-.281-.06-.339,0a1.487,1.487,0,0,0,.785.24c-.09.019.644.444,1,.7.528.086.42-.147.507-.233.339.484,1.469.3,1.94.776-.188-.018-.779-.1-.395.123.348.47,1,.086,1.68.49l-.091-.321c.272.272,1.13.221.965.46.277-.009.836.384.839.1,1.136.62,2.984.834,3.581,1.536.186.014.606.2.558.039-.242-.235-.435-.03-.511-.161.158.044.214-.016.242-.046.358.181.648.3.225.393.788.434,1-.162,2.041.272-.081.091-.012.156.307.237l.651,0c.679.256.318.363.279.548a2.6,2.6,0,0,0,1.041.151l.381.365c-.279-.263.339-.018.527-.012l-.188-.007c.046.1.49.176.714.218-.018-.126-.444-.3-.674-.4.214-.023.5.083.785.063-.137.151.567.3.858.409.328.137.428-.047.525-.012-.018.095.549.177.247.228-.125,0-.239-.167-.453-.142.2.135.132.286.628.305.376.016.012-.376.642-.068a1.487,1.487,0,0,0-.393.077l.6.276.072-.154c.072.065.011.063.042.1.233-.112.965.214,1.16.063a9.117,9.117,0,0,1,.925.4l-.061,0a2.316,2.316,0,0,0,1.185.247l-.026.03a2.981,2.981,0,0,0,.953.151c.474.256.005.657.621.6.518.132.888-.083.709-.242a20.732,20.732,0,0,1,2.81.843c.151-.032.077-.095.362-.063a21.98,21.98,0,0,1,3.937,1.111c-.412-.028-.067.156-.079.251.362-.067.356.247.534.025,0-.156.053-.219-.318-.372a10.124,10.124,0,0,1,2.5.651c-.211-.121-.025-.125.163-.128-.114.221.483.395.957.418l.1-.13.263.216c.186-.005.262-.256.685-.019a.265.265,0,0,0,.1.183,3.946,3.946,0,0,1,1.694.165l.376.3c.225.023.62-.026.247-.167a6.077,6.077,0,0,1,1.652.683,16.67,16.67,0,0,1,3.705.263l-.864,2.294-1.59-.946.1-.068c-.363-.332-.312.04-.563-.195.186-.012-.2-.379.188-.3-.537-.444-.864-.277-1.276-.456-.132.091.358.1.191.216-.091.005-.771-.57-.972-.432-.109-.16.088-.233.212-.265l-.42-.114c-.323-.477,1.248.177.934-.362l-.356-.161c-.211-.383,1.025.281.212-.269-.423-.114-.9-.016-.614.255-.8-.379-.609.253-1.427-.221-.165-.239.678.339.606.095-.3-.374-.832-.348-1.148-.593.346.284-.088.3-.356.2-.372-.323.374-.032-.212-.381-.16.058-.753-.161-.321.177-.353.132-.583-.412-1.016-.391-.1-.283.841-.077.228-.521.012.226-.939-.207-.728.235-.232-.188-.186-.337.06-.341-.312-.305-1.064-.17-1-.576l-.221.107c-.084-.121-.228-.253-.367-.446-.327-.176-1.181-.316-1.011-.567-.119-.028-.86-.432-.669-.1.405.356.606.146.732.53-.221-.374-.683-.325-.986-.4l.011-.125c-.181-.044-.537-.26-.7-.2.153.005.126-.1.012-.191l-.249.07c-.693-.255-.012-.355-.671-.634l.546.125c-.119-.028-.26-.284-.59-.391-.193.083-.5.142-.662.2-.39-.121-.077-.244-.5-.277l.549.063c.093-.012-.19-.4-.671-.637-.332-.107-.911-.142-.469.183-.242-.119-.534-.379-.29-.386-.572-.225-.007.19-.523.044-.144-.191-.678-.627-.971-.946l.614,0-.328-.165c.523.016-.14-.256.2-.341a2.253,2.253,0,0,0-.758-.263c.493.653-.955.083-.911.476-.937-.362-.2-1.008-1.374-.992.116.151-.439.167.172.353-.544-.3-.527.118-1.129-.325.551.112-.379-.556.416-.395-.1.077.358.265.481.29-.176-.226.195-.279-.381-.555-.365-.14-.85-.365-.855-.176-.067.179.546.239.237.305-.728-.277-.72-.6-1.153-.428.451.188.477.418.412.532l-.546-.174.153-.067c-.783-.476-.339.09-1.123-.319l-.269-.4c.284-.109,1.122.635,1.13.251-.513-.263-.762-.179-1.215-.49.123.023.276.084.4.107-.183-.1-.17-.606-1.03-.7-.428-.083-.154.067-.219.181-.853-.353-1.16-.346-1.706-.577.218-.183-.943-.465-.239-.428a3.346,3.346,0,0,0,1.827.728c-.177-.416.641.344.951.149-.671-.318-.511-.574-.537-.8a1.624,1.624,0,0,0-.521-.133c-.156.132.088.242.023.421a5.381,5.381,0,0,0-1.983-.664c-.214-.195-.058-.33.247-.209a26.989,26.989,0,0,1-2.7-1.237c.428.521-.981-.36-.706.037.43.267.735.637.428.648-.277-.144.063-.116-.03-.228-.43-.011-.46-.493-.92-.414.858.276.307-.265.553-.414-.646-.142.093-.142-.493-.4a18.971,18.971,0,0,1-2.1-.59,13.111,13.111,0,0,0-2.845-1.206c-.344-.269.023-.407-.384-.623-.5-.2.26.416-.43,0l.091-.021c-.246-.033-1.283-.718-1.645-.453l.337-.176a.977.977,0,0,0-.405-.088c.03-.09-.1-.235.149-.2-.381-.37-.969-.36-1.466-.555l.255.288c-.9-.223-1.408-.588-2.252-.855l.086-.147-.527-.1c.177-.1-.233-.376-.542-.349l1.425.112c.318.228-.462.037-.3.277a1.5,1.5,0,0,0,1.1.358,1.292,1.292,0,0,0-.563-.133c-.011-.255.43-.074.707-.132-.158-.051-.349-.2-.409-.146a3.52,3.52,0,0,1,1.157.3c-.372-.053.13.209-.023.219.116-.174.614-.039,1.209.265.351.4,1.213.332,1.9.683a3.156,3.156,0,0,1-1.266-.021c.407.279.5.2.908.477a1.889,1.889,0,0,1,1.141-.06l-.028.154c.56.142.648-.065,1.3.262,1.118.56,2.3,1.064,3.165,1.457l-.028.154c.62-.095,1.662.606,2.371.76,1.048.63,2.47.939,2.921,1.446a58.556,58.556,0,0,1,5.712,2.5l-.434.039c.43.025.177.226.542.367-.325-.355.588.026.9.023a9.956,9.956,0,0,0,2.884,1.239l-.039.151a8.99,8.99,0,0,1,2.71,1.39,1.154,1.154,0,0,0,.5.467,7.11,7.11,0,0,1,1.762.486,17.263,17.263,0,0,1,1.989,1.23c2.292.832,4.346,2.217,6.628,3.282l.068.246a18.058,18.058,0,0,1,2.838,1.448l4.936,2.988-5.68-1.008c-1.564-.277-3.056-.656-4.286-.792l.258-.26c-.616-.225-1.467-.225-1.352.023-.62-.223-1.624-.2-1.976-.534a5.924,5.924,0,0,0-1.378-.119,19.771,19.771,0,0,0-3.005-.73l.3.091c.151-.033.191-.158-.109-.249-.476-.028-1.659-.484-1.29-.019-1.26-.513-3.088-.588-4.286-1.183.083.125-.242.063-.395.093a23.175,23.175,0,0,0-3.242-.89c-.169-.1.333-.086-.128-.221-.284-.035-.042.126-.393.09-1.892-.339-3.681-1.215-5.359-1.668-3.021-.678-6.077-1.717-8.9-2.615l.054-.06c-1.029-.046-2.122-.986-3-.848-.2-.144-.837-.325-.627-.4-.811-.07-2.027-.9-3.191-1.032a.781.781,0,0,0,.284.054c-1.034-.532-2.061-.683-3.154-1.236.126.012.346.067.4.011-.391-.293-1.153-.09-1.271-.513-.255-.09-.242.1-.084.149-2.452-1.046-5.175-1.857-7.785-2.787-1.768-.922.107-.6-1.446-.927-.093-.111-.135.093-.128.016-.6-.13-.73-.714-1.19-.7.081.267-.3.011-.365.128a6.833,6.833,0,0,0-2.175-1.058l.111-.079c-1.162-.119-2.3-.771-3.316-.786-5.747-2.3-11.281-4.464-16.774-7.037-2.217-1.1-4.42-2.18-6.6-3.368-.548-.3-1.092-.6-1.634-.922l-.814-.488-.418-.26c-.26-.165-.511-.33-.757-.5a9.223,9.223,0,0,1-2.391-2.129,2.473,2.473,0,0,1-.42-1,2.2,2.2,0,0,1,.093-1.053,2.089,2.089,0,0,1,1.28-1.167,5.992,5.992,0,0,1,2.5-.183c.681.121,1.187.255,1.6.348l.764.195c.4.09.827.13,1.617.228-.072.035-.172.026-.077.091.128-.228,1.1.205,1.294.009,2.208.539,4.234,1,6.47,1.61-.362-.072-.592.074-.168.174l.481-.03.053.086c.3.044.642.014.367-.144,5.664,1.373,10.944,3.595,16.331,5.354,1.243.528,3.084,1.064,4.483,1.5a114.272,114.272,0,0,0,11.757,4.662,3.735,3.735,0,0,1-2.514-.1",
    transform: "translate(50.878 75.739)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M99.28,108.937c.1.172.544.416.111.425,0-.126-.2-.341-.111-.425",
    transform: "translate(72.336 82.28)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M106.172,112.508c.03-.026.154.123.184.16-.154-.06-.337-.026-.432-.139.156.06.156-.005.247-.021",
    transform: "translate(77.373 84.975)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M108.344,113.471a3.042,3.042,0,0,1-1.2-.3Z",
    transform: "translate(78.296 85.475)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M109.463,114.334c.211.2.119.214-.214.056,0-.065.123-.04.214-.056",
    transform: "translate(79.883 86.356)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M109.559,114.259a.987.987,0,0,1,.423.335c.032-.091-.581-.205-.423-.335",
    transform: "translate(80.098 86.3)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M113.034,116.128c.153.067.516.144.6.323-.118-.154-.786-.235-.6-.323",
    transform: "translate(82.717 87.711)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M114.7,116.862a.636.636,0,0,0,.239.119c.147.13-.068.111-.216.047Z",
    transform: "translate(84 88.266)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M100.712,114.261l.346.063-.084.086Z",
    transform: "translate(73.435 86.301)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M87.158,109.091c-.348-.07-.184-.19-.23-.226.293.112-.16.081.23.226",
    transform: "translate(63.024 82.226)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M79.721,106.1l.1.042-.128.188Z",
    transform: "translate(57.557 80.137)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M124.3,121.78s-2.531,30.6,14.337,53.842,37.8,36.814,46.752,30.318,2.531-30.6-14.339-53.844S124.3,121.78,124.3,121.78m37.936,36.645c15.747,21.694,25.176,41.7,21.06,44.69s-20.218-12.178-35.964-33.872a138.087,138.087,0,0,1-21.06-44.69,138.1,138.1,0,0,1,35.964,33.872",
    transform: "translate(91.149 91.98)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M124.3,121.78s-2.531,30.6,14.337,53.842,37.8,36.814,46.752,30.318,2.531-30.6-14.339-53.844S124.3,121.78,124.3,121.78m37.936,36.645c15.747,21.694,25.176,41.7,21.06,44.69s-20.218-12.178-35.964-33.872a138.087,138.087,0,0,1-21.06-44.69,138.1,138.1,0,0,1,35.964,33.872",
    transform: "translate(91.149 91.98)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M146.907,141.817c.153.263.428-.072.516-.079-.381-.351-.6.154-.516.079",
    transform: "translate(108.314 106.96)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M145.01,139.948l.19-.039-.793-.3Z",
    transform: "translate(106.437 105.446)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M143.091,137.76c-.269.8,1.155,1.22,1.483,2.022l-.04.209.685-.077c-.711-.721-1.833-1.48-2.127-2.154",
    transform: "translate(105.419 104.05)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M142.894,136.12c-.109.3-.537-.244.321.493a.482.482,0,0,1-.018-.125,3.307,3.307,0,0,1-.3-.369",
    transform: "translate(105.142 102.811)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M142.981,136.381c.342.356-.039-.4,0,0",
    transform: "translate(105.359 102.919)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M142.059,135.63l.616.319c.032-.212-.325-.672-.093-.592-.546-.407-.574-.193-.523.272",
    transform: "translate(104.651 102.073)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M141.6,135.36l.3.179c.011-.091-.028-.176-.3-.179",
    transform: "translate(104.316 102.237)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M142.428,135.845l-.637-.383c-.023.149-.19.312.276.19-.195.1.049.068.362.193",
    transform: "translate(104.426 102.314)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M142.348,135.893c.125.376.362.792-.253.472.892.858,1.15.39.253-.472",
    transform: "translate(104.692 102.64)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M142.667,137.945l.149.5.446.165c-.221-.082-.439-.841-.6-.667",
    transform: "translate(105.124 104.17)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M140.734,133.6c-.137.077-.142.441-.249.611l.455.226c-.093-.251-.346-.656-.205-.837",
    transform: "translate(103.476 100.905)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M140.778,134.089l-.681-.337c.418.484.588.483.681.337",
    transform: "translate(103.183 101.023)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M141.288,135.688l1.187.5c-.449-.221-.885-.453-1.346-.658Z",
    transform: "translate(103.961 102.366)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M139.69,132.516l.539.037-.892-.133Z",
    transform: "translate(102.609 100.017)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M139.162,132.233c.42,0,.051-.646.4-.551a3.026,3.026,0,0,0-1.3-.523,1.836,1.836,0,0,1,.9,1.074",
    transform: "translate(101.801 99.064)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M137.872,131.047a4.02,4.02,0,0,0,.693.2,1.966,1.966,0,0,0-.693-.2",
    transform: "translate(101.502 98.98)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M139.727,133.528a.785.785,0,0,0-.091-.7l-.1.5.195.2",
    transform: "translate(102.756 100.324)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M139.708,133.319l0-.016c-.209-.223-.353-.379-.414-.444l.411.46",
    transform: "translate(102.578 100.348)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M139.694,133.277l-.049-.051c-.011.049-.009.07.049.051",
    transform: "translate(102.838 100.626)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M141.083,134.8c-.463-.139-1.246-.59-.934.272.419.014.239-.479.934-.272",
    transform: "translate(103.168 101.633)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M139.594,133.61l.453.614c.072-.09.1-.305.325-.237Z",
    transform: "translate(102.803 100.916)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M139.389,133.541l.36.165-.174-.223Z",
    transform: "translate(102.648 100.82)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M138.663,131.972a2.646,2.646,0,0,1-.953-.581,8.531,8.531,0,0,0,.857,1c.137-.056.437-.1.1-.414",
    transform: "translate(101.38 99.24)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M138.888,132.431l-.068-.033c.007.056.023.091.068.033",
    transform: "translate(102.218 100)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M136.048,129.85l-.005.1.061-.046Z",
    transform: "translate(100.12 98.075)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M138.22,132.067a.764.764,0,0,0,.609.386,4.75,4.75,0,0,1-.606-.5c-.061.025-.093.051,0,.109",
    transform: "translate(101.723 99.668)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M137.329,130.7a4.083,4.083,0,0,0,.253.558c-.028-.212-.132-.6-.253-.558",
    transform: "translate(101.092 98.714)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M138.823,132.337c.016.007.032.012.047.021-.011-.142-.033-.1-.047-.021",
    transform: "translate(102.221 99.899)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M139.034,132.357a1.871,1.871,0,0,0-.491-.118,2.682,2.682,0,0,0,.486.279.555.555,0,0,1,.005-.161",
    transform: "translate(102.009 99.88)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M134.708,131.11c.3-.262,1.181.025,1.443.823.734.258,1.271-1.025,1.281-1.989-.132.114-.239.232-.953-.086.049.335.9,1.471.184,1.324-.872-.5-.509-.637-.728-1.111-.026.639-1.411-.286-1.732.406l.809.372c-.061.1-.413.026-.3.262",
    transform: "translate(98.73 98.082)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M137.043,130.943l.258.174a2.934,2.934,0,0,1-.416-1.127c-.514-.2-.693-.158-.807-.082.37.344.727.7,1.083,1.064Z",
    transform: "translate(100.147 98.072)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M137.837,131.513c-.472.151-1.136-.216-1.127.435.678.59.707.165,1.23.395-1.137-.915.47.111-.13-.786a4.347,4.347,0,0,1,.655.455,6.142,6.142,0,0,1-.416-.66l.005.044.007,0-.005,0c.009.082,0,.121-.03.049-.007,0-.021-.011-.028-.014a.508.508,0,0,1-.16.074c-.247-.353.028-.128.16-.074a.51.51,0,0,0,.058-.035l0-.007-1.23-.825a5.676,5.676,0,0,0,1.013.943",
    transform: "translate(100.625 98.62)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M139.46,134.954a.125.125,0,0,1,.04-.1c-.1-.03-.153-.032-.04.1",
    transform: "translate(102.654 101.84)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M139.308,135.09a.594.594,0,0,1,.5.256c.109.3-.151.142-.244.253.225.068.721.307.428-.307l-.112-.033c-.293-.525-.423-1.448-.312-1.415a3.05,3.05,0,0,0-.263,1.246",
    transform: "translate(102.587 101.091)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M138.726,133.153l-1.008-.7.176.7.135-.183c.425.544.514.242.7.179",
    transform: "translate(101.386 100.044)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M136.3,129.806l.427-.233-.958.014Z",
    transform: "translate(99.911 97.866)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M135.442,129.285l.307-.26-.472-.1Z",
    transform: "translate(99.542 97.38)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M144.8,156.1l.311.193a1.367,1.367,0,0,0-.311-.193",
    transform: "translate(106.733 117.904)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M143.969,154.993l-.19.077c.156.021.249.007.19-.077",
    transform: "translate(105.964 117.066)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M127.5,133.758c-.147.625-.437,1.385-.053,1.153l.339-.318a1.4,1.4,0,0,1-.286-.835",
    transform: "translate(93.481 101.027)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M135.936,146.457c.011-.065.019-.132.03-.2l-.534-.061c.154.079.325.169.5.262",
    transform: "translate(99.659 110.421)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M136.688,145.946l.146.7a2.462,2.462,0,0,0-.146-.7",
    transform: "translate(100.608 110.233)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M150.27,161.763l.6-.035c-.446-.439-.407-.086-.6.035",
    transform: "translate(110.866 121.992)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M126.8,122.823a14.586,14.586,0,0,0-1.624-1.336c.944.888,1.766,1.861,1.624,1.336",
    transform: "translate(91.914 91.759)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M142.415,157.4c.2.116.328.128.4.061-.2-.123-.348-.165-.4-.061",
    transform: "translate(104.934 118.836)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M124.251,120.934c.147.135.279.253.423.384a4.708,4.708,0,0,1,1.2.628c-.685-.651-1.443-1.257-1.624-1.013",
    transform: "translate(91.214 91.3)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M150.672,152.433c0-.042-.016-.084-.014-.123-.056.021-.033.065.014.123",
    transform: "translate(111.135 115.04)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M148.159,144.015a4.939,4.939,0,0,1,.377.477,1.481,1.481,0,0,0-.377-.477",
    transform: "translate(109.272 108.775)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M132.662,126.709c.281.188.072,0,0,0",
    transform: "translate(97.567 95.703)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M132.864,128.055a.27.27,0,0,0-.237.079.339.339,0,0,1,.237-.079",
    transform: "translate(97.541 96.719)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M125.665,124.352l.005.025c.121.088.1.068-.005-.025",
    transform: "translate(92.282 93.923)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_720",
    "data-name": "Path 720",
    d: "M132.926,127.136a2.154,2.154,0,0,0-.254-.37,2.324,2.324,0,0,0,.254.37",
    transform: "translate(97.574 95.746)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_721",
    "data-name": "Path 721",
    d: "M132.86,126.861l.2.216c.081-.03.079-.088-.2-.216",
    transform: "translate(97.717 95.818)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_722",
    "data-name": "Path 722",
    d: "M132.446,126.552a2.465,2.465,0,0,1,.4.376c-.033-.065-.039-.1-.016-.1l-.381-.274",
    transform: "translate(97.404 95.585)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M157.594,165.668a.351.351,0,0,1,.033-.051c-.223-.212-.177-.116-.033.051",
    transform: "translate(116.307 124.999)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M131.774,137.177c-.011-.012-.025-.014-.035-.025l.007.051Z",
    transform: "translate(96.87 103.591)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_725",
    "data-name": "Path 725",
    d: "M133,138.054c-.709-.2-.778-.488-.843-.874l-.957.9Z",
    transform: "translate(96.461 103.612)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M165.373,187.72l-.26-.869c1.143.3,1.455.974,1.348.037-1.1.837-2.219-2.268-3.316-1.455l-.139-.6c.093.126.169.091.26.218-.195-1.225-1.26.056-2-1.1-.228-.43-.29-.811.042-.669l-.941-.59c-.179-.251.053-.346.23-.1l-1.116-1.167.039-.016a6.464,6.464,0,0,1-1.173-.341c-.111-.441.244.067.307-.121l-.821-.484c.046-.507.776-.146,1.13.36.523-1.506-.735-.356-1.252-2.254l.665.544c.258-.906-.37-1.241-.581-2.285-.06.33.233,2.249-.634,1.7a1.315,1.315,0,0,0-.816-.828c.377-.307-.037-.63-.451-1.116l.532-.363c-.569-.428-.793-.184-1.271-.326a1.218,1.218,0,0,1,.093-1.476c-.665-1.041-.116,1.164-1.1.079-.427-.965-1.074-1.374-2.117-2.131-.253-.709.39-.135.383-.451l-.792-.2c-.084-.132.072-.186.151-.212-.479-.312-.544.349-1.185-.23-.7.232-.211-2-1.441-2.387,0-.316.391-.128.549-.337a8.635,8.635,0,0,0-2.259-1.336l-.221-1.058c.023.871-1,.43-1.847-.005a5.271,5.271,0,0,0-.088.829c-.355-.3-.678-.616-1.016-.927,0-.193.258-.2.6-.163-.093-.047-.183-.091-.26-.121-.056-.532.388-.525.869-.437-.025.205-.049.414-.076.62a1.683,1.683,0,0,0,1.308-.191.912.912,0,0,1-.381-.263c.133.012.242.005.274-.063s-.16-.111-.411-.2l.439-.644-.277.095L145.814,163c-1.269-.639-2.758-.985-4-2.545.7.153.793-.348,1.343-.641-.29.792.988,1.169,1.415,2.085-.223-.479.091-.537.253-.479-.488-.4-.951-.821-1.431-1.234.458-.225.135-.525.081-1.034-.69.814-1.259-.82-1.9-1.3.272-.205.662-.223,1.043.586.158-1.218-1.676-.514-1.573-1.689.112.19.123.318.314.311-.507-.3-.893-1.518-.495-1.4l.111.188a15.767,15.767,0,0,0-1.367-2.417c-.532-.793-1.106-1.4-1.536-1.3a5.934,5.934,0,0,1,1.2-.293c-1.239-.337-2.5-.686-3.746-1.058.764-.116,1.954-1.659,2.856-.762a2.19,2.19,0,0,0-.671-1.336c0,.256-.711.988-.909.725a6.766,6.766,0,0,0,.309-2.027c.005.386-1.206.514-1.41-.011.193.007,1.015-.514,1.209-.381-.534-.263-1.085-.521-1.61-.8.325.235.9-.337,1.069-.75-.146.221-.458-1.106-.707-1.4l-.007.644c-.455-1.506-2.1-.788-2.628-2.273.288.09,1.5-.116,1.339-.9-.664-.114-3.2-.444-4.116-1.606l.214-.37-.732-.874a27.683,27.683,0,0,1,4.469,2.066c.025-.639.3-.295-.054-1.1.174-.4.616.269.728.5-.191-.651-.384-1.3-.555-1.959-.6.326-1.181-1.213-1.682-.946l1.436,1.824c-.6.332-2.243-.513-2.647-1.924.121-.439,1.227-.154,1.427-.263a.706.706,0,0,1-.26-.219c-.088-.095-.214-.3-.262-.348-.119-.156-.2-.34-.125-.383a3.464,3.464,0,0,0,.46.218c.063-.2-.2-.284-.451-.463-.242-.16-.47-.428-.186-.592-.005-.081.207-.13.379-.14s.284-.009.032-.126c-.911-.258-3.656-.853-4.483-1.59a6.615,6.615,0,0,1,.16-.941c.105-.409.276-.72.467-.73.3,0,.9.618,1.431,1.1a4.962,4.962,0,0,0,1.346,1.015,4.606,4.606,0,0,1-.758-.732c.154-.056.828.665.583.163-1.018-.883-.2-.864-.914-.92-.453-.779.04-.349-.165-.953a12.65,12.65,0,0,1-1.61-1.92,14.779,14.779,0,0,1-1.478-2.457,4.8,4.8,0,0,0,.7.707,3.519,3.519,0,0,1-.1-1.153c.744.6,1.38,1.155,2,1.567a8.585,8.585,0,0,1,1.216,1.683c-.03-.179-.181-.583.1-.409,1.155,1.552-.506-.225.692,1.513-.441-.818.044-.686.279-.832-.295-.6-.6-.853-.83-.914a.334.334,0,0,0-.411.225,4.181,4.181,0,0,1-.778-2.075c.06-.4.446-.507,1.116-.3,1.141.5.8,1.2.958,1.16,1.1.883,1.471.7,1.933.637.434-.088.969,0,1.971,1.143.344.6.233.848.09,1.051s-.341.342-.33.593c-.841-.388-1.22-1.367-1.862-1.8l.734.85a1.487,1.487,0,0,1-1.106-.613,8.713,8.713,0,0,0,1.875,1.757c.416.33.857.678,1.255,1.025a7.931,7.931,0,0,1,1.046,1.1c.355.051.888.239.827-.09l-.477-.284c-.123-.658,1.188.179.771-.418a3.891,3.891,0,0,1,2.373,1.243l-.244.6c.1-.153-.288-.721-.634-.767.511.072.692,1.671,1.576,1.36l-.286-.8c.765.247,1.919.332,2.486,1.106.077-.741-.2-.091-.244-1.065-.135,1.043-1.81-1.571-1.7-.263.011-1.071-.674-1.029-.913-2.145-.107.176,0,.5-.551-.07a.894.894,0,0,1-.247.032l-.032-.046.019.046c-.046,0-.053.005.007.018a.891.891,0,0,1,.118.49c-.6.118-1.56-.671-2.038-.744-.3-.365.295-.061.233-.39l-.714-.109c.379-.293-.96-1.673.516-.886l-1.225-.951a7.89,7.89,0,0,0-2.428-2.031c-.642-.6-1.515-.446-1.016-.541l-1.917-.993-.061-.179a18.607,18.607,0,0,0-2.731-1.487,14.3,14.3,0,0,1-3.374-2.507,6.847,6.847,0,0,1-2.192-1.213l0,.014-.539-.569a7.7,7.7,0,0,1,.327,1.734,3.863,3.863,0,0,0,.52,1.655c-.625-.353-.4.841.005,2.254.221.714.449,1.457.66,2.138.1.33.188.644.272.936s.161.563.2.783l.676.486a24.849,24.849,0,0,0,1.58,4.016l.479.021a5.954,5.954,0,0,1,.741,2.194c.082.427.174.9.281,1.378a5.257,5.257,0,0,0,.284.967c-.195-.026-.272-.363-.262-.627-.384,1.876,1.89,2.928,1.761,4.548a.989.989,0,0,1,.327.823.19.19,0,0,0-.056-.075,1.138,1.138,0,0,0,.053.14c-.012.181-.033.369-.032.563a1.829,1.829,0,0,0,.063-.488,4.638,4.638,0,0,0,.6.972l-.376.351c.019.03.032.053.051.084,0,.448.342.212.592-.13a2.086,2.086,0,0,0,.488.391c-.585.616.676.9.093,1.652.472.1,1.141,1.8,2.015,1.636-.095.06-.091.193-.193-.009a1.839,1.839,0,0,0,.609,1.2l-.472.441,1.174.563c-.075.718-.146,1.039-.851.7,1.32,1,.788.957,2,1.755l-.383.125c.216.395,1.011.792.839,1.185-.2,1.239,2.217,4.444,2.958,7.005.755-1.029.158,1.308.99.93-.161.272-.112.667-.53.428.89,1.006.683,1.924,1.811,2.294-.153.277-.495-.021-.562.181.107.058.43.226.365.432s-.3-.039-.516-.153c.771,1.125,1.56.774,2.285.42.051.778.269,1.048.988,1.157-.084.34-.084.82-.641.184.235.407,1.327,2.586,1.882,2.257-.051.214.335.567.467.625a12.128,12.128,0,0,0,1.234,1.8l-.084-.293c.865-.13.646.588,1.211,1.2l-.077.028c.688,1.861.7.5,1.32,2.385l.323-.372c.932-.488.518,1.692,1.5,2.317l-.023-.479c.642.251-.093,2.177.176,2.735.01.158-.241-.075-.406-.177.488,1.618.621-.228,1.462.6-.133.381-.853.319-.411.978.028.486,2.294,1.1,2.466,2.34.053-.351.109-.7.6-.4.6.577.669,2.375,1.8,2.415a.286.286,0,0,1-.061.247c.574.351,1.611,1.348,2.2,1.341-.876,1.55,3.217,2.435,2.069,3.439l1.387,1.4-.151.07a2.416,2.416,0,0,0,1.927,1.127c.125.283-.125.228-.2.267a3.98,3.98,0,0,0,2.854,2.18l-.237.465c.493.086,1.353,2.44,3.1,3.238a.346.346,0,0,1-.3.03,8.684,8.684,0,0,1,2.347,2.385c.707.836,1.422,1.448,2.278.953.448.163.909.311,1.366.455-1.343-1.141.672-.486.267-1.15.6.312,1.129,1.453.377,1.06l-.056-.151c-.816.616,1.645,1.49,1.294,2a16.358,16.358,0,0,0,3.082,1.436,5.529,5.529,0,0,0,3.279.2,3.649,3.649,0,0,0,2.347-2.124,6.773,6.773,0,0,0,.5-3.347,5.77,5.77,0,0,1-.7.4c-.04-.484-.028-.992-.116-1.466.1-.383.493-.6.627.546.188-.3,0-.793-.219-1.169a1,1,0,0,0-.586-.546c-.088-1.678.983.442.886-.051l-.214-.674-.047.176c-.42-.486-.748-.439-.979-1.41-.046-.639.337-.439.29-.685.049-.014.047-.1-.1-.369-.123-.477-.276-.93-.414-1.4l-.355.739c-.481-.506-.423-1.276-.818-.434.314-.623-.079-1.9-.57-3.079a15.865,15.865,0,0,1-1.065-2.58,5.769,5.769,0,0,1-1.543-2.364c.011.29-.5.718-.841-.132,1.359-.309-.233-1.757.274-2.863-.251.881-1.374-2.229-1.685-.878-.265-.725.421-.281.425-.944-1.334-1.343-1.666-3.672-2.97-5.524-.17.061-.209.521-.683.244l.146-1.471c-.307-.335-1.08.177-.981-.832-.067.176-.168.437-.374.214-1.573-4.216-5.394-7.172-6.6-11.748.061.693-.195.379-.469.009.105.293-.362.244-.525.428l-.53-1.908c-.734.1-1.2-1.6-1.829-1.39l.437.413c-1.067-.2-.718,1.861-1.571,2.324,1.2.225.293,2.6,2.1,3.074.016.37-.409-.044-.5.221.544.063.867.372,1.167,1.146l-.135-.018c1.355,1.826,1.564,2.859,2.717,5.141l.3-.416a2.046,2.046,0,0,1,.219.951c.95.139-.8-1.313.179-1.264-.414,1.13,2.07,3.268,1.385,4.272.435.718.339-.5.776.219l-.137.346.439-.021a.891.891,0,0,1-.147,1.085c-.042-.13-.256-.288-.348-.4.067.792,1.141,1.657,1.166,1.927l-.256-.785c1.42,1.824,2.468,4.437,4.048,6.089l.118-.255c1.169,1.294.425,1.308,1.45,2.861l-.079-.035a2.426,2.426,0,0,1,.9,1.087c-.444-.3-.063,1.011-.6.593,1.2,1.439.707.651,1.983,1.385l-.221.411a1.754,1.754,0,0,1,1.127,1c-.6-.563-.281.769-1.009.169.025,2.071,1.892,2.312,1.092,3.569,1.287.449-.068-1.75.311-1.373.154-.514,1,.39,1.113,1,.2.592-.853,1.443-.381,2.851-.04-.142-.118-.128-.16-.272-.074.607.663.946.432,1.711.69.211.161.843.964.778-.17-.427-.312-.853-.506-1.28.4.674,1.515,1.288,1.187,2.361a3.831,3.831,0,0,1-.579-.6c-.188.258.228.523.011.755a.727.727,0,0,1-.548-.655,2.751,2.751,0,0,0-.137-.46,1.539,1.539,0,0,0-.418-.614.472.472,0,0,0,.025.395,1.407,1.407,0,0,0,.2.346c.107.149.137.244-.312.177.578.095.579.342.528.528-.051.214-.137.337.277.846l-.5-.3c.081.105.29.413.242.563a5.281,5.281,0,0,0-.593-.655c.256.316.09.427-.111.409-.216-.012-.42-.125-.42.082.207-.132.327-.054.5.147s.335.5.6.509c.012.409-.191.53-.37.493s-.383-.23-.558-.42c-.376-.42-.632-.9-.888-.846.04-.054.425.411.325.646a1.217,1.217,0,0,1-.481-.73c-.191-.025-.219.093-.191.272s.126.411-.032.5c-.065-.353-.121-.311-.263-.207a.946.946,0,0,1-.59.249l.228-.428c-1.164-1.073-.888.672-1.954-.485l.911-.2-.755-.293.448-.365a2.306,2.306,0,0,1-1.69-1.05c-.046.39-.627.637-1.248.16-.233-.56.518-.174-.379-.813.386-.077.832-.205.923.444.135-.091.379-.091.514-.183-.233-.606-1.051-.939-1.357-1.2a1.071,1.071,0,0,1,.255.362l-1.65-.52c-.068-.305.176-.279.42-.261a6.042,6.042,0,0,1-.978-.442c.355-.211.6-.534,1.227-.228l-1.424-.685c.04-.2-.256-.878-.012-.85-.458-.734-2.038-.862-2.629-1.878a.7.7,0,0,1-.441-.146c-.7-.814-1.006-1.82-2.268-2.359l.018-1.006c-.8-.606.023,1.32-1.308.3-.964-.707.144-.732.009-1.167-.658-.177-1.876-.444-2.175-1.629.339.176.449.453.711.664m-8.2-9.163c.226.125.772.295.66.611-.6.137-.532-.191-.66-.611M145.175,164.1c.23.063.311.337.323.7a1.312,1.312,0,0,1-.323-.7m-9.056-34.93a.142.142,0,0,0-.039,0c-.635-.714-.411-.451.039,0m1.306,1.248c.172.046.2-.018.175-.121-.163.03-.474-.193-.814-.493.049.2.179.4.639.614M186,195.879l-.051.256c-.29-.448-.126-.349.051-.256",
    transform: "translate(90.222 90.728)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M136.642,145.99a.521.521,0,0,1-.161.23c.121.032.2-.019.161-.23",
    transform: "translate(100.452 110.266)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M150.208,161.662l.023.03a.221.221,0,0,0,.088-.037Z",
    transform: "translate(110.82 122.098)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M128.015,127.853a.356.356,0,0,1-.274-.019c.163.114.281.151.274.019",
    transform: "translate(93.85 96.553)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M134.548,128.036l-.641-.372a1.091,1.091,0,0,1,.4.544c.06-.1.06-.312.239-.172",
    transform: "translate(98.507 96.425)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M135.864,131.633c.116.028.167.146.283.172l.132-.184c-.335-.293-.686-.372-.414.012",
    transform: "translate(99.912 99.226)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M134,128.822c-.223.349.219.527.646.806a.428.428,0,0,1-.067-.06c.488-.335-.044-.548-.579-.746",
    transform: "translate(98.53 97.299)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M134.4,129.32a1.909,1.909,0,0,1,.356.3c.195-.133-.111-.161-.356-.3",
    transform: "translate(98.876 97.675)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M132.21,126.625c.123.233.442-.314.446-.1.534-.239-1.648-.514-.446.1",
    transform: "translate(96.948 95.359)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M133.776,129.768l.19-.5-.479.128Z",
    transform: "translate(98.19 97.638)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M132.052,127.958l.537.611c.044-.074.154-.046.274.005-.367-.332-.734-.742-.811-.616",
    transform: "translate(97.106 96.629)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M132.514,128.3a1.325,1.325,0,0,0,.548.351,2.911,2.911,0,0,0-.548-.351",
    transform: "translate(97.455 96.904)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M133.344,129.488l-.114-.232-.409-.393Z",
    transform: "translate(97.687 97.33)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M128.155,124.844l-.679-.3a1.04,1.04,0,0,0,.551.63c.095-.074.342.018.128-.33",
    transform: "translate(93.65 94.068)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M129.406,127.011a3.447,3.447,0,0,1-.3-.7l.084.848a1.479,1.479,0,0,1,.214-.146",
    transform: "translate(94.883 95.401)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M128.47,126.2c.025.239-.33.4.2.723-.084-.277.349-.154-.2-.723",
    transform: "translate(94.33 95.317)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_742",
    "data-name": "Path 742",
    d: "M127.342,127.925l-.075-.2-1.288-.688c.46.312.893.6,1.364.89",
    transform: "translate(92.519 95.95)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M130.732,133.438c-.176-1.029-.683.025-.748-.946-.314-.13.051.8-.233.648.476.469.474.82.981.3",
    transform: "translate(95.368 100.061)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M129.864,132.955a2.2,2.2,0,0,0-.262-.232,1.026,1.026,0,0,0,.262.232",
    transform: "translate(95.256 100.246)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M147.711,142.979l-.219-.671-.026.553Z",
    transform: "translate(108.748 107.485)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_746",
    "data-name": "Path 746",
    d: "M146.944,142.566l.437-.511-.714.019c.112.105.33.312.277.491",
    transform: "translate(108.145 107.294)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M142.455,152.132l-.154.058c-.07.184.016.312.186.571Z",
    transform: "translate(104.829 114.905)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_748",
    "data-name": "Path 748",
    d: "M145.531,156.279l-.09-.125-.262.6Z",
    transform: "translate(107.022 117.944)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_749",
    "data-name": "Path 749",
    d: "M148.828,159.376c-.188-.237-.525-.409-.714-.648.527.409.232,1.209.714.648",
    transform: "translate(109.238 119.887)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_750",
    "data-name": "Path 750",
    d: "M124.194,123.176c-.279-.107-.272.328-.333.39.488.028.351-.5.333-.39",
    transform: "translate(90.919 93.022)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_751",
    "data-name": "Path 751",
    d: "M127.261,123.567l-.149.13.915-.126Z",
    transform: "translate(93.375 93.331)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_752",
    "data-name": "Path 752",
    d: "M131.377,125.2c-.188-.862-1.806-.576-2.579-1.151l-.086-.207-.592.391c1.079.319,2.594.477,3.256.967",
    transform: "translate(94.137 93.536)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_753",
    "data-name": "Path 753",
    d: "M131.32,126.18c-.044-.321.642.011-.555-.328a.869.869,0,0,1,.079.111,4.329,4.329,0,0,1,.476.218",
    transform: "translate(96.134 95.056)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_754",
    "data-name": "Path 754",
    d: "M130.888,125.933c-.506-.191.233.353,0,0",
    transform: "translate(96.09 95.086)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_755",
    "data-name": "Path 755",
    d: "M132.469,126.447l-.75-.074c.067.212.623.513.362.523.716.183.651-.028.388-.449",
    transform: "translate(96.855 95.45)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M132.787,126.334l-.381-.061c.03.091.107.154.381.061",
    transform: "translate(97.374 95.374)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M131.946,126.238l.807.13c-.046-.149.042-.365-.362-.081.147-.165-.081-.046-.446-.049",
    transform: "translate(97.026 95.279)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M132.154,126.348c-.3-.311-.734-.621.023-.544-1.3-.467-1.306.065-.023.544",
    transform: "translate(96.46 94.883)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M130.687,124.456l-.425-.407-.53.053c.267-.033.9.574.955.355",
    transform: "translate(95.354 93.694)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M134.551,128.042c.111-.116-.026-.47.016-.669l-.549-.086c.195.218.606.537.534.755",
    transform: "translate(98.59 96.14)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M134.33,127.393l.825.128c-.616-.349-.788-.3-.825-.128",
    transform: "translate(98.827 96.12)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M133.493,125.951l-1.418-.053,1.652.153Z",
    transform: "translate(97.123 95.091)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M136.058,128.536l-.556.09.946-.075Z",
    transform: "translate(99.712 97.083)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M136.928,129.066c-.434.09.139.65-.253.634a4.444,4.444,0,0,0,1.48.267,2.528,2.528,0,0,1-1.227-.9",
    transform: "translate(100.598 97.484)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M138.278,129.672a4.344,4.344,0,0,0-.76-.093,2.277,2.277,0,0,0,.76.093",
    transform: "translate(101.235 97.871)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M135.461,127.8a.893.893,0,0,0,.33.69l-.063-.53-.267-.16",
    transform: "translate(99.681 96.529)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M135.612,127.883l0,.018.57.355-.574-.372",
    transform: "translate(99.795 96.59)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M135.423,127.786l.067.04c-.005-.051-.014-.074-.067-.04",
    transform: "translate(99.652 96.505)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M133.858,126.879c.521,0,1.511.218.832-.544-.432.109-.044.542-.832.544",
    transform: "translate(98.47 95.421)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M135.78,127.611l-.706-.474c-.039.109.019.325-.24.325Z",
    transform: "translate(99.208 96.027)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M135.8,127.481c-.14-.032-.288-.047-.432-.074l.262.176Z",
    transform: "translate(99.614 96.231)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M137.484,129.187a2.752,2.752,0,0,1,1.141.442,6.211,6.211,0,0,0-1.165-.872c-.126.082-.43.19.025.43",
    transform: "translate(101.027 97.25)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M136.532,128.456c.026.005.058.012.082.019-.025-.056-.054-.086-.082-.019",
    transform: "translate(100.49 96.994)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M140.16,130.675l-.012-.105-.056.051Z",
    transform: "translate(103.179 98.619)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M137.677,128.806a.924.924,0,0,0-.76-.255,6,6,0,0,1,.79.363c.056-.037.082-.068-.03-.109",
    transform: "translate(100.781 97.093)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M138.77,130.14a4.671,4.671,0,0,0-.4-.534c.083.214.283.592.4.534",
    transform: "translate(101.88 97.891)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M136.63,128.549a.31.31,0,0,1-.056-.011c.056.139.067.093.056.011",
    transform: "translate(100.522 97.085)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M136.626,128.614a2.134,2.134,0,0,0,.548.011,3.3,3.3,0,0,0-.593-.174.6.6,0,0,1,.046.163",
    transform: "translate(100.526 97.019)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M142.842,130.158c-.288.284-1.287.021-1.727-.82-.843-.235-1.127,1.171-.974,2.18.119-.128.209-.262,1.022.032-.111-.346-1.222-1.5-.442-1.383,1.025.481.665.648.983,1.134-.091-.674,1.576.24,1.81-.488l-.955-.369c.051-.1.449-.042.284-.286",
    transform: "translate(103.186 97.669)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M139.529,130.1l-.316-.142a2.989,2.989,0,0,1,.688,1.088c.569.168.748.114.855.028-.439-.348-.89-.679-1.359-.987Z",
    transform: "translate(102.515 98.16)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M138.812,129.865c.455-.223,1.253.067,1.08-.6-.872-.52-.793-.075-1.4-.24,1.429.783-.521-.046.337.792a5.278,5.278,0,0,1-.8-.372,7.552,7.552,0,0,1,.6.616l-.016-.042-.007,0,0,0c-.03-.084-.032-.125.019-.054a.074.074,0,0,1,.032.011.474.474,0,0,1,.149-.1c.348.327,0,.135-.149.1a.292.292,0,0,0-.051.044l0,.007,1.492.669a6.929,6.929,0,0,0-1.294-.821",
    transform: "translate(101.622 97.436)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M135.02,126.092a.117.117,0,0,1,0,.114c.119,0,.172-.012,0-.114",
    transform: "translate(99.348 95.237)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M135.74,126.592a.741.741,0,0,1-.63-.112c-.242-.27.095-.183.146-.318-.263-.007-.876-.1-.316.425h.132c.525.437,1.025,1.3.893,1.3a2.814,2.814,0,0,0-.225-1.3",
    transform: "translate(99.115 95.282)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M136.982,127.97l1.3.495-.416-.671-.082.212c-.634-.463-.627-.139-.8-.037",
    transform: "translate(100.83 96.5)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M140.307,130.781l-.406.272,1-.079Z",
    transform: "translate(103.035 98.779)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M141.081,131.334l-.286.284.514.074Z",
    transform: "translate(103.71 99.197)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M147.977,169.324l-.427-.119a1.818,1.818,0,0,0,.427.119",
    transform: "translate(108.812 127.801)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M149.349,170.2l.156-.139c-.176.03-.265.072-.156.139",
    transform: "translate(110.135 128.447)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M156.079,150.293c-.075.681-.325,1.506.049,1.253l.319-.348a1.824,1.824,0,0,1-.369-.906",
    transform: "translate(115.14 113.516)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M161.233,166.488c.054-.046.112-.095.169-.144-.114-.172-.218-.328-.332-.47a5.843,5.843,0,0,1,.163.614",
    transform: "translate(119.024 125.285)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M162.326,166.7a7.743,7.743,0,0,1-.5.774,2.694,2.694,0,0,0,.5-.774",
    transform: "translate(119.593 125.909)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M140.411,163.721l-.662-.009c.563.52.469.126.662.009",
    transform: "translate(102.92 123.652)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M148.428,138.157a4.569,4.569,0,0,0,.556,1.127c-.17-.618-.179-1.236-.556-1.127",
    transform: "translate(109.475 104.341)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M149.864,167.332c-.244-.051-.377-.025-.42.063.251.06.411.056.42-.063",
    transform: "translate(110.243 126.367)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M149.626,139.9c-.019-.093-.054-.174-.079-.265a4.205,4.205,0,0,1-.8-.843,1.452,1.452,0,0,0,.881,1.108",
    transform: "translate(109.715 104.831)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M123.667,134.533c.012-.046.014-.1.03-.142-.06,0-.054.056-.03.142",
    transform: "translate(90.76 101.506)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M125.257,124.587c.023.163.032.43.044.683a2.016,2.016,0,0,0-.044-.683",
    transform: "translate(91.974 94.101)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M144.077,133.937c-.288-.228-.074,0,0,0",
    transform: "translate(106.078 101.085)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M143.862,132.513a.279.279,0,0,0,.253-.068.357.357,0,0,1-.253.068",
    transform: "translate(106.026 100.036)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M151.765,140.268l.018.028c.005-.142,0-.116-.018-.028",
    transform: "translate(111.996 105.89)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M143.855,133.6a3.9,3.9,0,0,0,.265.413,2.1,2.1,0,0,0-.265-.413",
    transform: "translate(106.021 100.905)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M143.927,133.813l-.223-.235c-.083.026-.081.088.223.235",
    transform: "translate(105.872 100.891)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M144.411,134.27a3.045,3.045,0,0,1-.405-.439c.033.072.039.112.014.109.082.068.2.167.391.33",
    transform: "translate(106.135 101.083)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M130.768,151.275a.676.676,0,0,1-.012-.091c-.367-.23-.249-.1.012.091",
    transform: "translate(95.952 114.096)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M160.607,154.5c-.011-.016-.026-.021-.035-.035l.005.06Z",
    transform: "translate(118.648 116.669)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M161.819,155.7a1.245,1.245,0,0,1-.8-1.2l-1.034.855Z",
    transform: "translate(118.205 116.695)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M160.276,200.673l.562.915c-1.348-.209-1.922-.925-1.5.088.913-.988,3.254,2.213,4.165,1.139l.39.606c-.151-.116-.221-.067-.369-.183.713,1.269,1.339-.3,2.621.739.434.39.692.755.263.7l1.285.353c.312.211.118.372-.193.163.586.295,1.2.56,1.792.839l-.032.028a10.361,10.361,0,0,1,1.409-.079c.367.393-.288.025-.246.232.377.056.744.123,1.127.158.27.5-.713.462-1.373.075.367,1.678.943.1,2.738,1.668-.358-.067-.714-.14-1.06-.232a1.748,1.748,0,0,0,.886.99,13.4,13.4,0,0,1,1.415.886c-.262-.309-1.933-1.975-.658-1.864a1.849,1.849,0,0,0,1.422.342c-.133.463.52.56,1.341.714l-.207.613c.936.039.936-.307,1.517-.5a1.724,1.724,0,0,1,1.359,1.18c1.7.258-1.088-.9.9-.843a5.861,5.861,0,0,0,4.053-.779c1.046-.095-.068.434.337.5.256-.26.5-.516.727-.772.216-.058.2.1.2.2.639-.507-.169-.623.807-1.271-.042-.405.586-.439,1.332-.7a2.4,2.4,0,0,0,1.74-1.6c.356-.179.205.386.463.453.2-.5.341-.851.453-1.129.084-.281.133-.486.176-.681a5.3,5.3,0,0,0,.084-1.594,10.819,10.819,0,0,0,.83-1.085c-.767.757-.867-.583-1.158-1.611-.295.251-.549.449-.681.59-.012-.518.019-1.009-.037-1.517.13-.158.326.019.555.312-.037-.111-.075-.218-.112-.3.314-.495.642-.177.937.286a4.6,4.6,0,0,1-.493.484c.3.451.634.929,1.018.937a1.552,1.552,0,0,1-.049-.572c.081.126.158.214.232.179s-.021-.244-.123-.541l.767-.249-.267-.139a20.53,20.53,0,0,0,.686-2.142c-.651-1.618-1.7-2.866-2.24-5.094.585.509.867.032,1.492-.011-.6.707.451,1.808.342,3.084.046-.653.348-.521.458-.355-.218-.753-.463-1.482-.737-2.192.506,0,.353-.511.476-1.108-.941.549-.869-1.539-1.352-2.349.323-.116.7.033.806,1.12.537-1.318-1.411-1.318-1.029-2.564.061.254.04.4.23.469-.411-.539-.511-2.043-.153-1.769l.07.253c-.247-1.743-1.417-5.115-2.315-5.078A4.96,4.96,0,0,1,189.6,181c-1.227-.693-2.473-1.334-3.712-1.94.783,0,2.062-1.583,2.949-.376a2.919,2.919,0,0,0-.658-1.673c0,.3-.748,1.03-.944.7a6.92,6.92,0,0,0,.316-2.3c.012.449-1.23.448-1.443-.172.2.028,1.029-.488,1.23-.309-.551-.37-1.122-.725-1.683-1.076.349.295.909-.311,1.053-.781-.13.246-.555-1.323-.851-1.673l.056.744c-.63-1.768-2.2-1-2.954-2.654.307.093,1.532-.14,1.246-1.048-.713-.135-3.337-.432-4.478-1.61l.146-.425-.915-.892a20.505,20.505,0,0,1,4.946,2.024c-.086-.741.258-.351-.249-1.269.105-.472.681.291.839.558-.316-.757-.628-1.515-.967-2.261-.546.416-1.483-1.32-1.938-.957l1.882,1.983c-.553.409-2.4-.439-3.138-1.969.018-.511,1.208-.311,1.387-.451-.312-.081-1.2-1.2-1.13-1.417l.676.453c-.253-.967-1.56-.9-1.6-2.212-.161-.365.128-1.473-.253-1.318a4.638,4.638,0,0,1-3,2.245,14.833,14.833,0,0,1-.372-2.7c.16-.872,1.736.044,1.878-.7-.17.077-.551-.105-.7-.19-.095-.434.576-.165.011-.876-.656.246-.955-1.569-.718-.042-.649-.627-.386-.867-1-1.7-.184.516-1.769.079-2.421-.527.172-.056.249-.349.279-.484a40.032,40.032,0,0,0-2.338-3.779c.035-.221-.314-.985.133-.9a1.922,1.922,0,0,1-.9-.544c-.169-1.167.8.855.872-.195-.353.195-1.271-.72-1.92-1.137-.326.577.969,1.411,1.629,1.843-.676.534-2.133.061-3.528-.981-1.087-.853.007-.8-.246-.888-1.661-1.982-2.543-.6-3.579-2.526-.239-.958.723-.8.86-1.2.976.618.951,1.488,1.5,2.013l-.455-.864a2.349,2.349,0,0,1,1.15,1,7.044,7.044,0,0,0-1.662-2.175,20.637,20.637,0,0,1-2.54-2.7c-.384-.109-.96-.386-.89-.025l.516.374c.133.72-1.271-.356-.82.339a5.8,5.8,0,0,1-2.622-1.487l.216-.618c-.093.156.369.772.748.836-.553-.095-.892-1.8-1.815-1.5l.377.857a6.638,6.638,0,0,1-2.766-1.178c.019.76.239.083.4,1.078.046-1.1,2.022,1.689,1.806.314.068,1.12.8,1.1,1.1,2.254.109-.176-.019-.516.588.1a.937.937,0,0,1,.263-.018l.035.049-.021-.049c.049,0,.056,0-.009-.018a.956.956,0,0,1-.142-.513c.66-.109,1.65.865,2.161,1,.316.423-.316.025-.253.377l.757.211c-.253.381.49,1.474-.576.848l.781.751a3.98,3.98,0,0,0,1.348,1.552c.274.439,1.236.6.678.514l1.362,1.051-.072.086c1.141,1.209,2.808,2.161,3.372,4.151a4.688,4.688,0,0,1,1.378,1.592l-.209.379c.541.521.96,2.026,1.466,2.059-.412,1.241,1.8,3.081,2.331,4.281l.456-.232a15,15,0,0,0,1.773,2.259l.349-.291c.82.63.983,2.284,1.764,3.574-.2-.005-.351-.36-.395-.646,0,2.052,2.484,2.987,2.575,4.794a1.2,1.2,0,0,1,.434.888.254.254,0,0,0-.067-.081,1.451,1.451,0,0,0,.068.153c.011.2.011.4.033.613a1.954,1.954,0,0,0,.009-.532,6.551,6.551,0,0,0,.713,1.051l-.353.388c.021.032.037.058.058.091.03.49.362.235.588-.14a2.527,2.527,0,0,0,.525.437c-.556.665.765,1.006.2,1.815.5.123,1.213,2.027,2.085,1.941-.1.058-.093.205-.195-.026a2.359,2.359,0,0,0,.609,1.39l-.5.43,1.178.774c-.105.783-.221,1.122-.9.641,1.232,1.313.713,1.164,1.836,2.277l-.4.058c.163.472.92,1.087.692,1.473-.207.651.154,1.985.5,3.544a15.116,15.116,0,0,1,.453,4.776c1.113-.665-.395,1.339.511,1.366-.26.184-.388.574-.664.146.355,1.394-.367,2.063.358,3.03-.29.139-.383-.307-.558-.179.051.107.207.435.032.562s-.218-.211-.321-.423c-.042,1.325.741,1.56,1.527,1.787-.465.671-.514.979-.112,1.627-.318.184-.676.491-.565-.36-.06.239-.358.906-.6,1.506s-.465,1.132-.2,1.313c-.105.025-.193.158-.255.305a1.143,1.143,0,0,0-.132.356,4.844,4.844,0,0,1-.711.785c-.181.205-.388.369-.748.706l.276-.095c.181.872-.574.686-1.253,1.125l-.014-.081c-.486.086-.764.133-.958.17a1.01,1.01,0,0,0-.362.167c-.167.119-.383.214-1.353.04l.163.469c-.025.514-.513.432-1.087.211a8.88,8.88,0,0,0-.9-.344,1.587,1.587,0,0,0-.916-.1l.391.314c-.339.153-.76-.244-1.122-.739-.367-.472-.679-1.025-.958-1.167-.109-.119.237-.091.428-.114-1.388-.976-.341.592-1.56.4-.119-.391.513-.748-.237-1.044-.149-.177-.786-.112-1.518-.142a2.493,2.493,0,0,1-1.931-.725c.119.348.248.7-.374.621-.888-.305-1.748-1.975-2.863-1.668a.289.289,0,0,1-.042-.262c-.72-.149-2.143-.872-2.751-.728.172-.878-.85-1.309-1.815-1.718s-1.869-.785-1.4-1.4c-.6-.425-1.2-.827-1.787-1.273l.142-.086a3.114,3.114,0,0,0-2.261-1.027c-.183-.29.093-.246.165-.29a5.414,5.414,0,0,0-3.351-2.254l.205-.488c-.551-.111-1.645-2.591-3.458-3.628a.368.368,0,0,1,.316,0c-2.048-1.208-2.715-4.882-4.618-4.292l-1.329-.846c1.181,1.573-.785.3-.483,1.1-.592-.518-.9-1.868-.205-1.211l.028.17c.936-.344-1.318-2.078-.786-2.452a46.3,46.3,0,0,1-3.353-4.588q-.756-1.18-1.5-2.336c-.455-.781-.909-1.545-1.388-2.284l-.386.748-.651-1.058c-.037-.363.244-.671.7.076.1-.609-1.109-1.039-1.262-.979-.7-1.594,1.1.111.823-.341l-.441-.565.016.179c-.565-.333-.844-.23-1.334-1.176-.2-.662.228-.525.125-.771.046-.023.025-.112-.177-.362l-.7-1.387-.211.816c-.59-.47-.688-1.3-.92-.363.156-.686-.363-2.054-.948-3.335a12.02,12.02,0,0,1-1.187-2.856,6.733,6.733,0,0,1-1.459-2.791c-.007.318-.555.713-.853-.286.711-.053.649-.532.563-1.16a2.924,2.924,0,0,1,.06-1.92c-.388.9-1.03-2.729-1.553-1.36-.156-.853.467-.193.576-.9-1-1.845-.848-4.42-1.476-6.849-.181,0-.36.467-.727-.014l.6-1.473c-.19-.469-1.09-.269-.634-1.276-.126.153-.318.383-.427.06a58.462,58.462,0,0,0-.829-7.52,17.973,17.973,0,0,1,.311-7.614c-.326.683-.37.233-.395-.286-.074.339-.437,0-.676.068.2-.709.442-1.41.662-2.1-.676-.395,0-2.242-.618-2.482l.09.667c-.725-.925-1.7,1.2-2.663,1.057.837,1.023-1.285,2.719-.011,4.387-.188.377-.318-.307-.535-.1.418.418.518.927.39,1.889l-.109-.1a25.978,25.978,0,0,1,.06,3.307c-.025,1.006-.151,2.068-.084,3.586l.446-.276a2.729,2.729,0,0,1-.2,1.122c.806.653-.179-1.817.693-1.23-.43.477-.3,1.617-.183,2.719.13,1.1.283,2.164-.221,2.542.154.992.5-.377.651.611l-.251.311.418.184c.04.658-.27,1.051-.509,1.12a3.478,3.478,0,0,0-.2-.6c-.211.909.6,2.345.532,2.656l-.014-.983c.781,2.629,1.218,5.986,2.543,8.359l.156-.255c1,1.8.249,1.611,1.1,3.663l-.075-.06a4.043,4.043,0,0,1,.848,1.438c-.448-.434-.1,1.16-.639.574,1.2,1.894.718.9,2.01,1.931l-.226.449a2.585,2.585,0,0,1,1.2,1.262c-.672-.693-.226.865-1.041.112.237,2.459,2.191,2.782,1.567,4.274,1.371.5-.332-2.078.118-1.634.1-.6,1.057.46,1.274,1.151.332.648-.569,1.7.363,3.346-.086-.167-.16-.14-.247-.305.114.748.976,1.027,1.027,2,.764.1.579.962,1.324.662a14.223,14.223,0,0,1-1.053-1.362c.621.771,1.976.981,2.449,2.557a2.738,2.738,0,0,1-.92-.5c.061.518.627.663.7,1.2-.741.328-1.3-1.641-2.392-2.2-.005.6,1.587,1.352.567,1.374,1.339.035.918,1.636,2.315,2.226l-.437.205a2.8,2.8,0,0,1,.788.655c-.3-.056-.585-.13-.879-.2,1,.562.79,1.869,1.6,2.5-1.232-1.641.188-.714-.047-1.617,2.006,1.638-.135,1.911,1.776,4.025-.288-.263-.655-1.316-.112-.978a4.821,4.821,0,0,1,.558,1.573c1.255,1.4.2-.53.932-.091-.053.86.757.572,1.418,1.083l-.37.312c1.13,1.836,1.136-.212,2.08,1.492L143.8,184.3l.779.649-.555.2a3.844,3.844,0,0,1,1.757,1.789c.09-.411.751-.481,1.394.205.219.669-.583.042.367.987-.425-.018-.932-.009-.993-.741-.156.061-.427-.018-.585.04.225.737,1.12,1.353,1.457,1.7a1.345,1.345,0,0,1-.274-.463l1.822.958c.077.348-.195.272-.463.2a11.227,11.227,0,0,1,1.088.681c-.388.168-.658.481-1.359.007.528.355,1.072.693,1.613,1.034-.035.207.337,1.013.065.943.574.9,2.34,1.245,3.137,2.392a.938.938,0,0,1,.511.193c.879.941,1.425,2.068,2.945,2.654l.211,1.1c1.025.649-.332-1.438,1.371-.367,1.243.707.032.8.3,1.266a3.855,3.855,0,0,1,2.882,1.573c-.432-.144-.634-.439-.988-.639m13.2,7.2c-.312-.009-1,.079-1.092-.27.52-.39.667-.06,1.092.27m17.651-10.569c.149.232.032.565-.212.916a2.381,2.381,0,0,1,.212-.916m-28.118-52.278.039,0c.307.542.2.346-.039,0m-.772-1c-.139-.037-.179.019-.186.1.147-.03.36.156.572.4.023-.153-.037-.327-.386-.5m-25.182,23.739.007.276c-.388-.414-.2-.341-.007-.276",
    transform: "translate(90.378 92.45)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M162.124,166.638a.433.433,0,0,1-.284.065c.051.137.142.165.284-.065",
    transform: "translate(119.605 125.862)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M140.249,163.732l-.03-.035a.243.243,0,0,0-.093.033Z",
    transform: "translate(103.205 123.64)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M154.314,142.088a1.138,1.138,0,0,1,.068.574c.105-.051.13-.211-.068-.574",
    transform: "translate(113.921 107.319)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M142.261,132.687l.7.4a1.3,1.3,0,0,1-.458-.577c-.056.1-.04.325-.239.174",
    transform: "translate(104.817 100.087)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M140.2,128.936c-.135-.016-.219-.132-.353-.146l-.1.205c.441.263.846.305.449-.06",
    transform: "translate(102.921 97.275)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M142.876,131.988c.195-.356-.27-.593-.79-.853a.575.575,0,0,1,.083.058c-.479.358.132.553.707.8",
    transform: "translate(104.617 99.046)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M142.192,131.226a2.446,2.446,0,0,1-.435-.3c-.191.144.146.162.435.3",
    transform: "translate(104.394 98.89)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M144.888,134.251c-.123-.258-.47.274-.47.049-.567.183,1.718.736.47-.049",
    transform: "translate(106.377 101.345)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M142.821,130.848l-.146.53.5-.118Z",
    transform: "translate(105.13 98.829)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M145.045,132.954l-.627-.686c-.044.074-.165.037-.3-.025.43.37.848.837.929.711",
    transform: "translate(106.218 99.883)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M144.386,132.416a1.762,1.762,0,0,0-.628-.4,3.878,3.878,0,0,0,.628.4",
    transform: "translate(105.948 99.71)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M143.372,131.234l.147.255.484.441Z",
    transform: "translate(105.656 99.121)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M148.6,136.692a7.942,7.942,0,0,1,.762.667c.195-.03.107-.316-.181-.563-.256-.1-.56-.327-.581-.1",
    transform: "translate(109.609 103.172)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M147.994,134.843a.969.969,0,0,1,.03.593l.476-.405Z",
    transform: "translate(109.147 101.847)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M149.295,136.2c.207-.049,1.378.785.474-.163-.2.035-1.011-.621-.474.163",
    transform: "translate(109.993 102.579)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M154.395,143.461l-.144-.214-.848.576Z",
    transform: "translate(113.233 108.195)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M159.375,149.962c-.316-1.211-.7.012-.908-1.115-.342-.151.174.92-.144.746.556.548.586.965,1.051.369",
    transform: "translate(116.95 112.413)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M158.455,149.382a3,3,0,0,0-.305-.269,1.348,1.348,0,0,0,.305.269",
    transform: "translate(116.818 112.625)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M125.641,123.345l.235-.734-.358.467Z",
    transform: "translate(92.171 92.608)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M125.188,122.455l.66-.135-.562-.458c.016.154.054.469-.1.593",
    transform: "translate(91.922 92.042)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M153.124,172.454l.107-.135c-.093-.193-.286-.262-.665-.409.184.181.36.374.558.544",
    transform: "translate(112.601 129.844)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M147.109,169.531l.154.112.011-.69Z",
    transform: "translate(108.479 127.611)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M142.6,166.676c.277.253.7.425.979.679-.7-.427-.6-1.315-.979-.679",
    transform: "translate(105.076 125.723)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M137.573,144.2c.458.556-.068-.428.342.333a.446.446,0,0,1-.342-.333",
    transform: "translate(101.276 108.913)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M151.392,166.38c1.831,1.527,3.179,4.322,5,6.124.2.221-.3.128.167.618a40.189,40.189,0,0,1,5.566,7.483l-.181-.088c.3.49.965.853,1.309,1.352-.044.04-.186-.1-.163.06.233.011.746.8,1.009.922.095.23-.03.3.1.59l.374.144c.978.446,1.441,1.838,2.468,2.694-.077-.019-.188-.1-.158.014,1.562,1.441,3.21,3.495,4.838,5.2-.116-.023-.272,0-.242.153.237-.051.755.462,1.2.906.023.358.865.676,1.271,1.3l-.079-.014c.537.251.448.688.95.828l.109.372c.39-.035.42.686.846.907l.037-.054c.346.256.388.523.7.769v.053c.7.6.965,1.1,1.118.913.093.365-.7-.567-.535-.01.781.66,1.618,1.388,2.336,1.954a13.138,13.138,0,0,0,1.129.818,4,4,0,0,0,.611.326.744.744,0,0,0,.669.03.71.71,0,0,0,.176-.611,3.38,3.38,0,0,0-.111-.648,10.264,10.264,0,0,0-.418-1.245c0-.267-.056-.476.007-.555a7.052,7.052,0,0,0-.748-1.243c.047.091.026-.232-.035-.383-.163-.542-.506-.428-.686-1.02.169.186.276.225.318.112a9.278,9.278,0,0,1-1.048-1.525c.081.065.172.184.228.128-.507-.493-.548-1.1-.955-1.555l.23.126c-.318-.915-.39-.1-.709-.869.135.149.149.061.216.065a17.258,17.258,0,0,1-1.613-2.275.045.045,0,0,0,.065,0,26.182,26.182,0,0,0-1.4-2.217c-.121-.316.348-.084-.158-.811-.219.174-.886-1.216-.881-.606a14.016,14.016,0,0,0-1.252-2.106c.27.23.093-.495.448.023l-.111-.492c.135,0,.228.434.27.23a14.493,14.493,0,0,1-.878-1.237,6.961,6.961,0,0,1-1.557-1.448c.332.312.121-.379.325-.153l-1.166-.811c-.183-.256.147-.179-.161-.518-.049.06-.195-.079-.321-.163-.037-.116-.774-1.05-.62-1.315.014-.176.33.395.219.051-.321-.483-.414-.453-.737-.932l.025-.03c-.179-.342-.723-.874-.62-.444.14.228.083-.176.233.2a3.96,3.96,0,0,1-1.018-1.15c.147.14.195.079.3.1a15.452,15.452,0,0,1-1.694-1.84c-.116.063.379.135.393.279-.474-1.025-1.5-1.757-1.811-2.67.105.111-.107.172-.082.142-.29-.451-.119-.539-.376-.786.072-.091-.279-.342-.511-.618-.172-.107-.009-.109.179.142a16.642,16.642,0,0,1-2.18-2.949c-.047.06-.63-.428-.778-.649l.2-.014c-.056-.258-.527-.721-.432-.842-.5-.346,1.408,1.689.832,1.151,0-.246-.841-.718-.555-.718-.312-.434-.771-.744-.934-1.255.063.137.446.216.186-.13-.467-.6-.193-.128-.6-.6l-.283-.276c-.151.077-.377-.565-.365-.226.058-.156-.713-.851-.441-.948l.24-.042c-.205-.258-.5-.3-.732-.456-.009-.047-.023-.144.016-.151-.3.153-.437-.653-.874-.818-.311-.628-1.018-1.425-1.046-1.808a4.923,4.923,0,0,1-1.083-1.209c.1.077.2.205.283.19-.146-.363-.274-.386-.523-.632a7.211,7.211,0,0,0-.449-1.137c-.393-.363-.43-.109-.551-.084-.016-.59-1.064-1.057-1.192-1.715.147.116.6.511.4.112-.032-.583-.786-.62-1.132-1.332l-.1.319c-.075-.379-.822-.807-.551-.916-.237-.146-.486-.781-.644-.548-.609-1.143-2.033-2.338-2.145-3.253-.147-.114-.395-.5-.444-.34.072.33.346.265.337.416-.109-.123-.188-.1-.226-.095-.2-.348-.379-.6.028-.451-.42-.8-.929-.418-1.555-1.352.118-.032.1-.125-.125-.367l-.542-.36c-.427-.588-.067-.479.067-.613-.27-.277-.565-.651-.785-.7l-.118-.514c.088.372-.291-.174-.446-.281l.153.109c.014-.105-.312-.416-.477-.574-.054.116.205.495.341.707-.191-.1-.376-.346-.62-.483.2-.053-.307-.567-.491-.814-.2-.295-.383-.2-.444-.281.067-.068-.362-.449-.081-.326.1.072.107.27.3.369-.1-.225.047-.311-.356-.6-.305-.218-.218.307-.576-.295.153.109.23.086.372.151l-.346-.556-.146.088c-.023-.093.026-.056.018-.1-.256-.035-.688-.711-.934-.693a8.985,8.985,0,0,1-.553-.841l.051.035a2.288,2.288,0,0,0-.853-.858l.04-.011a2.968,2.968,0,0,0-.714-.649c-.255-.477.358-.553-.188-.846-.36-.395-.786-.42-.723-.188a20.482,20.482,0,0,1-1.883-2.252c-.144-.054-.116.037-.337-.146a21.935,21.935,0,0,1-2.675-3.095c.33.251.14-.095.205-.167-.341-.142-.163-.4-.434-.314-.088.128-.165.154.061.486a10.085,10.085,0,0,1-1.725-1.919c.109.218-.049.119-.207.018.216-.121-.184-.6-.569-.874l-.153.054-.1-.325c-.158-.1-.36.07-.581-.362a.264.264,0,0,0,.018-.205,3.942,3.942,0,0,1-1.324-1.073l-.147-.456c-.176-.142-.532-.319-.3,0a6.056,6.056,0,0,1-1-1.48,16.741,16.741,0,0,1-2.949-2.259l1.985-1.441c.277.576.553,1.143.806,1.666l-.121,0c.119.477.281.139.363.472-.165-.093-.04.43-.327.149.205.669.57.707.816,1.085.16-.005-.244-.279-.042-.284.079.046.33.9.576.9,0,.191-.2.146-.325.1l.286.326c.009.576-.943-.836-.978-.212l.209.332c-.035.435-.7-.8-.325.107.29.328.739.506.651.125.458.757.648.125,1.071.972.005.288-.377-.658-.453-.414.047.479.5.748.632,1.129-.132-.428.237-.2.405.032.132.474-.33-.181-.032.434.163.04.539.551.365.03.367.084.26.665.634.886-.074.291-.746-.4-.479.309.116-.2.67.69.737.2.089.286-.03.386-.237.253.095.427.8.728.521,1.034l.242.032c.005.146.053.335.061.574.176.326.811.913.532,1.029.084.09.481.836.506.449-.142-.521-.425-.455-.319-.846-.023.434.391.648.6.876l-.077.1c.126.135.305.511.469.549-.125-.089-.158.012-.114.153l.247.077c.437.6-.186.3.211.9l-.388-.405c.084.09.061.383.277.653.205.037.5.158.662.195.26.316-.068.248.27.509l-.425-.355c-.084-.042-.06.435.209.9.218.27.683.62.493.1.135.233.235.611.028.483.353.5.109-.154.462.251.014.239.219.9.288,1.325l-.511-.342.183.32c-.427-.3-.021.29-.353.174a2.252,2.252,0,0,0,.488.635c-.054-.816.843.458,1.023.105.581.818-.386.955.6,1.585-.014-.191.456.1.051-.39.288.553.5.191.762.892-.4-.4.011.674-.563.1.123-.012-.153-.42-.242-.507.023.286-.316.126.012.674.228.318.507.772.616.616.156-.112-.323-.5-.028-.384.455.63.272.892.727.992-.274-.405-.169-.613-.053-.672l.362.448-.165-.03c.391.828.332.112.762.886l0,.483c-.3-.065-.588-1.148-.8-.832.281.5.535.569.743,1.078-.09-.086-.183-.223-.272-.307.1.181-.191.6.472,1.155.312.3.167.028.283-.032.52.765.778.929,1.108,1.424-.283.032.53.906-.037.486a3.346,3.346,0,0,0-1.125-1.613c-.081.446-.344-.639-.711-.648.383.634.111.762.005.965a1.6,1.6,0,0,0,.363.4c.2-.023.06-.249.212-.363a5.359,5.359,0,0,0,1.29,1.646c.072.281-.133.307-.321.039a27.222,27.222,0,0,1,1.574,2.519c-.072-.671.62.841.609.358-.212-.458-.263-.936,0-.778.153.274-.116.063-.1.209.353.246.112.663.539.853-.563-.7-.4.051-.688.04.46.474-.156.067.188.607a19.113,19.113,0,0,1,1.427,1.648,13.15,13.15,0,0,0,1.711,2.573c.139.414-.244.327-.023.732.307.439.014-.492.362.233l-.088-.033c.188.163.676,1.306,1.123,1.283l-.377-.039a.982.982,0,0,0,.29.3c-.074.058-.046.249-.233.084.114.518.609.834.916,1.269l-.053-.381c.623.679.851,1.266,1.408,1.954l-.151.075.386.37c-.207-.011-.012.444.26.592l-1.127-.878c-.14-.367.405.221.4-.068a1.5,1.5,0,0,0-.72-.9,1.262,1.262,0,0,0,.395.421c-.13.218-.4-.176-.662-.277.1.128.181.36.26.346a3.545,3.545,0,0,1-.8-.89c.281.249.007-.246.14-.17-.193.082-.535-.305-.864-.888-.074-.525-.83-.944-1.213-1.617a3.138,3.138,0,0,1,1.044.716c-.186-.458-.309-.441-.495-.9a1.88,1.88,0,0,1-.985-.578l.107-.114c-.388-.428-.576-.3-.941-.934-.625-1.083-1.332-2.154-1.84-2.959l.107-.112c-.569-.262-1.053-1.42-1.56-1.941-.528-1.1-1.545-2.143-1.643-2.816a59.174,59.174,0,0,1-3.391-5.231l.383.207c-.344-.258-.023-.288-.251-.6.077.474-.476-.346-.734-.514a9.988,9.988,0,0,0-1.725-2.621l.116-.105a8.9,8.9,0,0,1-1.5-2.652,1.15,1.15,0,0,0-.158-.662,7.113,7.113,0,0,1-1.2-1.378,17.832,17.832,0,0,1-.983-2.122c-1.455-1.957-2.407-4.243-3.726-6.389l.079-.242A18.112,18.112,0,0,1,124.111,123l-2.475-5.211,4.186,3.969c1.151,1.092,2.191,2.229,3.144,3.019l-.36.075c.391.528,1.1,1,1.141.725.4.528,1.246,1.062,1.357,1.534.423.518.672.484,1.085.858a19.819,19.819,0,0,0,2.106,2.264l-.2-.24c-.144-.056-.248.026-.047.269.383.284,1.12,1.316,1.067.725.769,1.122,2.254,2.191,2.928,3.347,0-.149.235.081.381.139a22.864,22.864,0,0,0,2.217,2.529c.088.174-.327-.111-.016.254.218.188.1-.082.377.144,1.394,1.322,2.4,3.038,3.554,4.341,2.15,2.229,4.128,4.78,5.991,7.083l-.079.019c.836.6,1.23,1.992,2.041,2.363.086.228.52.73.3.679.641.506,1.2,1.866,2.1,2.619a.781.781,0,0,0-.205-.2c.569,1.015,1.343,1.706,1.952,2.77-.1-.081-.251-.248-.332-.232.167.46.913.711.781,1.127.162.214.258.049.151-.077,1.471,2.224,3.3,4.4,4.964,6.612.969,1.743-.418.442.7,1.569.018.144.165,0,.118.058.428.439.216,1,.609,1.238.079-.267.26.16.376.095a6.848,6.848,0,0,0,1.232,2.08l-.135.005c.9.739,1.494,1.908,2.335,2.482,3.532,5.083,6.96,9.937,10.13,15.108,1.246,2.136,2.489,4.253,3.656,6.447.293.549.579,1.1.857,1.669l.411.855.205.448c.126.281.246.556.356.834a9.165,9.165,0,0,1,.825,3.095,2.529,2.529,0,0,1-.2,1.064,2.192,2.192,0,0,1-.657.827,2.089,2.089,0,0,1-1.711.269,5.948,5.948,0,0,1-2.184-1.22c-.5-.476-.851-.865-1.144-1.171-.2-.219-.362-.4-.528-.583-.286-.295-.62-.563-1.225-1.081.081.011.158.074.116-.033-.235.119-.8-.776-1.076-.72-1.548-1.666-2.988-3.163-4.515-4.9.262.258.534.263.235-.053l-.418-.24,0-.1c-.223-.2-.528-.367-.386-.083-3.972-4.264-7.156-9.026-10.686-13.46-.746-1.127-1.989-2.587-2.916-3.719a114.783,114.783,0,0,0-7.249-10.365s.853.091,2.043,1.467",
    transform: "translate(89.239 88.968)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M137.3,144.011c.011-.2-.226-.648.142-.416-.067.107-.021.395-.142.416",
    transform: "translate(101.024 108.408)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M133.6,137.183c-.04.005-.061-.188-.067-.235.1.135.269.209.284.355-.1-.137-.133-.082-.218-.119",
    transform: "translate(98.223 103.437)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M132.555,135.416c.121-.016.588.555.832.913Z",
    transform: "translate(97.486 102.28)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M131.824,133.82c-.065-.283.018-.244.211.072-.037.053-.125-.035-.211-.072",
    transform: "translate(96.918 100.93)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M131.7,133.924a1,1,0,0,1-.168-.513c-.076.058.372.492.168.513",
    transform: "translate(96.708 100.765)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M129.895,130.49c-.091-.139-.351-.4-.323-.6.014.193.527.628.323.6",
    transform: "translate(95.232 98.106)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M128.82,128.834a.649.649,0,0,0-.135-.232c-.049-.19.119-.054.209.081Z",
    transform: "translate(94.556 97.063)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M139.113,138.682l-.255-.242.118-.026Z",
    transform: "translate(102.247 104.543)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M147.5,150.479c.253.249.049.258.068.316-.184-.254.177.019-.068-.316",
    transform: "translate(108.775 113.657)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M152.07,157.018l-.058-.088.211-.088Z",
    transform: "translate(112.182 118.463)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M148.741,122s-29.628,8.076-45.706,31.869-21.683,48.1-12.521,54.3,29.628-8.076,45.708-31.871S148.741,122,148.741,122m-21.481,48.172c-15.01,22.212-30.593,37.909-34.806,35.062S96.993,182.068,112,159.858A138.107,138.107,0,0,1,146.806,124.8a138.088,138.088,0,0,1-19.547,45.373",
    transform: "translate(62.408 92.144)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M148.741,122s-29.628,8.076-45.706,31.869-21.683,48.1-12.521,54.3,29.628-8.076,45.708-31.871S148.741,122,148.741,122m-21.481,48.172c-15.01,22.212-30.593,37.909-34.806,35.062S96.993,182.068,112,159.858A138.107,138.107,0,0,1,146.806,124.8a138.088,138.088,0,0,1-19.547,45.373",
    transform: "translate(62.408 92.144)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M110.807,150.114c-.195.233.214.377.251.458.2-.479-.349-.509-.251-.458",
    transform: "translate(81.02 113.367)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M111.861,147.721l.1.165.012-.848Z",
    transform: "translate(81.856 111.058)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M113.9,145.157c-.846.021-.753,1.5-1.394,2.085l-.211.033.307.616a11.536,11.536,0,0,1,1.3-2.735",
    transform: "translate(82.183 109.637)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M114.81,144.413c-.319,0,.046-.59-.355.47a1.078,1.078,0,0,1,.112-.06,3.84,3.84,0,0,1,.242-.411",
    transform: "translate(83.815 108.952)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M114.541,144.59c-.218.444.36-.172,0,0",
    transform: "translate(83.842 109.186)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M115.1,143.453l-.09.688c.211-.042.52-.535.523-.29.2-.651-.014-.606-.434-.4",
    transform: "translate(84.232 108.247)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M114.987,142.947l-.065.344c.09-.019.154-.086.065-.344",
    transform: "translate(84.168 107.968)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M114.873,143.872l.142-.728c-.147.028-.358-.072-.084.323-.161-.149-.047.068-.058.405",
    transform: "translate(84.075 108.117)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M114.991,143.765c-.311.246-.618.611-.53-.077-.5,1.132.028,1.215.53.077",
    transform: "translate(83.667 108.528)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M113.087,144.831l-.421.311,0,.477c0-.237.639-.7.423-.788",
    transform: "translate(82.463 109.391)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M116.593,141.451c-.119-.1-.463.016-.66-.026l-.056.506c.2-.174.5-.549.716-.479",
    transform: "translate(84.889 106.805)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M115.969,141.742l.084-.755c-.312.558-.253.716-.084.755",
    transform: "translate(84.854 106.488)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M114.613,142.768l-.065,1.287c.054-.5.125-.988.16-1.492Z",
    transform: "translate(83.886 107.678)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M116.979,140.183l.149.52-.179-.885Z",
    transform: "translate(85.7 105.604)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M117.368,139.59c.14.395.625-.172.655.191a2.993,2.993,0,0,0,.047-1.4,1.827,1.827,0,0,1-.7,1.209",
    transform: "translate(86.016 104.519)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M117.74,137.972a3.96,3.96,0,0,0,.053.718,2,2,0,0,0-.053-.718",
    transform: "translate(86.294 104.21)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M116.3,140.521a.79.79,0,0,0,.63-.325l-.507.072c-.037.077-.079.165-.123.253",
    transform: "translate(85.206 105.89)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M116.357,140.473l.018,0c.137-.272.233-.46.276-.541l-.293.544",
    transform: "translate(85.252 105.688)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M116.287,140.444l.032-.063c-.049.005-.07.014-.032.063",
    transform: "translate(85.184 106.03)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M115.5,142.251c-.028-.483.126-1.373-.576-.785.132.4.532.06.576.785",
    transform: "translate(84.173 106.703)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M116.1,140.466l-.421.635c.107.037.318-.014.332.223Z",
    transform: "translate(84.74 106.094)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M115.951,140.241l-.032.395.149-.239Z",
    transform: "translate(84.921 105.924)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M117.416,139.032a2.64,2.64,0,0,1,.221-1.1,8.523,8.523,0,0,0-.642,1.146c.1.109.24.377.421-.051",
    transform: "translate(85.734 104.184)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M116.807,139.4l.009-.077c-.053.026-.077.054-.009.077",
    transform: "translate(85.56 105.231)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M118.282,135.846l-.1.03.063.042Z",
    transform: "translate(86.633 102.605)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M117.014,138.641a.76.76,0,0,0-.154.7,4.879,4.879,0,0,1,.258-.737c-.044-.049-.079-.07-.1.033",
    transform: "translate(85.612 104.66)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M118.071,137.342a4.005,4.005,0,0,0-.439.428c.19-.1.518-.328.439-.428",
    transform: "translate(86.215 103.734)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M116.882,139.3a.266.266,0,0,1,0,.053c.13-.06.083-.067,0-.053",
    transform: "translate(85.646 105.208)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M116.947,139.512a1.866,1.866,0,0,0-.058-.5,2.674,2.674,0,0,0-.1.553.532.532,0,0,1,.154-.051",
    transform: "translate(85.581 104.994)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M117.152,134.928c.351.2.383,1.122-.281,1.638.009.776,1.4.844,2.308.527-.153-.086-.3-.147-.246-.929-.3.163-1.078,1.346-1.181.627.169-.99.425-.7.8-1.062-.611.193-.214-1.427-.974-1.492l-.074.89c-.111-.026-.167-.381-.349-.2",
    transform: "translate(85.64 101.388)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M117.887,137.149l-.075.3a2.917,2.917,0,0,1,.918-.776c.011-.551-.09-.706-.2-.788-.2.467-.414.923-.63,1.381Z",
    transform: "translate(86.351 102.635)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M117.9,138.051c-.3-.393-.186-1.141-.793-.909-.323.837.086.721.047,1.29.472-1.38.058.481.7-.39a4.427,4.427,0,0,1-.2.771,6.114,6.114,0,0,1,.477-.618l-.039.021,0,.007-.005,0c-.074.035-.112.042-.056-.01,0-.007,0-.025,0-.032a.525.525,0,0,1-.125-.125c.248-.355.13-.018.125.125a.423.423,0,0,0,.053.042l.007,0,.353-1.439a5.678,5.678,0,0,0-.539,1.274",
    transform: "translate(85.724 103.308)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M114.65,140.8a.123.123,0,0,1,.111,0c-.005-.107-.023-.154-.111,0",
    transform: "translate(83.963 106.272)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M115.1,140.6a.594.594,0,0,1-.068.56c-.249.207-.186-.093-.321-.14.012.233-.042.781.435.3l-.007-.118c.393-.455,1.215-.893,1.223-.776a3.02,3.02,0,0,0-1.262.177",
    transform: "translate(84.009 106.049)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M116.309,139.493l.311-1.185-.6.4.219.065c-.367.586-.053.567.068.716",
    transform: "translate(84.998 104.464)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M118.383,136.065l.365.321-.341-.9Z",
    transform: "translate(86.782 102.336)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M118.685,135.086l.349.2-.07-.477Z",
    transform: "translate(87.01 101.821)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M96.589,153.04l-.074.358a1.365,1.365,0,0,0,.074-.358",
    transform: "translate(70.265 115.591)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M97.348,151.871l-.139-.153c.035.156.079.237.139.153",
    transform: "translate(70.789 114.593)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M112.121,129.048c-.637.075-1.45.063-1.1.344l.412.209a1.4,1.4,0,0,1,.688-.553",
    transform: "translate(81.158 97.47)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M102.627,141.417l.2-.04c-.046-.188-.086-.362-.125-.523-.023.172-.047.363-.074.563",
    transform: "translate(74.882 106.387)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M103.595,141.949l-.611.377a2.541,2.541,0,0,0,.611-.377",
    transform: "translate(75.151 107.214)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M93.208,160.081l.237.548c.258-.569-.06-.413-.237-.548",
    transform: "translate(67.767 120.909)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M122.053,124.757a14.655,14.655,0,0,0,.7-1.982c-.513,1.192-1.144,2.3-.7,1.982",
    transform: "translate(89.44 92.732)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M94.559,151.234c-.04.228-.009.353.079.4.046-.232.037-.384-.079-.4",
    transform: "translate(68.775 114.227)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M122.784,121.708c-.075.186-.142.348-.216.53a4.775,4.775,0,0,1-.183,1.343c.379-.867.688-1.787.4-1.873",
    transform: "translate(89.806 91.926)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M102.055,157.3c.039-.016.072-.044.111-.056-.039-.046-.072-.007-.111.056",
    transform: "translate(74.45 118.754)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M109.2,152.07a4.738,4.738,0,0,1-.321.518,1.474,1.474,0,0,0,.321-.518",
    transform: "translate(79.607 114.859)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M120.049,131.594c-.079.328.028.067,0,0",
    transform: "translate(88.018 99.393)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M118.873,132.231a.273.273,0,0,0-.154-.195.341.341,0,0,1,.154.195",
    transform: "translate(87.036 99.727)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M119.881,124.212l-.021.012c-.04.146-.032.118.021-.012",
    transform: "translate(87.879 93.817)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M119.837,131.987a2.162,2.162,0,0,0,.26-.365,2.287,2.287,0,0,0-.26.365",
    transform: "translate(87.88 99.414)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M120.018,131.831l-.133.265c.054.063.109.044.133-.265",
    transform: "translate(87.917 99.572)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M120.2,131.336a2.306,2.306,0,0,1-.218.5c.049-.053.081-.07.09-.049.026-.095.065-.228.128-.451",
    transform: "translate(87.992 99.198)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M91.99,168.335a.577.577,0,0,1,.06.014c.123-.283.049-.205-.06-.014",
    transform: "translate(66.848 127.014)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M109.914,134.335a.367.367,0,0,0,.011-.042l-.044.025Z",
    transform: "translate(80.361 101.432)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M109.852,135.652c-.051-.735.193-.9.534-1.092l-1.173-.59Z",
    transform: "translate(79.856 101.188)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M100.093,183.181l.728-.542c.109,1.176-.42,1.7.425,1.28-1.162-.744,1.373-2.859.235-3.614l.514-.334c-.086.128-.028.19-.114.316,1.085-.6-.484-1.162.353-2.256.326-.362.664-.549.644-.19l.232-1.085c.176-.255.342-.07.169.183l.716-1.448.03.03a6.377,6.377,0,0,1-.082-1.216c.376-.255.021.251.219.247l.176-.939c.491-.13.4.679.046,1.185,1.6-.021.086-.813,1.692-1.947l-.284.813c.941-.067,1.039-.772,1.95-1.327-.332.056-2.034.988-1.819-.014a1.32,1.32,0,0,0,.5-1.05c.416.251.579-.249.893-.806l.523.377c.209-.681-.1-.809-.126-1.308a1.22,1.22,0,0,1,1.42-.416c.75-.981-1.134.288-.449-1a5.249,5.249,0,0,0,1.28-2.717c.579-.481.26.319.555.205l-.079-.814c.095-.125.2.005.251.07.13-.558-.514-.393-.19-1.192-.456-.578,1.811-.885,1.752-2.17.3-.105.255.323.506.4a8.72,8.72,0,0,0,.483-2.58l.918-.569c-.809.319-.744-.79-.625-1.736a5.079,5.079,0,0,0-.807.2c.156-.435.346-.848.521-1.273.183-.065.277.176.36.507.012-.1.023-.2.025-.284.479-.235.625.184.707.669l-.607.14c.111.49.283.994.627,1.162a.9.9,0,0,1,.118-.448c.033.13.075.23.153.237s.049-.188.049-.456l.755.193-.183-.228,1.4-1.085c.167-1.41-.016-2.926,1.027-4.623.095.711.6.627,1.06,1.044-.843,0-.762,1.327-1.476,2.041.374-.374.535-.1.537.074.209-.6.446-1.174.671-1.766.369.353.539-.053,1-.279-1-.369.339-1.46.572-2.227.286.186.435.546-.195,1.18,1.2-.269-.088-1.752,1.05-2.055-.139.17-.256.225-.184.4.112-.579,1.122-1.359,1.146-.943l-.139.167a15.646,15.646,0,0,0,1.8-2.11c.563-.772.936-1.517.7-1.889a6,6,0,0,1,.686,1.027c-.107-1.28-.207-2.579-.286-3.881.369.678,2.226,1.269,1.692,2.424a2.2,2.2,0,0,0,1.027-1.088c-.24.091-1.173-.33-.992-.606a6.7,6.7,0,0,0,2.01-.4c-.362.139-.9-.957-.47-1.327.058.184.829.778.769,1.008.065-.593.121-1.2.2-1.787-.112.386.621.73,1.067.748-.258-.06.885-.806,1.076-1.141l-.607.212c1.259-.943.025-2.242,1.237-3.246.014.3.621,1.373,1.3.95-.118-.662-.674-3.16.105-4.416l.421.074.572-.986a27.588,27.588,0,0,1-.416,4.906c.609-.195.381.183,1.011-.425.434.026-.042.671-.221.855.548-.4,1.094-.806,1.654-1.19-.513-.451.735-1.525.312-1.9l-1.222,1.973c-.516-.446-.286-2.284.9-3.146.455-.035.567,1.1.735,1.252a.719.719,0,0,1,.118-.318c.06-.116.212-.307.239-.365.105-.167.251-.3.318-.249a3.148,3.148,0,0,0-.049.507c.212-.009.2-.288.281-.583s.242-.588.493-.377c.074-.032.193.153.26.309s.107.265.132-.014c-.07-.944-.448-3.726-.037-4.757a6.7,6.7,0,0,1,.939-.17c.42-.04.771.014.844.19.105.283-.272,1.06-.548,1.72a5.012,5.012,0,0,0-.493,1.613,4.451,4.451,0,0,1,.43-.962c.105.125-.342,1,.046.6.481-1.259.741-.486.551-1.174.579-.692.344-.081.839-.479a12.663,12.663,0,0,1,1.255-2.17,14.754,14.754,0,0,1,1.806-2.229,4.7,4.7,0,0,0-.428.9,3.426,3.426,0,0,1,1.051-.488c-.309.9-.614,1.689-.792,2.414a8.387,8.387,0,0,1-1.166,1.72c.158-.091.486-.37.421-.042-1.065,1.615.037-.555-1.187,1.166.618-.693.66-.193.878-.023a1.583,1.583,0,0,0,.576-1.092.332.332,0,0,0-.353-.309c.66-.781,1.334-1.415,1.685-1.439.4-.081.628.246.662.946-.084,1.246-.858,1.167-.764,1.3-.453,1.339-.153,1.62.061,2.034.232.377.332.911-.4,2.243-.444.527-.72.509-.958.442s-.437-.2-.671-.107c.077-.922.867-1.613,1.05-2.363l-.548.979a1.493,1.493,0,0,1,.2-1.25,8.743,8.743,0,0,0-1.011,2.364c-.167.5-.344,1.036-.534,1.527a7.988,7.988,0,0,1-.676,1.36c.074.349.079.915.367.746l.105-.546c.576-.341.237,1.178.653.581a3.885,3.885,0,0,1-.356,2.656l-.646-.025c.176.042.579-.518.5-.857.107.5-1.334,1.22-.739,1.945l.651-.542c.03.806.344,1.917-.19,2.714.721-.179.016-.223.92-.592-1.029.23.857-2.238-.335-1.69,1.009-.356.735-.985,1.7-1.592-.2-.04-.469.172-.121-.541a.863.863,0,0,1-.114-.223l.032-.044-.037.033c-.018-.044-.023-.047-.012.012a.9.9,0,0,1-.421.277c-.316-.523.1-1.7,0-2.17.241-.409.158.258.446.086l-.142-.709c.405.258,1.245-1.473,1.009.184l.476-1.476a7.887,7.887,0,0,0,1.08-2.975c.341-.809-.1-1.576.161-1.141l.277-2.141.149-.119a18.58,18.58,0,0,0,.463-3.075,14.309,14.309,0,0,1,1.2-4.025,6.776,6.776,0,0,1,.39-2.475l-.014.007.351-.7a7.664,7.664,0,0,1-1.517.9,3.844,3.844,0,0,0-1.378,1.053c.116-.707-.929-.091-2.117.774-.6.453-1.216.92-1.785,1.352-.277.2-.541.395-.785.574a7.946,7.946,0,0,1-.669.46l-.223.8a24.707,24.707,0,0,0-3.237,2.858l.144.458a5.924,5.924,0,0,1-1.808,1.445c-.372.225-.792.472-1.2.735a5.242,5.242,0,0,0-.811.6c-.042-.191.248-.381.5-.458-1.894.279-2.1,2.775-3.672,3.207a.987.987,0,0,1-.662.588.18.18,0,0,0,.051-.077,1.119,1.119,0,0,0-.114.1c-.172.049-.356.095-.541.161a1.728,1.728,0,0,0,.481-.107,4.546,4.546,0,0,0-.709.893l-.458-.232c-.023.026-.039.047-.061.075-.421.153-.084.395.323.511a2.139,2.139,0,0,0-.2.593c-.778-.339-.614.943-1.52.653.067.476-1.3,1.683-.848,2.452-.09-.07-.212-.021-.06-.184a1.838,1.838,0,0,0-.918.981l-.576-.293-.128,1.3c-.7.176-1.027.219-.946-.56-.5,1.583-.63,1.065-.969,2.475l-.248-.318c-.3.337-.4,1.222-.827,1.194-1.234.235-3.421,3.6-5.575,5.173,1.225.358-1.174.6-.535,1.248-.311-.058-.663.123-.583-.353-.641,1.181-1.575,1.3-1.538,2.487-.314-.049-.149-.472-.362-.467-.018.121-.067.483-.283.492s-.065-.3-.032-.537c-.793,1.109-.195,1.731.386,2.291-.713.314-.893.611-.749,1.324-.349.039-.8.2-.391-.539-.3.36-1.978,2.131-1.478,2.54-.219.026-.42.509-.43.653a12.279,12.279,0,0,0-1.267,1.773l.247-.179c.418.771-.332.807-.716,1.55l-.053-.065c-1.513,1.283-.226.834-1.79,2.055l.46.177c.776.709-1.413,1.065-1.666,2.2l.442-.186c-.018.69-2.077.657-2.508,1.1-.147.063-.014-.253.026-.442-1.353,1.011.427.506-.063,1.578-.4.007-.592-.692-1.058-.051-.448.191-.246,2.529-1.357,3.117.348-.07.693-.137.585.43-.337.764-2,1.439-1.657,2.512a.283.283,0,0,1-.253.028c-.135.658-.718,1.975-.509,2.529-1.755-.293-1.188,3.855-2.524,3.119l-.839,1.78-.116-.118a2.423,2.423,0,0,0-.4,2.2c-.221.212-.256-.04-.318-.1a3.983,3.983,0,0,0-1.074,3.428l-.518-.063c.088.491-1.831,2.1-1.984,4.023a.349.349,0,0,1-.13-.27,8.7,8.7,0,0,1-1.439,3.021c-.544.951-.874,1.831-.118,2.468,0,.476.018.96.039,1.438.614-1.652.686.467,1.173-.142-.091.667-.979,1.557-.867.718l.123-.1c-.858-.558-.841,2.054-1.438,1.9a16.33,16.33,0,0,0-.3,3.388,5.526,5.526,0,0,0,.934,3.149,3.653,3.653,0,0,0,2.8,1.48,6.757,6.757,0,0,0,3.318-.672,5.86,5.86,0,0,1-.613-.521c.442-.2.922-.365,1.339-.609.393-.035.735.258-.3.776.346.074.746-.274,1.025-.606a1,1,0,0,0,.311-.739c1.548-.655-.079,1.076.351.816l.56-.432-.179.016c.312-.56.156-.853.988-1.4.586-.26.528.167.742.039.03.042.112.011.314-.216.405-.279.781-.577,1.171-.867l-.814-.081c.311-.623,1.055-.832.126-.916.7.083,1.762-.723,2.7-1.589a15.9,15.9,0,0,1,2.061-1.882,5.765,5.765,0,0,1,1.7-2.259c-.269.109-.848-.228-.163-.836.755,1.173,1.571-.82,2.784-.72-.915.065,1.625-2.054.249-1.883.59-.5.409.3,1.034.075.806-1.711,2.88-2.819,4.174-4.678-.114-.139-.56-.018-.462-.558l1.432-.367c.211-.4-.535-.953.448-1.206-.188,0-.469-.009-.33-.277,3.425-2.917,4.9-7.52,8.785-10.221-.63.295-.423-.053-.167-.437-.24.2-.353-.256-.583-.346l1.611-1.15c-.348-.655,1.1-1.676.681-2.2l-.237.553c-.179-1.069-1.994-.039-2.721-.681.2,1.2-2.34,1.16-2.173,3.021-.342.144-.1-.4-.376-.39.126.532-.054.941-.679,1.488l-.028-.133c-1.253,1.9-2.154,2.447-3.906,4.311l.493.137a2.031,2.031,0,0,1-.82.532c.195.939.962-1.2,1.25-.265-1.2,0-2.364,3.063-3.542,2.761-.525.656.586.149.06.8l-.372-.009.169.405a.888.888,0,0,1-1.069.232c.107-.084.183-.339.256-.463-.721.333-1.167,1.639-1.415,1.755l.651-.509c-1.229,1.957-3.328,3.834-4.341,5.884l.279.023c-.814,1.541-1.083.846-2.192,2.342l.005-.086a2.427,2.427,0,0,1-.714,1.211c.13-.52-.972.286-.764-.36-.944,1.617-.37.888-.623,2.338l-.462-.068a1.756,1.756,0,0,1-.549,1.4c.325-.753-.82,0-.5-.89-1.94.73-1.527,2.566-2.98,2.245.018,1.362,1.622-.662,1.4-.177.537-.03-.026,1.071-.562,1.388-.488.39-1.648-.309-2.81.616.121-.088.081-.156.2-.242-.6.137-.662.946-1.46.99.037.72-.737.439-.4,1.171.342-.305.7-.586,1.029-.913-.5.6-.692,1.864-1.811,1.92a3.726,3.726,0,0,1,.362-.746c-.307-.089-.414.393-.706.267a.726.726,0,0,1,.428-.737,2.6,2.6,0,0,0,.386-.288,1.524,1.524,0,0,0,.435-.6.465.465,0,0,0-.363.16,1.415,1.415,0,0,0-.258.305c-.1.151-.181.212-.272-.233.109.576-.125.662-.316.678-.219.025-.365-.014-.7.549l.111-.569c-.07.112-.29.412-.446.421a5.346,5.346,0,0,0,.411-.783c-.207.349-.37.23-.421.035s-.026-.435-.221-.363c.195.147.163.288.033.52s-.358.486-.274.735c-.381.153-.565,0-.592-.179a1.207,1.207,0,0,1,.205-.667c.265-.5.623-.9.491-1.125.063.019-.242.539-.5.527a1.219,1.219,0,0,1,.523-.7c-.042-.188-.161-.174-.319-.086s-.344.258-.483.14c.309-.183.251-.221.105-.319s-.376-.239-.435-.467l.479.067c.611-1.459-.934-.6-.211-2l.5.788.018-.809.5.3a2.3,2.3,0,0,1,.409-1.947c-.383.09-.813-.372-.577-1.12.448-.409.341.428.635-.634.2.337.477.713-.1,1.02.132.095.214.325.348.42.488-.425.523-1.308.658-1.682a1.1,1.1,0,0,1-.253.363l-.075-1.729c.265-.17.323.07.39.305a6.055,6.055,0,0,1,.081-1.071c.321.262.709.386.635,1.074l.156-1.571c.2-.03.737-.541.8-.3.532-.681.112-2.208.865-3.112a.706.706,0,0,1-.012-.465c.527-.93,1.366-1.566,1.441-2.937l.951-.326c.3-.958-1.232.47-.728-1.127.334-1.146.735-.114,1.1-.39a2.579,2.579,0,0,1,.788-2.6c-.049.377-.272.576-.381.9m5.808-10.842c-.039.256-.014.827-.349.829-.334-.52,0-.565.349-.829m9.487-16.21c.019.237-.211.407-.546.542a1.306,1.306,0,0,1,.546-.542m29.735-20.444-.012-.037c.455-.843.284-.541.012.037m-.727,1.652c.018.177.086.184.174.125-.084-.144.021-.511.186-.934-.167.114-.318.305-.36.809M99.472,205.353l-.258.039c.321-.425.286-.237.258-.039",
    transform: "translate(63.975 90.789)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M103.368,141.888a.5.5,0,0,1-.27-.074c.011.125.086.183.27.074",
    transform: "translate(75.237 107.112)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M93.192,160.023l-.021.032a.252.252,0,0,0,.065.07Z",
    transform: "translate(67.74 120.865)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M117.387,127.617a.353.353,0,0,1-.075-.265c-.051.193-.046.316.075.265",
    transform: "translate(85.95 96.189)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M119.593,133.818l.132-.728a1.09,1.09,0,0,1-.374.562c.111.025.312-.051.242.167",
    transform: "translate(87.513 100.523)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M116.622,136.278c.014.119-.081.207-.065.325l.218.061c.161-.418.116-.772-.153-.386",
    transform: "translate(85.401 102.806)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M118.727,133.551c-.405-.09-.421.386-.535.883a.333.333,0,0,1,.032-.082c.483.342.5-.23.5-.8",
    transform: "translate(86.638 100.863)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M118.244,134.114a1.9,1.9,0,0,1-.161.439c.191.137.114-.16.161-.439",
    transform: "translate(86.556 101.296)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M120.072,131.129c-.177.195.446.309.244.386.407.42-.079-1.725-.244-.386",
    transform: "translate(88.033 98.705)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M117.7,133.667l.534.009-.284-.407Z",
    transform: "translate(86.267 100.658)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M118.832,131.443l-.391.714c.084.016.1.128.09.258.186-.458.446-.943.3-.972",
    transform: "translate(86.826 99.279)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M118.556,132a1.33,1.33,0,0,0-.144.635,2.9,2.9,0,0,0,.144-.635",
    transform: "translate(86.799 99.698)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M117.834,133.183l.179-.186.23-.518Z",
    transform: "translate(86.367 100.061)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M120.424,126.721l.049-.741a1.04,1.04,0,0,0-.4.732c.1.065.1.33.355.009",
    transform: "translate(88.056 95.153)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M118.971,128.637a3.615,3.615,0,0,1,.556-.521l-.767.37a1.5,1.5,0,0,1,.211.151",
    transform: "translate(87.067 96.766)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M119.336,127.441c-.216.105-.49-.172-.613.435.233-.174.267.274.613-.435",
    transform: "translate(87.039 96.256)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M117.235,127.008l.165-.14.205-1.445c-.137.537-.255,1.041-.37,1.585",
    transform: "translate(85.915 94.732)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M113.464,132.026c.906-.516-.256-.634.634-1.027.014-.339-.728.319-.688,0-.279.607-.609.727.054,1.025",
    transform: "translate(82.774 98.868)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M113.266,131.1a2.5,2.5,0,0,0,.13-.325,1.012,1.012,0,0,0-.13.325",
    transform: "translate(82.917 98.772)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M110.121,151.284l.556-.435-.53.165Z",
    transform: "translate(80.542 113.936)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M110.178,150.431l.628.235-.262-.663c-.061.142-.181.416-.367.428",
    transform: "translate(80.585 113.297)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M99.711,149.464l-.107-.125c-.2,0-.29.121-.472.37Z",
    transform: "translate(72.242 112.796)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M96.884,153.7l.086-.126-.653-.04Z",
    transform: "translate(70.116 115.965)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M95.13,157.947c.16-.258.2-.634.365-.892-.205.634-1.058.63-.365.892",
    transform: "translate(69.017 118.624)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M120.628,122.371c.007-.3-.4-.144-.481-.179.142.467.59.158.481.179",
    transform: "translate(88.115 92.285)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M121.2,125.425l-.172-.095.43.814Z",
    transform: "translate(88.777 94.662)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M121.177,129.811c.746-.47-.075-1.894.2-2.817l.168-.151-.57-.421c.067,1.122.437,2.6.2,3.389",
    transform: "translate(88.738 95.487)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M120.126,130.151c.288-.151.211.607.119-.632a.871.871,0,0,1-.077.111,4.078,4.078,0,0,1-.042.521",
    transform: "translate(88.099 97.826)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M120.2,129.66c.007-.541-.253.339,0,0",
    transform: "translate(88.069 97.796)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M120.375,131.322l-.186-.73c-.177.135-.27.762-.369.518.072.737.249.6.555.212",
    transform: "translate(87.868 98.636)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M120.457,131.582l-.074-.379c-.074.058-.105.154.074.379",
    transform: "translate(88.249 99.098)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M120.271,130.746l.154.8c.125-.093.356-.084-.049-.367.205.082.016-.091-.105-.435",
    transform: "translate(88.208 98.752)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M120.355,130.979c.19-.388.334-.9.52-.165-.005-1.38-.507-1.2-.52.165",
    transform: "translate(88.272 98.084)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M121.536,128.96l.237-.539-.23-.481c.123.24-.232,1.046-.007,1.02",
    transform: "translate(89.106 96.633)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M119.655,133.823c.146.063.434-.184.634-.214l-.107-.544c-.139.256-.3.753-.527.758",
    transform: "translate(87.743 100.504)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M120.017,133.377l.161.818c.119-.7.011-.841-.161-.818",
    transform: "translate(88.016 100.738)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M121.033,132.115l-.435-1.352.421,1.6Z",
    transform: "translate(88.455 98.766)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M119.515,135.4l-.274-.493.393.865Z",
    transform: "translate(87.431 101.892)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M119.536,136.353c-.233-.376-.563.353-.681-.021a4.428,4.428,0,0,0,.255,1.481,2.518,2.518,0,0,1,.427-1.46",
    transform: "translate(87.135 102.903)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M119.17,137.883a4.241,4.241,0,0,0-.172-.746,2.223,2.223,0,0,0,.172.746",
    transform: "translate(87.247 103.58)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M120.2,134.6a.893.893,0,0,0-.535.546l.476-.24c.019-.093.039-.2.06-.305",
    transform: "translate(87.747 101.662)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M120,134.767l-.016.009c-.067.33-.114.56-.135.658.019-.084.063-.284.151-.667",
    transform: "translate(87.893 101.79)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M119.981,134.554c-.005.028-.009.049-.016.077.047-.023.065-.039.016-.077",
    transform: "translate(87.977 101.629)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M120.5,132.7c.179.49.312,1.5.8.6-.249-.369-.525.144-.8-.6",
    transform: "translate(88.385 100.225)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M120.385,134.784l.2-.825c-.114,0-.3.13-.386-.116Z",
    transform: "translate(88.156 101.092)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M120.417,134.809c-.019-.142-.053-.286-.079-.43l-.075.305Z",
    transform: "translate(88.202 101.497)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M119.5,136.945a2.757,2.757,0,0,1-.026,1.223,6.314,6.314,0,0,0,.423-1.392c-.123-.091-.325-.341-.4.169",
    transform: "translate(87.609 103.2)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M119.731,135.822l.011.084c.044-.044.063-.081-.011-.084",
    transform: "translate(87.8 102.586)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M118.9,139.988l.095-.049-.067-.033Z",
    transform: "translate(87.175 105.67)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M119.811,137.022a.928.928,0,0,0-.019-.8,5.854,5.854,0,0,1-.074.865c.056.04.095.054.093-.065",
    transform: "translate(87.79 102.889)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M119.065,138.505a4.775,4.775,0,0,0,.365-.556c-.172.149-.46.467-.365.556",
    transform: "translate(87.283 104.193)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M119.692,135.951c0-.019-.009-.037-.011-.056-.111.1-.063.093.011.056",
    transform: "translate(87.713 102.642)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M119.659,135.97a2.142,2.142,0,0,0,.177.518,3.264,3.264,0,0,0-.04-.618.549.549,0,0,1-.137.1",
    transform: "translate(87.746 102.623)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M121.16,142.181c-.365-.174-.46-1.2.179-1.9-.067-.872-1.485-.66-2.382-.172.161.068.318.107.319.972.288-.223.992-1.66,1.151-.888-.1,1.127-.383.844-.732,1.309.6-.314.314,1.564,1.078,1.536l.021-1.025c.114.012.191.407.365.17",
    transform: "translate(87.216 105.502)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M119.53,139.207l.026-.346a3.01,3.01,0,0,1-.788,1.02c.037.59.147.741.265.813.176-.532.335-1.069.465-1.615Z",
    transform: "translate(87.073 104.882)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M119.547,138.387c.365.351.367,1.2.934.809.19-1-.2-.771-.253-1.4-.247,1.61-.135-.5-.63.588a5.452,5.452,0,0,1,.077-.876,7.362,7.362,0,0,1-.374.774l.035-.032v-.007l.005,0c.068-.058.105-.072.058,0a.115.115,0,0,1,0,.035.482.482,0,0,1,.144.107c-.19.437-.126.047-.144-.107a.32.32,0,0,0-.06-.032l-.005,0-.119,1.632a6.949,6.949,0,0,0,.33-1.5",
    transform: "translate(87.412 103.861)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M121.468,133.6a.118.118,0,0,1-.107.04c.04.112.07.158.107-.04",
    transform: "translate(89.031 100.907)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M121.716,134.431a.745.745,0,0,1-.111-.632c.172-.319.205.028.349.03-.084-.251-.205-.857-.507-.153l.044.125c-.23.641-.872,1.408-.916,1.285a2.838,2.838,0,0,0,1.141-.655",
    transform: "translate(88.438 100.717)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M120.42,136.054l-.021,1.387.486-.62-.228-.005c.219-.755-.083-.637-.237-.762",
    transform: "translate(88.305 102.762)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M118.931,140.129l-.395-.288.416.913Z",
    transform: "translate(86.898 105.622)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M118.681,141.044l-.365-.172.107.509Z",
    transform: "translate(86.731 106.401)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M85.216,160.545l-.032-.441a1.789,1.789,0,0,0,.032.441",
    transform: "translate(61.706 120.927)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M84.912,162.123l.184.1c-.088-.156-.158-.225-.184-.1",
    transform: "translate(61.502 122.403)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M106.386,161.6c-.665.161-1.525.211-1.162.474l.435.183a1.836,1.836,0,0,1,.727-.656",
    transform: "translate(76.778 122.054)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M92.636,172.035l.193.109c.123-.167.235-.316.328-.472a5.585,5.585,0,0,1-.521.363",
    transform: "translate(67.335 129.664)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M92.9,173.021a7.615,7.615,0,0,1-.9-.207,2.733,2.733,0,0,0,.9.207",
    transform: "translate(66.854 130.526)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M87.949,151.521l-.218-.625c-.3.707.04.483.218.625",
    transform: "translate(63.542 113.972)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M115.042,150.32a4.568,4.568,0,0,0-.869.907c.523-.37,1.1-.59.869-.907",
    transform: "translate(83.602 113.537)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M87.771,161.625c-.037-.247-.105-.363-.2-.372.032.255.09.405.2.372",
    transform: "translate(63.507 121.794)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M113.752,152.043c.083-.049.146-.111.221-.165a4.267,4.267,0,0,1,.52-1.041,1.448,1.448,0,0,0-.741,1.206",
    transform: "translate(83.284 113.927)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M109.665,125.808c.047,0,.1-.021.144-.021-.018-.058-.072-.032-.144.021",
    transform: "translate(80.197 94.982)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M119.771,123.909c-.146.077-.393.177-.627.274a2,2,0,0,0,.627-.274",
    transform: "translate(87.357 93.588)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M117.164,144.791c.116-.349-.023-.07,0,0",
    transform: "translate(85.86 109.231)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M118.435,144.093a.272.272,0,0,0,.151.214.35.35,0,0,1-.151-.214",
    transform: "translate(86.821 108.833)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M113.856,154.172l-.019.026c.133-.044.109-.037.019-.026",
    transform: "translate(83.349 116.44)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M117.515,144.465a4.025,4.025,0,0,0-.3.39,2.047,2.047,0,0,0,.3-.39",
    transform: "translate(85.902 109.114)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M117.263,144.6c.058-.114.1-.2.144-.29-.053-.068-.109-.047-.144.29",
    transform: "translate(85.936 108.976)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M117.062,145.219a2.971,2.971,0,0,1,.274-.532c-.056.056-.091.075-.1.053l-.177.479",
    transform: "translate(85.784 109.282)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M96.352,138.206a.715.715,0,0,1,.083-.042c.09-.427.011-.27-.083.042",
    transform: "translate(70.142 104.158)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M103.485,167.351c.011-.016.012-.03.021-.044l-.054.025Z",
    transform: "translate(75.505 126.367)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M103.095,168.775a1.246,1.246,0,0,1,.857-1.162l-1.158-.679Z",
    transform: "translate(75.007 126.085)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M87.785,182.34l-.669.839c-.263-1.338.214-2.122-.593-1.378,1.239.521-.969,3.816.353,4.3l-.437.572c.058-.181-.014-.228.046-.407-.95,1.1.737,1.157.2,2.715-.219.541-.474.906-.567.486l.107,1.329c-.091.363-.311.237-.219-.128-.077.653-.118,1.316-.176,1.973l-.039-.021a10.058,10.058,0,0,1,.555,1.3c-.242.477-.119-.263-.3-.153.079.374.14.741.239,1.113-.379.425-.679-.513-.541-1.266-1.452.92.226.921-.632,3.144-.06-.358-.111-.718-.144-1.074a1.734,1.734,0,0,0-.627,1.171,13.656,13.656,0,0,1-.351,1.632c.2-.351,1.2-2.491,1.527-1.257a1.847,1.847,0,0,0,.165,1.455c-.481.032-.351.679-.214,1.5l-.646.014c.283.893.609.774.988,1.253a1.728,1.728,0,0,1-.644,1.682c.339,1.689.474-1.331,1.1.562a5.863,5.863,0,0,0,2.119,3.544c.446.95-.432.082-.356.486q.5.229.974.42c.128.183-.026.226-.116.255.7.427.528-.37,1.471.325.365-.177.611.4,1.113,1.013a2.4,2.4,0,0,0,2.1,1.087c.291.276-.291.326-.267.592l1.216.039c.293-.016.5-.04.7-.067a5.27,5.27,0,0,0,1.527-.465,10.915,10.915,0,0,0,1.3.411c-.974-.463.251-1.015,1.118-1.639-.337-.193-.609-.363-.786-.439.483-.19.955-.326,1.411-.553.193.067.095.312-.1.628.093-.074.179-.146.244-.207.572.125.386.541.051.976a4.683,4.683,0,0,1-.623-.3c-.321.435-.656.913-.534,1.276a1.575,1.575,0,0,1,.521-.24c-.091.118-.147.221-.09.279s.223-.1.467-.3l.5.637.039-.3a21.325,21.325,0,0,0,2.247-.086c1.3-1.166,2.113-2.579,4.021-3.846-.277.723.269.825.52,1.4-.867-.319-1.543,1.043-2.78,1.374.628-.181.609.149.49.309.634-.46,1.234-.941,1.808-1.441.17.477.6.156,1.2.068-.837-.7,1.15-1.343,1.745-2.071.219.263.209.669-.778,1.139,1.424.053.757-1.778,2.061-1.843-.219.146-.365.176-.363.377.367-.572,1.745-1.18,1.611-.75l-.214.153c1.553-.829,4.323-3.079,3.983-3.911a4.915,4.915,0,0,1,.477,1.15c.233-1.39.411-2.779.556-4.153.265.737,2.192,1.4,1.36,2.644a2.905,2.905,0,0,0,1.346-1.19c-.284.107-1.223-.349-.978-.648a6.935,6.935,0,0,0,2.266-.488c-.418.165-.841-1-.33-1.415.04.195.809.8.709,1.051.161-.644.3-1.3.437-1.95-.158.428.6.748,1.094.721-.274-.039,1.055-.972,1.281-1.371l-.681.307c1.446-1.2.188-2.412,1.487-3.683.016.319.655,1.392,1.41.813-.116-.716-.734-3.284-.018-4.757l.449-.009.527-1.164a20.483,20.483,0,0,1-.212,5.34c.665-.333.418.123,1.108-.667.481-.065-.042.737-.239.978.6-.555,1.209-1.108,1.8-1.68-.577-.37.732-1.847.237-2.148l-1.222,2.447c-.574-.381-.409-2.41.779-3.625.484-.156.7,1.03.9,1.152a2.936,2.936,0,0,1,.944-1.548l-.195.79c.823-.569.309-1.773,1.536-2.256.286-.276,1.425-.381,1.151-.686a4.638,4.638,0,0,1-3.135-2.055,14.7,14.7,0,0,1,2.41-1.271c.874-.147.551,1.645,1.3,1.525-.132-.132-.09-.553-.06-.718.374-.237.351.484.828-.29-.458-.534,1.146-1.434-.207-.69.367-.823.683-.658,1.26-1.52-.549.005-.679-1.636-.334-2.452.112.142.414.114.551.095a39.492,39.492,0,0,0,2.752-3.488c.221-.042.82-.632.888-.181a1.878,1.878,0,0,1,.2-1.034c1.037-.558-.534,1.039.481.751-.305-.265.24-1.439.412-2.192-.655-.111-1,1.392-1.176,2.159-.732-.453-.786-1.982-.284-3.649.432-1.313.75-.267.751-.535,1.3-2.238-.309-2.593,1.152-4.227.818-.551,1,.409,1.422.4-.247,1.129-1.074,1.4-1.38,2.094l.655-.721a2.34,2.34,0,0,1-.548,1.424,7.02,7.02,0,0,0,1.476-2.306,20.838,20.838,0,0,1,1.673-3.31c-.028-.4.037-1.034-.279-.844l-.177.613c-.628.372-.1-1.316-.6-.655a5.822,5.822,0,0,1,.5-2.973l.655-.007c-.179-.035-.6.611-.53.988-.1-.553,1.383-1.452.8-2.22l-.676.648a6.6,6.6,0,0,1,.161-3c-.709.277,0,.253-.876.748,1.053-.335-.9,2.475.321,1.8-1.029.448-.758,1.123-1.739,1.808.2.042.477-.195.1.586a1.034,1.034,0,0,1,.105.242c-.014.023-.019.032-.033.051l.039-.037c.016.046.021.051.014-.014a.936.936,0,0,1,.432-.309c.328.583-.249,1.847-.2,2.373-.291.441-.132-.288-.442-.111l.061.785c-.444-.109-1.22.964-1-.253l-.439.992a3.973,3.973,0,0,0-1,1.8c-.318.407-.137,1.366-.251.813l-.523,1.639-.107-.039c-.746,1.487-1.071,3.379-2.749,4.587a4.673,4.673,0,0,1-1.025,1.84l-.428-.067c-.305.686-1.575,1.594-1.434,2.08-1.308.037-2.278,2.747-3.226,3.655l.374.349a15.019,15.019,0,0,0-1.52,2.436l.395.232c-.312.985-1.811,1.7-2.756,2.877-.065-.191.218-.453.472-.592-1.929.706-1.961,3.356-3.626,4.058a1.193,1.193,0,0,1-.686.711.278.278,0,0,0,.053-.09,1.194,1.194,0,0,0-.119.116c-.181.075-.374.147-.565.24a2,2,0,0,0,.5-.174,6.5,6.5,0,0,0-.744,1.03l-.486-.2-.065.086c-.451.195-.1.419.334.5a2.538,2.538,0,0,0-.233.642c-.816-.295-.685,1.062-1.638.807.056.513-1.49,1.831-1.113,2.622-.086-.072-.225-.018-.04-.193a2.37,2.37,0,0,0-1.1,1.048l-.574-.319-.326,1.371c-.771.169-1.127.176-.909-.625-.811,1.606-.85,1.067-1.511,2.5l-.191-.356c-.388.316-.706,1.238-1.148,1.155-.681.026-1.811.823-3.158,1.683a15.1,15.1,0,0,1-4.334,2.057c1.006.82-1.392.088-1.109.948-.262-.183-.671-.169-.363-.574-1.188.807-2.064.358-2.726,1.371-.228-.225.16-.465-.021-.585-.084.084-.339.342-.518.219s.125-.276.288-.446c-1.26.414-1.213,1.229-1.157,2.047-.79-.209-1.1-.149-1.567.449-.281-.235-.693-.467.144-.655-.244.026-.974-.025-1.62-.047s-1.223-.051-1.3.256a.477.477,0,0,0-.374-.135,1.125,1.125,0,0,0-.379,0,4.732,4.732,0,0,1-.979-.4c-.255-.1-.481-.239-.92-.462l.183.228c-.757.465-.841-.305-1.485-.8l.072-.04c-.247-.428-.388-.672-.488-.843a1,1,0,0,0-.281-.283c-.168-.116-.334-.288-.5-1.259l-.386.314c-.491.151-.581-.335-.569-.95a8.482,8.482,0,0,0,.014-.969,1.58,1.58,0,0,0-.221-.893l-.16.476c-.26-.267-.03-.8.311-1.308a5.258,5.258,0,0,0,.769-1.3c.075-.142.167.191.253.363.444-1.638-.671-.118-.909-1.331.328-.244.879.228.9-.577.116-.2-.163-.778-.384-1.476a2.49,2.49,0,0,1,.021-2.062c-.286.23-.574.472-.711-.139-.018-.939,1.257-2.319.588-3.261.091-.1.167-.135.232-.128-.107-.728.088-2.314-.256-2.835.885-.139.943-1.245,1-2.292s.1-2.024.837-1.792c.2-.7.367-1.415.586-2.113l.13.1a3.118,3.118,0,0,0,.191-2.475c.211-.27.263,0,.33.056a5.409,5.409,0,0,0,.972-3.92l.53.026c-.086-.555,1.871-2.429,2.227-4.488a.364.364,0,0,1,.105.3c.435-2.338,3.662-4.22,2.457-5.807l.341-1.538c-1.074,1.648-.548-.637-1.2-.077.284-.732,1.448-1.485,1.069-.607l-.153.086c.644.76,1.5-1.948,2.036-1.578a46.542,46.542,0,0,1,3.168-4.716q.848-1.116,1.682-2.21c.579-.693,1.143-1.383,1.673-2.085l-.834-.107.772-.974c.328-.158.714,0,.169.688.606-.118.6-1.4.49-1.52,1.259-1.2.272,1.072.6.656l.379-.607-.162.075c.119-.646-.072-.872.649-1.655.553-.411.57.035.765-.146.039.035.116-.016.281-.29l1.065-1.127-.841.079c.242-.713.99-1.09.03-.988.7-.086,1.8-1.043,2.81-2.029a11.919,11.919,0,0,1,2.278-2.091,6.747,6.747,0,0,1,2.124-2.326c-.3.1-.86-.277-.023-.9.293.651.723.428,1.283.133a2.917,2.917,0,0,1,1.826-.6c-.981-.056,2.213-1.9.748-1.926.748-.437.341.374,1.043.235,1.392-1.573,3.863-2.308,5.933-3.726-.058-.172-.562-.181-.235-.69l1.589.06c.376-.337-.119-1.116.983-1.032-.186-.067-.467-.167-.2-.379a58.3,58.3,0,0,0,6.784-3.349,17.989,17.989,0,0,1,7.263-2.308c-.753-.074-.346-.269.133-.469-.344.046-.147-.411-.295-.611.734-.058,1.474-.067,2.2-.1.14-.771,2.108-.764,2.122-1.427l-.6.311c.621-1-1.7-1.194-1.9-2.141-.674,1.136-2.993-.279-4.125,1.488-.42-.047.181-.4-.086-.539-.251.535-.693.8-1.641,1.011l.06-.137a26.575,26.575,0,0,1-3.088,1.187c-.955.319-1.994.563-3.4,1.144l.413.327a2.752,2.752,0,0,1-1.123.195c-.337.981,1.646-.786,1.4.233-.6-.242-1.62.272-2.619.755-.992.5-1.938,1.006-2.464.664-.879.483.525.337-.351.818l-.379-.13-.03.456a1.054,1.054,0,0,1-1.227-.095,3.491,3.491,0,0,0,.5-.391c-.927.111-2,1.359-2.314,1.406l.92-.349c-2.206,1.632-5.21,3.191-6.988,5.247l.293.06c-1.346,1.557-1.429.785-3.068,2.285l.032-.091a4.04,4.04,0,0,1-1.062,1.288c.255-.569-1.125.3-.758-.4-1.369,1.778-.6.981-1.129,2.547l-.5-.058a2.577,2.577,0,0,1-.778,1.557c.423-.867-.89.083-.46-.939-2.231,1.062-1.866,3.009-3.482,2.933,0,1.46,1.84-1.022,1.578-.448.593-.111-.072,1.15-.649,1.59-.5.534-1.792.049-3.017,1.485.126-.137.075-.2.2-.337-.663.363-.632,1.269-1.527,1.648.165.753-.707.874-.17,1.471a14.651,14.651,0,0,1,.92-1.457c-.511.848-.246,2.192-1.566,3.175a2.7,2.7,0,0,1,.158-1.036c-.467.235-.411.816-.892,1.064-.56-.583,1.1-1.78,1.248-3-.569.2-.728,1.954-1.1,1,.423,1.271-1.225,1.422-1.3,2.937l-.341-.341a2.821,2.821,0,0,1-.348.964c-.047-.3-.077-.593-.116-.893-.186,1.132-1.487,1.381-1.8,2.356,1.12-1.718.735-.068,1.5-.6-.853,2.443-1.843.525-3.175,3.045.149-.362,1.015-1.066.879-.441a4.8,4.8,0,0,1-1.287,1.062c-.89,1.659.569.009.4.844-.825.246-.279.908-.534,1.7l-.42-.242c-1.339,1.69.588,1-.692,2.464l-.181-1.036-.346.955-.381-.451a3.84,3.84,0,0,1-1.081,2.261c.418-.056.709.542.284,1.381-.555.434-.239-.534-.8.681-.128-.405-.309-.879.358-1.187-.112-.126-.13-.407-.239-.535a5,5,0,0,0-1.1,1.95,1.432,1.432,0,0,1,.342-.416l-.277,2.04c-.3.193-.323-.088-.342-.369a11.354,11.354,0,0,1-.27,1.257c-.29-.307-.674-.455-.47-1.274-.153.618-.284,1.246-.42,1.868-.207.039-.836.665-.864.384-.651.848-.37,2.622-1.178,3.765a.92.92,0,0,1-.007.546c-.583,1.148-1.457,2.047-1.488,3.674l-.964.577c-.262,1.185,1.237-.8.811,1.162-.239,1.409-.739.3-1.085.713.1.786.43,2.164-.495,3.246a5.31,5.31,0,0,1,.263-1.146M85.526,197.2c-.1-.295-.416-.909-.119-1.118.544.356.283.606.119,1.118m15.961,12.979c-.165.219-.52.223-.932.114a2.39,2.39,0,0,1,.932-.114M141.014,165.9a.224.224,0,0,0,.011.037c-.4.476-.255.311-.011-.037m.678-1.067c-.012-.144-.077-.161-.16-.14.077.13-.023.393-.179.674.151-.032.293-.146.339-.534m-30.913-15.557-.256.1c.256-.507.251-.309.256-.1",
    transform: "translate(60.805 91.999)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M92.631,172.915a.448.448,0,0,1-.16-.246c-.109.1-.105.19.16.246",
    transform: "translate(67.16 130.417)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M87.845,151.367l.023-.039a.237.237,0,0,0-.063-.077Z",
    transform: "translate(63.687 114.24)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M113.2,157.2a1.137,1.137,0,0,1-.516.26c.084.083.242.051.516-.26",
    transform: "translate(82.479 118.731)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M117.828,142.631l-.14.793a1.291,1.291,0,0,1,.386-.628c-.114-.019-.319.072-.246-.165",
    transform: "translate(86.257 107.729)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M120.618,139.409c-.032-.132.049-.251.018-.383l-.228-.019c-.1.506,0,.9.211.4",
    transform: "translate(88.283 104.992)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M118.779,142.96c.4.061.465-.456.532-1.034a.478.478,0,0,1-.026.1c-.5-.328-.474.312-.506.936",
    transform: "translate(87.081 107.197)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M119.1,142.084a2.347,2.347,0,0,1,.132-.511c-.2-.13-.1.191-.132.511",
    transform: "translate(87.32 106.908)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M117.238,145.633c.2-.205-.42-.349-.207-.425-.365-.47-.1,1.866.207.425",
    transform: "translate(85.626 109.628)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M119.831,142.5l-.548.044.281.43Z",
    transform: "translate(87.462 107.627)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M118.566,145.364l.432-.823c-.084-.016-.093-.144-.081-.291-.2.53-.5,1.081-.351,1.115",
    transform: "translate(86.891 108.951)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M118.748,144.562a1.742,1.742,0,0,0,.163-.728,3.871,3.871,0,0,0-.163.728",
    transform: "translate(87.058 108.638)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M119.63,143.2l-.19.226-.248.606Z",
    transform: "translate(87.394 108.162)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M116.3,149.976a7.844,7.844,0,0,1-.367.944c.095.172.334-.009.467-.363.005-.274.116-.637-.1-.581",
    transform: "translate(84.929 113.273)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M117.865,148.782c-.219.2-.328.167-.548.23l.544.309Z",
    transform: "translate(85.977 112.375)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M116.936,150.463c.118.177-.267,1.562.316.39-.1-.177.239-1.162-.316-.39",
    transform: "translate(85.676 113.424)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M111.949,157.656l.153-.207-.83-.6Z",
    transform: "translate(81.411 118.468)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M107.788,164.625c1.03-.711-.249-.651.739-1.234.025-.374-.806.477-.753.119-.325.711-.707.881.014,1.115",
    transform: "translate(78.469 123.336)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M107.6,163.58a3.166,3.166,0,0,0,.149-.379,1.368,1.368,0,0,0-.149.379",
    transform: "translate(78.64 123.266)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M121.078,123.777l.769-.03-.56-.177Z",
    transform: "translate(88.818 93.332)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M121.72,123.077l.353.574.239-.685c-.139.068-.421.211-.592.111",
    transform: "translate(89.303 92.876)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M84.172,166.452l.163.054c.151-.154.149-.358.156-.765-.105.235-.228.467-.319.711",
    transform: "translate(60.943 125.184)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M84.982,159.733l-.053.183.651-.225Z",
    transform: "translate(61.515 120.615)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M86.091,154.559c-.144.346-.16.806-.3,1.153.16-.807,1.032-1.009.3-1.153",
    transform: "translate(62.162 116.738)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M105.364,142.184c-.367.621.379-.211-.2.435a.444.444,0,0,1,.2-.435",
    transform: "translate(76.797 107.392)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M114.7,162.749c-.809,2.242-2.975,4.464-4.048,6.793-.14.262-.221-.237-.523.367A40.266,40.266,0,0,1,105,177.7l.019-.2c-.356.451-.47,1.2-.821,1.69-.054-.026.03-.207-.112-.13.07.221-.5.974-.521,1.262-.184.169-.291.074-.52.3l-.007.4c-.084,1.071-1.236,1.982-1.689,3.24-.009-.079.026-.209-.067-.142-.821,1.961-2.189,4.211-3.235,6.321-.018-.116-.089-.256-.226-.174.13.205-.176.867-.439,1.439-.33.146-.341,1.044-.792,1.641l-.014-.079c-.053.59-.495.657-.455,1.176l-.312.228c.167.353-.5.63-.563,1.1l.063.016c-.123.414-.358.544-.484.922l-.047.018c-.328.867-.7,1.283-.477,1.364-.311.212.295-.848-.172-.506-.353.958-.753,1.994-1.037,2.863a13.3,13.3,0,0,0-.384,1.339,3.941,3.941,0,0,0-.1.686.746.746,0,0,0,.2.639.72.72,0,0,0,.635-.044,3.524,3.524,0,0,0,.57-.327,10.228,10.228,0,0,0,1.027-.818c.249-.091.427-.214.523-.181a7.029,7.029,0,0,0,.913-1.129c-.068.076.228-.054.348-.163.455-.341.23-.621.725-.993-.118.221-.118.335,0,.337a9.176,9.176,0,0,1,1.076-1.506c-.033.1-.116.225-.044.258.29-.644.851-.892,1.136-1.429l-.04.258c.751-.611-.035-.4.576-.962-.095.179-.009.161.011.225a17.4,17.4,0,0,1,1.587-2.294.048.048,0,0,0,.023.063,25.731,25.731,0,0,0,1.6-2.078c.258-.223.2.3.709-.425-.237-.149.841-1.248.269-1.036a14.094,14.094,0,0,0,1.553-1.9c-.125.332.495-.083.13.428l.425-.272c.047.126-.33.363-.125.332a14.527,14.527,0,0,1,.864-1.246,6.942,6.942,0,0,1,.828-1.959c-.179.42.4-.016.255.255l.365-1.373c.177-.26.218.077.43-.33-.074-.025.009-.211.044-.356.1-.075.723-1.087,1.025-1.032.17-.047-.258.444.028.225.342-.469.283-.544.623-1.013l.037.012c.26-.284.574-.978.2-.732-.165.209.193.016-.1.286a3.948,3.948,0,0,1,.732-1.35c-.081.186-.007.209.009.319a15.549,15.549,0,0,1,1.15-2.219c-.1-.088,0,.4-.128.463.8-.8,1.137-2.015,1.892-2.614-.07.137-.2-.042-.163-.03.325-.427.465-.3.611-.621.111.037.226-.379.407-.692.04-.2.1-.046-.074.218a16.564,16.564,0,0,1,2.027-3.058,2.182,2.182,0,0,1,.346-.951l.081.184c.225-.14.5-.741.644-.693.154-.586-1.106,1.9-.8,1.176.232-.081.388-1.037.486-.767.3-.442.435-.979.86-1.308-.107.107-.051.493.184.132.407-.644.056-.225.358-.765l.163-.36c-.125-.116.4-.548.088-.42.167,0,.556-.96.741-.739l.121.212a2.447,2.447,0,0,0,.179-.844c.042-.023.126-.07.147-.037-.247-.232.465-.634.469-1.1.484-.506.994-1.445,1.343-1.6a4.959,4.959,0,0,1,.767-1.431c-.04.118-.123.262-.081.328.291-.26.269-.388.414-.706,0,.091.583-.525.914-.811.207-.493-.044-.442-.107-.548.548-.216.628-1.36,1.2-1.706-.06.179-.276.735.028.413.537-.228.316-.951.867-1.52l-.335.014c.33-.2.477-1.048.672-.832.056-.272.569-.723.295-.793.865-.96,1.5-2.708,2.324-3.124.058-.179.335-.544.169-.535-.286.181-.13.416-.277.46.079-.144.035-.212.012-.246.26-.307.439-.562.434-.128.606-.665.077-1.015.741-1.924.068.1.147.049.3-.242l.154-.632c.405-.6.427-.226.6-.146a2.609,2.609,0,0,0,.388-.976l.444-.286c-.321.209.061-.333.111-.516l-.049.181c.1-.021.283-.435.376-.644-.126-.012-.395.362-.549.562.028-.212.2-.47.244-.748.116.169.427-.483.6-.739.211-.288.054-.428.111-.514.088.039.3-.493.279-.188-.033.119-.216.193-.242.407.177-.167.309-.061.442-.541.1-.36-.362-.1.083-.639a1.412,1.412,0,0,0-.016.4l.405-.514-.133-.105c.081-.054.063,0,.1-.019-.056-.253.432-.89.332-1.115a8.692,8.692,0,0,1,.6-.807l-.016.06a2.3,2.3,0,0,0,.514-1.094l.025.033a2.987,2.987,0,0,0,.367-.893c.36-.4.641.147.73-.465.248-.474.125-.883-.07-.744a20.766,20.766,0,0,1,1.471-2.54c0-.153-.074-.1.023-.367a22.218,22.218,0,0,1,1.994-3.57c-.121.395.137.1.226.137.019-.369.323-.291.147-.516-.149-.037-.2-.1-.435.225a10.08,10.08,0,0,1,1.213-2.277c-.165.177-.126-.005-.086-.19.188.161.5-.377.628-.834l-.1-.125.27-.205c.039-.183-.188-.314.14-.669a.266.266,0,0,0,.2-.054,3.943,3.943,0,0,1,.555-1.61l.379-.295c.075-.212.119-.609-.105-.279a6.027,6.027,0,0,1,1.048-1.448,16.709,16.709,0,0,1,1.116-3.544l2.031,1.374-1.29,1.325-.042-.114c-.407.276-.033.312-.319.5.03-.186-.418.109-.251-.255-.558.42-.472.776-.742,1.136.06.149.179-.325.255-.137-.016.09-.734.618-.644.848-.181.067-.209-.14-.209-.27l-.209.381c-.539.2.463-1.173-.135-.992l-.24.311c-.421.116.511-.934-.211-.27-.211.386-.223.867.105.656-.555.688.1.651-.548,1.338-.27.1.488-.579.232-.567-.432.209-.53.728-.843.979.358-.27.27.154.109.391-.4.286.056-.37-.42.118.018.169-.333.7.1.355.046.374-.535.47-.616.9-.3.032.119-.835-.455-.344.225.042-.418.867.061.764-.239.183-.372.1-.319-.137-.369.235-.412,1-.792.843l.053.239c-.137.054-.3.163-.52.255-.246.277-.581,1.074-.785.851-.054.111-.62.735-.249.628.441-.312.283-.555.686-.59-.416.128-.476.59-.618.867l-.119-.039c-.084.165-.377.462-.356.628.04-.147-.067-.146-.183-.054l.011.258c-.409.616-.348-.072-.772.506l.249-.5c-.056.109-.339.186-.52.483.037.205.021.521.044.69-.209.351-.256.018-.388.426l.19-.521c.011-.093-.43.093-.776.506-.181.3-.349.853.07.5-.174.207-.493.43-.444.191-.351.5.183.051-.079.52-.219.1-.767.513-1.146.723l.147-.6-.237.279c.137-.5-.281.079-.284-.272a2.232,2.232,0,0,0-.432.676c.75-.33-.142.948.251,1-.57.827-1.029-.037-1.285,1.106.176-.079.06.465.384-.086-.421.46-.009.541-.577,1.022.237-.507-.63.24-.288-.495.051.111.341-.286.393-.4-.262.118-.226-.255-.628.242-.221.321-.553.741-.37.79.16.107.36-.476.353-.16-.437.644-.744.562-.685,1.023.288-.4.518-.369.614-.279l-.3.491-.03-.165c-.644.651.009.351-.572,1.018l-.451.169c-.042-.3.878-.944.506-1.041-.374.437-.351.7-.758,1.067.051-.112.146-.248.195-.36-.135.153-.627.025-.923.837-.179.4.03.167.125.256-.541.748-.606,1.048-.958,1.525-.126-.253-.671.809-.47.133a3.363,3.363,0,0,0,1.134-1.61c-.448.075.483-.542.365-.89-.465.577-.678.363-.906.337a1.582,1.582,0,0,0-.249.476c.091.183.255-.03.414.075a5.362,5.362,0,0,0-1.106,1.775c-.24.163-.333-.021-.146-.288a27.6,27.6,0,0,1-1.831,2.34c.607-.3-.577.871-.128.7.358-.356.79-.569.73-.267-.205.235-.1-.088-.23-.023-.111.414-.586.33-.618.8.469-.771-.186-.36-.272-.634-.29.6-.118-.123-.507.386a19.45,19.45,0,0,1-1.062,1.9,13.129,13.129,0,0,0-1.833,2.487c-.342.272-.391-.116-.7.23-.307.439.465-.156-.1.42l0-.093c-.09.23-1,1.079-.823,1.494l-.091-.369a.984.984,0,0,0-.181.374c-.079-.049-.251.042-.16-.191-.449.284-.576.858-.879,1.3l.339-.181c-.425.82-.9,1.234-1.355,1.992l-.123-.116-.216.488c-.06-.2-.421.14-.467.448l.441-1.36c.3-.256-.07.458.2.355a1.51,1.51,0,0,0,.6-.985,1.3,1.3,0,0,0-.262.514c-.249-.047.028-.434.035-.716-.086.14-.276.291-.235.363a3.486,3.486,0,0,1,.562-1.055c-.137.349.233-.079.207.072-.142-.153.107-.606.541-1.113.469-.249.6-1.1,1.106-1.692a3.168,3.168,0,0,1-.316,1.225c.367-.332.309-.441.676-.772a1.9,1.9,0,0,1,.207-1.123l.144.061c.269-.511.088-.642.556-1.2.8-.958,1.569-1.989,2.152-2.74l.142.061c.053-.623.976-1.474,1.292-2.129.855-.874,1.487-2.184,2.085-2.5a58.762,58.762,0,0,1,3.756-4.975l-.063.43c.125-.412.262-.119.483-.442-.42.233.161-.565.23-.865a9.933,9.933,0,0,0,1.875-2.517l.139.072a8.959,8.959,0,0,1,1.982-2.313,1.133,1.133,0,0,0,.569-.374,7.052,7.052,0,0,1,.883-1.6,17.719,17.719,0,0,1,1.659-1.648c1.341-2.036,3.165-3.712,4.731-5.685l.256-.007a18.044,18.044,0,0,1,2.066-2.426l4.055-4.107-2.3,5.29c-.634,1.457-1.348,2.821-1.764,3.986l-.193-.312c-.363.548-.56,1.376-.293,1.32-.36.553-.57,1.534-.978,1.8-.341.576-.225.8-.435,1.313a19.826,19.826,0,0,0-1.408,2.754l.158-.27c0-.153-.109-.223-.269.047-.137.456-.857,1.5-.318,1.252-.79,1.106-1.288,2.866-2.145,3.9.14-.053,0,.249,0,.405a22.989,22.989,0,0,0-1.618,2.947c-.133.142-.007-.344-.244.074-.1.269.112.068-.007.4-.767,1.761-2.034,3.3-2.865,4.825-1.362,2.78-3.082,5.513-4.609,8.05l-.046-.068c-.284.992-1.452,1.836-1.524,2.726-.186.16-.509.737-.535.514-.256.774-1.345,1.764-1.747,2.865a.762.762,0,0,0,.121-.263c-.758.881-1.144,1.845-1.936,2.78.042-.119.146-.319.105-.39-.376.312-.356,1.1-.793,1.118-.146.226.042.26.125.116-1.587,2.141-3.009,4.6-4.518,6.925-1.308,1.506-.56-.242-1.237,1.192-.13.065.058.153-.014.13-.267.551-.865.542-.955.994.277-.016-.061.3.04.384-.814.909-1.116.993-1.534,1.869l-.053-.125c-.386,1.1-1.283,2.057-1.534,3.044-3.572,5.055-6.962,9.935-10.739,14.68-1.582,1.9-3.147,3.793-4.81,5.64q-.624.7-1.276,1.376l-.663.678-.351.346c-.221.214-.439.421-.662.62a9.19,9.19,0,0,1-2.626,1.833,2.5,2.5,0,0,1-1.067.176,2.195,2.195,0,0,1-1-.335,2.088,2.088,0,0,1-.837-1.517,5.952,5.952,0,0,1,.4-2.47c.274-.634.521-1.094.707-1.473l.369-.7c.179-.369.318-.772.6-1.52.018.079-.014.174.072.1-.193-.177.453-1.018.307-1.255,1.037-2.024,1.952-3.888,3.068-5.919-.154.333-.065.592.13.2l.082-.474.1-.032c.111-.277.163-.621-.056-.39,2.652-5.19,6.038-9.81,9-14.643.8-1.085,1.752-2.752,2.5-4.011a114.7,114.7,0,0,0,7.263-10.355,3.737,3.737,0,0,1-.681,2.422",
    transform: "translate(65.963 89.264)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M105.546,141.86c.19-.058.53-.434.439-.009-.123-.026-.377.114-.439.009",
    transform: "translate(77.086 106.989)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M110.612,136.05c-.019-.035.156-.121.2-.142-.093.137-.1.321-.235.388.093-.139.032-.154.037-.246",
    transform: "translate(80.885 102.651)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M112.062,134.467c.056.109-.321.743-.572,1.094Z",
    transform: "translate(81.576 101.563)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M113.152,133.231c.244-.158.237-.067.005.223-.063-.016-.011-.13-.005-.223",
    transform: "translate(82.812 100.571)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M113.109,133.154a1.019,1.019,0,0,1,.423-.334c-.079-.051-.333.518-.423.334",
    transform: "translate(82.799 100.317)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M115.733,130.284c.1-.133.26-.469.453-.509-.177.079-.411.711-.453.509",
    transform: "translate(84.781 98.019)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M116.837,128.7a.606.606,0,0,0,.17-.205c.163-.112.093.093,0,.223Z",
    transform: "translate(85.614 97.031)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M111.059,141.743l.142-.323.063.1Z",
    transform: "translate(81.25 106.815)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M102.884,153.66c-.149.323-.226.135-.274.172.177-.26.042.174.274-.172",
    transform: "translate(74.869 116.059)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M98.243,160.175l.063-.084.154.168Z",
    transform: "translate(71.571 120.917)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M92.976,125.628a14.816,14.816,0,1,1,14.816,14.816,14.816,14.816,0,0,1-14.816-14.816",
    transform: "translate(105.419 83.696)",
    fill: "#082d74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M140.43,210.809c0,16-5.354,28.968-11.957,28.968s-11.959-12.97-11.959-28.968,5.354-28.968,11.959-28.968,11.957,12.97,11.957,28.968",
    transform: "translate(85.371 137.345)",
    fill: "#fffdee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M90.463,195.726c-5.721,8.761-12.842,14.241-15.9,12.241s-.908-10.723,4.815-19.484,12.84-14.241,15.9-12.24.906,10.721-4.815,19.482",
    transform: "translate(52.63 132.806)",
    fill: "#fffdee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M169.069,194.223c5.721,8.761,12.842,14.241,15.9,12.241s.908-10.723-4.815-19.484-12.84-14.241-15.9-12.24-.906,10.721,4.815,19.482",
    transform: "translate(120.377 131.671)",
    fill: "#fffdee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M206.791,105.783c10.17-2.459,17.716-7.335,16.856-10.89s-9.8-4.443-19.97-1.983-17.716,7.335-16.856,10.892,9.8,4.441,19.97,1.982",
    transform: "translate(138.423 69.124)",
    fill: "#fffdee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M57.338,102.91c-10.07-2.833-17.434-7.983-16.445-11.5s9.96-4.079,20.03-1.246,17.437,7.981,16.445,11.5-9.958,4.079-20.03,1.246",
    transform: "translate(28.186 66.733)",
    fill: "#fffdee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M118.033,50.918c0-10.463,2.965-18.945,6.623-18.945s6.621,8.482,6.621,18.945-2.965,18.945-6.621,18.945-6.623-8.482-6.623-18.945",
    transform: "translate(86.518 24.149)",
    fill: "#fffdee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeashell);
export default __webpack_public_path__ + "static/media/seashell.fa8386f8935c596c66f9306d874c4256.svg";
export { ForwardRef as ReactComponent };